import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountPlatformTimestamp: { input: any; output: any; }
  Any: { input: any; output: any; }
  Bytes: { input: any; output: any; }
  Date: { input: string; output: string; }
  DateTime: { input: string; output: string; }
  DateTimeRFC3339: { input: any; output: any; }
  FixedLineDateTimeRFC3339: { input: any; output: any; }
  MobileBigInt: { input: any; output: any; }
  Time: { input: string; output: string; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AiBillSummaryRequest = {
  currentInvoiceId: Scalars['String']['input'];
  previousInvoiceId: Scalars['String']['input'];
};

export type Account = {
  __typename?: 'Account';
  broadbandServices?: Maybe<Array<BroadbandService>>;
  cashback?: Maybe<CbcAccount>;
  communicationPreferences?: Maybe<Array<Maybe<PreferenceSubmission>>>;
  contactDetails?: Maybe<AccountPlatformContactDetails>;
  debtPaymentPlanDetails?: Maybe<DebtDetailsResponse>;
  debtPaymentPlanEligibility?: Maybe<EligibilityForDebtPaymentPlanResponse>;
  debtPaymentPlanSummary?: Maybe<DebtPaymentPlanSummaryResponse>;
  details?: Maybe<AccountDetails>;
  directDebitBankDetails?: Maybe<DirectDebitBankDetails>;
  /** Exclusive energy fields */
  energy?: Maybe<AccountEnergy>;
  id: Scalars['String']['output'];
  insights?: Maybe<Array<Insight>>;
  label: Scalars['String']['output'];
  marketingConsents?: Maybe<Consent>;
  number: Scalars['String']['output'];
  overdueBalance?: Maybe<Amount>;
  paymentMethods?: Maybe<Array<Maybe<PaymentMethodDetailsV2>>>;
  signUpDate?: Maybe<Scalars['Date']['output']>;
  smartTips?: Maybe<Array<SmartTip>>;
  tickets?: Maybe<TicketConnection>;
};


export type AccountBroadbandServicesArgs = {
  serviceId?: InputMaybe<Scalars['String']['input']>;
};


export type AccountTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};

export type AccountBills = {
  __typename?: 'AccountBills';
  accountId: Scalars['String']['output'];
  billsList?: Maybe<Array<Maybe<CustomerBilling__Bill>>>;
};

export type AccountDetails = BusinessDetails | LegacyBusinessDetails | ResidentialDetails;

export type AccountEmailPendingVerificationInfo = {
  __typename?: 'AccountEmailPendingVerificationInfo';
  emailLinkExpired: Scalars['Boolean']['output'];
  pendingEmail: Scalars['String']['output'];
};

export type AccountEnergy = {
  __typename?: 'AccountEnergy';
  budgetPlan?: Maybe<EnergyBudgetPlan>;
  budgetPlans: Array<EnergyBudgetPlan>;
  migrationStatus?: Maybe<EnergyAccountMigrationStatus>;
  /**
   * Fetch all properties associated with the account.
   *
   * Only properties that exist within Gentrack will be returned.
   */
  properties?: Maybe<Array<EnergyAccountProperty>>;
  /** Fetch a specific property for this account by its property ID */
  property?: Maybe<EnergyAccountProperty>;
  service?: Maybe<EnergyService>;
  services: Array<EnergyService>;
  smartBooking?: Maybe<EnergySmartBooking>;
};


export type AccountEnergyBudgetPlanArgs = {
  id: Scalars['String']['input'];
};


export type AccountEnergyBudgetPlansArgs = {
  input?: InputMaybe<BudgetPlansInput>;
};


export type AccountEnergyPropertyArgs = {
  id: Scalars['String']['input'];
};


export type AccountEnergyServiceArgs = {
  id: Scalars['String']['input'];
};


export type AccountEnergyServicesArgs = {
  input?: InputMaybe<AccountEnergyServicesInput>;
};

export type AccountEnergyServicesInput = {
  /** This is how much time to include previously ended services in, in seconds. Defaults to 30 days (2592000 seconds) */
  includeEndedWithin?: InputMaybe<Scalars['Int']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  /** Filter services by state. If not provided, defaults to [CREATED, ENDED, HELD, STARTED] */
  states?: InputMaybe<Array<EnergyServiceState>>;
};

export enum AccountPlatformAddressPurpose {
  Correspondence = 'CORRESPONDENCE',
  Supply = 'SUPPLY'
}

export type AccountPlatformChange = {
  __typename?: 'AccountPlatformChange';
  app?: Maybe<Scalars['String']['output']>;
  author?: Maybe<Scalars['String']['output']>;
  field: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['AccountPlatformTimestamp']['output']>;
};

export type AccountPlatformChangeAddressInput = {
  address?: InputMaybe<AccountPlatformPafAddressInput>;
  purpose: AccountPlatformAddressPurpose;
  reason: Scalars['String']['input'];
  sendConfirmation: Scalars['Boolean']['input'];
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type AccountPlatformChangeContactMethodInput = {
  method: AccountPlatformContactMethod;
  purpose: AccountPlatformAddressPurpose;
  value: Scalars['String']['input'];
};

export type AccountPlatformChangeNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  purpose: AccountPlatformAddressPurpose;
  title: Scalars['String']['input'];
};

export type AccountPlatformContactDetails = {
  __typename?: 'AccountPlatformContactDetails';
  displayAddress: Scalars['String']['output'];
  email: Scalars['String']['output'];
  landline: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  name?: Maybe<AccountPlatformName>;
  pafAddress?: Maybe<AccountPlatformPafAddress>;
  pendingEmail?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
};

export enum AccountPlatformContactMethod {
  Email = 'EMAIL',
  Landline = 'LANDLINE',
  Mobile = 'MOBILE'
}

export type AccountPlatformCustomerAccount = {
  __typename?: 'AccountPlatformCustomerAccount';
  accountId: Scalars['String']['output'];
  accountLabel: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  correspondenceDetails?: Maybe<AccountPlatformContactDetails>;
  occupancyType?: Maybe<AccountPlatformOccupancyType>;
  supplyDetails?: Maybe<AccountPlatformContactDetails>;
};

export type AccountPlatformDateInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type AccountPlatformMutation = {
  __typename?: 'AccountPlatformMutation';
  changeAddress: AccountPlatformPafAddress;
  changeContactMethod: Scalars['Boolean']['output'];
  changeDateOfBirth1: Scalars['Boolean']['output'];
  /** @deprecated No longer supported */
  changeDateOfBirth2: Scalars['Boolean']['output'];
  changeEmailBypassVerification: ChangeEmailResponse;
  changeLabel: Scalars['Boolean']['output'];
  changeLandline?: Maybe<Scalars['String']['output']>;
  changeMobile: Scalars['Boolean']['output'];
  changeName: Scalars['Boolean']['output'];
  clearFraud: Scalars['Boolean']['output'];
  markAsDeceased: Scalars['Boolean']['output'];
  markAsFraud: Scalars['Boolean']['output'];
  requestEmailChange?: Maybe<Scalars['String']['output']>;
  requestEmailChangeForCustomer?: Maybe<Scalars['String']['output']>;
};


export type AccountPlatformMutationChangeAddressArgs = {
  accountId: Scalars['String']['input'];
  input: AccountPlatformChangeAddressInput;
};


export type AccountPlatformMutationChangeContactMethodArgs = {
  accountId: Scalars['String']['input'];
  input: AccountPlatformChangeContactMethodInput;
};


export type AccountPlatformMutationChangeDateOfBirth1Args = {
  accountId: Scalars['String']['input'];
  date: AccountPlatformDateInput;
};


export type AccountPlatformMutationChangeDateOfBirth2Args = {
  accountId: Scalars['String']['input'];
  date: AccountPlatformDateInput;
};


export type AccountPlatformMutationChangeEmailBypassVerificationArgs = {
  accountId: Scalars['String']['input'];
  input: Scalars['String']['input'];
};


export type AccountPlatformMutationChangeLabelArgs = {
  accountId: Scalars['String']['input'];
  label: Scalars['String']['input'];
};


export type AccountPlatformMutationChangeLandlineArgs = {
  landline: Scalars['String']['input'];
};


export type AccountPlatformMutationChangeMobileArgs = {
  accountId: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};


export type AccountPlatformMutationChangeNameArgs = {
  accountId: Scalars['String']['input'];
  input: AccountPlatformChangeNameInput;
};


export type AccountPlatformMutationClearFraudArgs = {
  accountId: Scalars['String']['input'];
};


export type AccountPlatformMutationMarkAsDeceasedArgs = {
  accountId: Scalars['String']['input'];
};


export type AccountPlatformMutationMarkAsFraudArgs = {
  accountId: Scalars['String']['input'];
};


export type AccountPlatformMutationRequestEmailChangeArgs = {
  email: Scalars['String']['input'];
};


export type AccountPlatformMutationRequestEmailChangeForCustomerArgs = {
  accountId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type AccountPlatformName = {
  __typename?: 'AccountPlatformName';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type AccountPlatformObfuscatedCustomerAccount = {
  __typename?: 'AccountPlatformObfuscatedCustomerAccount';
  accountId: Scalars['String']['output'];
  accountLabel: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  correspondenceDetails?: Maybe<AccountPlatformContactDetails>;
  occupancyType?: Maybe<AccountPlatformOccupancyType>;
  supplyDetails?: Maybe<AccountPlatformContactDetails>;
};

export enum AccountPlatformOccupancyType {
  EstablishedTenant = 'ESTABLISHED_TENANT',
  Homeowner = 'HOMEOWNER',
  PartnerTenant = 'PARTNER_TENANT',
  Tenant = 'TENANT',
  Unknown = 'UNKNOWN'
}

export type AccountPlatformPafAddress = {
  __typename?: 'AccountPlatformPAFAddress';
  buildingName: Scalars['String']['output'];
  buildingNumber: Scalars['String']['output'];
  county: Scalars['String']['output'];
  department: Scalars['String']['output'];
  dependentLocality: Scalars['String']['output'];
  dependentThoroughfare: Scalars['String']['output'];
  doubleDependentLocality: Scalars['String']['output'];
  oneLine: Scalars['String']['output'];
  organization: Scalars['String']['output'];
  postTown: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  subBuilding: Scalars['String']['output'];
  thoroughfare: Scalars['String']['output'];
  uprn: Scalars['String']['output'];
  uuid?: Maybe<Scalars['String']['output']>;
};

export type AccountPlatformPafAddressInput = {
  buildingName: Scalars['String']['input'];
  buildingNumber: Scalars['String']['input'];
  county: Scalars['String']['input'];
  department: Scalars['String']['input'];
  dependentLocality: Scalars['String']['input'];
  dependentThoroughfare: Scalars['String']['input'];
  doubleDependentLocality: Scalars['String']['input'];
  organization: Scalars['String']['input'];
  postTown: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  subBuilding: Scalars['String']['input'];
  thoroughfare: Scalars['String']['input'];
  uprn: Scalars['String']['input'];
};

export type AccountPlatformQuery = {
  __typename?: 'AccountPlatformQuery';
  addressesByPostcode: Array<AccountPlatformPafAddress>;
  /** @deprecated Use account query */
  customerAccount: AccountPlatformCustomerAccount;
  /** @deprecated Use account query */
  obfuscatedCustomerAccount: AccountPlatformObfuscatedCustomerAccount;
  user: AccountPlatformUser;
};


export type AccountPlatformQueryAddressesByPostcodeArgs = {
  postcode: Scalars['String']['input'];
};


export type AccountPlatformQueryCustomerAccountArgs = {
  id: Scalars['String']['input'];
};


export type AccountPlatformQueryObfuscatedCustomerAccountArgs = {
  id: Scalars['String']['input'];
};


export type AccountPlatformQueryUserArgs = {
  accountId: Scalars['String']['input'];
};

export type AccountPlatformUser = {
  __typename?: 'AccountPlatformUser';
  email: Scalars['String']['output'];
  scopes?: Maybe<Array<Scalars['String']['output']>>;
};

export enum AccountType {
  AccountTypeBusiness = 'ACCOUNT_TYPE_BUSINESS',
  AccountTypeResidential = 'ACCOUNT_TYPE_RESIDENTIAL',
  AccountTypeUnspecified = 'ACCOUNT_TYPE_UNSPECIFIED'
}

export enum AdType {
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL'
}

export type AmendBudgetPlanError = {
  __typename?: 'AmendBudgetPlanError';
  code: AmendBudgetPlanErrorCode;
  message?: Maybe<Scalars['String']['output']>;
};

export enum AmendBudgetPlanErrorCode {
  BudgetPlanNotFound = 'BUDGET_PLAN_NOT_FOUND',
  External = 'EXTERNAL',
  Internal = 'INTERNAL',
  Unknown = 'UNKNOWN'
}

export type AmendBudgetPlanInput = {
  budgetPlanId: Scalars['String']['input'];
  totalAmount: AmountInput;
};

export type AmendBudgetPlanResponse = {
  __typename?: 'AmendBudgetPlanResponse';
  budgetPlan?: Maybe<EnergyBudgetPlan>;
  error?: Maybe<AmendBudgetPlanError>;
  success: Scalars['Boolean']['output'];
};

/** Amount type chosen as per https://wiki.uw.systems/posts/handing-monetary-values-at-uw-6h3vc8pz */
export type Amount = {
  __typename?: 'Amount';
  currency: Currency;
  value: Scalars['String']['output'];
};

export type AmountInput = {
  currency: Currency;
  value: Scalars['String']['input'];
};

export enum AppointmentSlot {
  Am = 'AM',
  Pm = 'PM'
}

export enum AppointmentStatus {
  Booked = 'BOOKED',
  Complete = 'COMPLETE',
  Confirming = 'CONFIRMING'
}

export type AvailableContactChannels = {
  __typename?: 'AvailableContactChannels';
  email?: Maybe<EmailContactChannel>;
  messenger?: Maybe<MessengerContactChannel>;
  phoneCall?: Maybe<PhoneCallContactChannel>;
  webChat?: Maybe<WebChatContactChannel>;
};

export type BankAccountInput = {
  holder: Scalars['String']['input'];
  number: Scalars['String']['input'];
  sortCode: Scalars['String']['input'];
  type?: InputMaybe<BankAccountType>;
};

export enum BankAccountType {
  Business = 'BUSINESS',
  Personal = 'PERSONAL'
}

export type Basket = {
  __typename?: 'Basket';
  hasAvailableEnergyQuotes: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
};

export type BillBreakdownRequest = {
  invoiceId: Scalars['String']['input'];
};

export type BillBreakdownResponse = {
  __typename?: 'BillBreakdownResponse';
  changeReasons?: Maybe<Array<BillChangeReason>>;
};

/**
 * The BillChangeReason describes different reasons that could
 * explain why a customers bill has changed compared to previous
 * months.
 */
export enum BillChangeReason {
  BillChangeReasonCatchupBill = 'BILL_CHANGE_REASON_CATCHUP_BILL'
}

export enum BillingCommunicationPreferenceGraphQl {
  BillingCommunicationPreferenceBraille = 'BILLING_COMMUNICATION_PREFERENCE_BRAILLE',
  BillingCommunicationPreferenceCsv = 'BILLING_COMMUNICATION_PREFERENCE_CSV',
  BillingCommunicationPreferenceEmail = 'BILLING_COMMUNICATION_PREFERENCE_EMAIL',
  BillingCommunicationPreferenceLargePrint = 'BILLING_COMMUNICATION_PREFERENCE_LARGE_PRINT',
  BillingCommunicationPreferenceNone = 'BILLING_COMMUNICATION_PREFERENCE_NONE',
  BillingCommunicationPreferencePrint = 'BILLING_COMMUNICATION_PREFERENCE_PRINT',
  BillingCommunicationPreferenceUnspecified = 'BILLING_COMMUNICATION_PREFERENCE_UNSPECIFIED'
}

export type BillingPlatform = BillingPlatformBill | BillingPlatformGentrack;

export type BillingPlatformBill = {
  __typename?: 'BillingPlatformBill';
  serviceId: Scalars['String']['output'];
};

export type BillingPlatformGentrack = {
  __typename?: 'BillingPlatformGentrack';
  accountNumber: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
};

export type BillingPreferences = {
  __typename?: 'BillingPreferences';
  accountType: AccountType;
  braille?: Maybe<Scalars['Boolean']['output']>;
  contactName?: Maybe<ContactName>;
  email?: Maybe<Scalars['Boolean']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  largePrint?: Maybe<Scalars['Boolean']['output']>;
  postalAddress?: Maybe<PostalAddress>;
  print?: Maybe<Scalars['Boolean']['output']>;
};

export type BillingPreferencesInput = {
  billingCommunicationPreference: BillingCommunicationPreferenceGraphQl;
};

export type BillsQueries = {
  __typename?: 'BillsQueries';
  makePayment: Scalars['String']['output'];
  makePaymentAndStore: Scalars['String']['output'];
  makePaymentOneOff: Scalars['String']['output'];
  paymentMethods: Array<PaymentCard>;
};


export type BillsQueriesMakePaymentArgs = {
  amount: PenceInput;
  paymentMethod: Scalars['String']['input'];
  returnURL: Scalars['String']['input'];
};


export type BillsQueriesMakePaymentAndStoreArgs = {
  amount: PenceInput;
  externalPaymentMethod: Scalars['String']['input'];
  returnURL: Scalars['String']['input'];
};


export type BillsQueriesMakePaymentOneOffArgs = {
  amount: PenceInput;
  externalPaymentMethod: Scalars['String']['input'];
  returnURL: Scalars['String']['input'];
};

export type BroadbandAppointment = {
  __typename?: 'BroadbandAppointment';
  date: Scalars['FixedLineDateTimeRFC3339']['output'];
  slot: AppointmentSlot;
  status?: Maybe<AppointmentStatus>;
};

export type BroadbandAppointmentInput = {
  date: Scalars['FixedLineDateTimeRFC3339']['input'];
  slot: AppointmentSlot;
};

export type BroadbandEntitiesAddressInput = {
  addressLines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  postTown?: InputMaybe<Scalars['String']['input']>;
  uprn?: InputMaybe<Scalars['String']['input']>;
};

export type BroadbandEquipment = {
  __typename?: 'BroadbandEquipment';
  /** @deprecated Use the nullable version: estimatedDeliveryV2. This will be removed in future versions */
  estimatedDelivery: Scalars['FixedLineDateTimeRFC3339']['output'];
  estimatedDeliveryV2?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  status?: Maybe<EquipmentStatus>;
  tracking?: Maybe<BroadbandTracking>;
  type: FixedLineMyServicesEquipmentType;
};

export type BroadbandGetAppointmentsBy = {
  quote_id?: InputMaybe<Scalars['String']['input']>;
  service_id?: InputMaybe<Scalars['String']['input']>;
};

export enum BroadbandMatchRequestResponse_Status {
  ErrorComplexResponseType = 'ERROR_COMPLEX_RESPONSE_TYPE',
  ErrorNotSwitch = 'ERROR_NOT_SWITCH',
  ErrorNoMatch = 'ERROR_NO_MATCH',
  ErrorNoReply = 'ERROR_NO_REPLY',
  Pending = 'PENDING',
  Success = 'SUCCESS',
  Unknown = 'UNKNOWN'
}

export enum BroadbandOtsDirectoryIdentityProcessSupport_Process {
  Ots = 'OTS',
  ProcessUnknown = 'PROCESS_UNKNOWN'
}

export enum BroadbandOtsDirectoryIdentityProcessSupport_Status {
  Active = 'ACTIVE',
  StatusUnknown = 'STATUS_UNKNOWN',
  Suspend = 'SUSPEND'
}

export type BroadbandOtsEntitiesDirectory = {
  __typename?: 'BroadbandOTSEntitiesDirectory';
  list?: Maybe<Array<Maybe<BroadbandOtsEntitiesDirectoryItem>>>;
};

export type BroadbandOtsEntitiesDirectoryIdentity = {
  __typename?: 'BroadbandOTSEntitiesDirectoryIdentity';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  processSupport?: Maybe<Array<Maybe<BroadbandOtsEntitiesDirectoryIdentityProcessSupport>>>;
  resource?: Maybe<Array<Maybe<BroadbandOtsEntitiesDirectoryIdentityResource>>>;
};

export type BroadbandOtsEntitiesDirectoryIdentityProcessSupport = {
  __typename?: 'BroadbandOTSEntitiesDirectoryIdentityProcessSupport';
  process?: Maybe<BroadbandOtsDirectoryIdentityProcessSupport_Process>;
  status?: Maybe<BroadbandOtsDirectoryIdentityProcessSupport_Status>;
};

export type BroadbandOtsEntitiesDirectoryIdentityResource = {
  __typename?: 'BroadbandOTSEntitiesDirectoryIdentityResource';
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BroadbandOtsEntitiesDirectoryItem = {
  __typename?: 'BroadbandOTSEntitiesDirectoryItem';
  identity?: Maybe<Array<Maybe<BroadbandOtsEntitiesDirectoryIdentity>>>;
  listType: Scalars['String']['output'];
};

export type BroadbandOrder = {
  __typename?: 'BroadbandOrder';
  appointment?: Maybe<BroadbandAppointment>;
  appointmentRequiredNotReserved?: Maybe<Scalars['Boolean']['output']>;
  equipment?: Maybe<Array<BroadbandEquipment>>;
  liveDate?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  originalLiveDate?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  status?: Maybe<BroadbandOrderStatus>;
};

export enum BroadbandOrderStatus {
  Cancelled = 'CANCELLED',
  Cancelling = 'CANCELLING',
  Complete = 'COMPLETE',
  Delayed = 'DELAYED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type BroadbandService = {
  __typename?: 'BroadbandService';
  diagnostics?: Maybe<FixedLineDiagnostics>;
  exceptions?: Maybe<Array<FixedLineServiceException>>;
  id: Scalars['ID']['output'];
  networkType?: Maybe<BroadbandServiceNetworkType>;
  order?: Maybe<BroadbandOrder>;
  reference?: Maybe<Scalars['String']['output']>;
  status?: Maybe<FixedLineMyServicesServiceStatus>;
  tariffName?: Maybe<Scalars['String']['output']>;
  technology?: Maybe<BroadbandServiceTechnology>;
};

export enum BroadbandServiceNetworkType {
  CityFibre = 'CITY_FIBRE',
  Openreach = 'OPENREACH'
}

export enum BroadbandServiceTechnology {
  Adsl = 'ADSL',
  Fttc = 'FTTC',
  Fttp = 'FTTP',
  SoGea = 'SoGEA'
}

export enum BroadbandSwitchMatchImplication_Method {
  Email = 'EMAIL',
  FirstClassPost = 'FIRST_CLASS_POST',
  Sms = 'SMS',
  Unknown = 'UNKNOWN'
}

export type BroadbandSwitchingCommunication = {
  __typename?: 'BroadbandSwitchingCommunication';
  sentBy: Scalars['String']['output'];
  sentMethod?: Maybe<BroadbandSwitchMatchImplication_Method>;
  sentTo: Scalars['String']['output'];
};

export type BroadbandSwitchingMatchRequestInput = {
  accountReference?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<BroadbandEntitiesAddressInput>;
  bpaQuoteId?: InputMaybe<Scalars['String']['input']>;
  broadband?: InputMaybe<BroadbandSwitchingSwitchingOptionServiceInput>;
  homePhone?: InputMaybe<BroadbandSwitchingSwitchingOptionServiceInput>;
  provider: Scalars['String']['input'];
  surname: Scalars['String']['input'];
};

export type BroadbandSwitchingMatchRequestResponse = {
  __typename?: 'BroadbandSwitchingMatchRequestResponse';
  fieldErrors: Array<Maybe<Scalars['String']['output']>>;
  implicationCommunications?: Maybe<Array<Maybe<BroadbandSwitchingCommunication>>>;
  options?: Maybe<Array<Maybe<BroadbandSwitchingSwitchingOption>>>;
  status?: Maybe<BroadbandMatchRequestResponse_Status>;
};

export enum BroadbandSwitchingOptionService_Action {
  Cease = 'CEASE',
  ForcedCease = 'FORCED_CEASE',
  NotApplicable = 'NOT_APPLICABLE',
  Port = 'PORT',
  Retain = 'RETAIN',
  Unknown = 'UNKNOWN'
}

export type BroadbandSwitchingRequestReference = {
  __typename?: 'BroadbandSwitchingRequestReference';
  id: Scalars['String']['output'];
};

export type BroadbandSwitchingRequestReferenceInput = {
  id?: InputMaybe<Scalars['String']['input']>;
};

export type BroadbandSwitchingSwitchingOption = {
  __typename?: 'BroadbandSwitchingSwitchingOption';
  broadband?: Maybe<BroadbandSwitchingSwitchingOptionService>;
  homePhone?: Maybe<BroadbandSwitchingSwitchingOptionService>;
  switchOrderReference: Scalars['String']['output'];
};

export type BroadbandSwitchingSwitchingOptionService = {
  __typename?: 'BroadbandSwitchingSwitchingOptionService';
  action?: Maybe<BroadbandSwitchingOptionService_Action>;
  identifier: Scalars['String']['output'];
};

export type BroadbandSwitchingSwitchingOptionServiceInput = {
  action?: InputMaybe<BroadbandSwitchingOptionService_Action>;
  identifier?: InputMaybe<Scalars['String']['input']>;
};

export type BroadbandTracking = {
  __typename?: 'BroadbandTracking';
  carrier?: Maybe<ShippingCarrier>;
  events?: Maybe<Array<BroadbandTrackingEvent>>;
  trackingRef?: Maybe<Scalars['String']['output']>;
  trackingUrl?: Maybe<Scalars['String']['output']>;
};

export type BroadbandTrackingEvent = {
  __typename?: 'BroadbandTrackingEvent';
  description: Scalars['String']['output'];
  timestamp: Scalars['FixedLineDateTimeRFC3339']['output'];
};

/** Budget Plan is not eligible for amendment because it is awaiting its first review. */
export type BudgetPlanNotEligibleAwaitingFirstReview = {
  __typename?: 'BudgetPlanNotEligibleAwaitingFirstReview';
  /** Date from which the 45 day review will have been performed, enabling BP modifications */
  eligibleDate: Scalars['DateTime']['output'];
};

/** Customer is not eligible for a Budget Plan as they are in debt. */
export type BudgetPlanNotEligibleInDebt = {
  __typename?: 'BudgetPlanNotEligibleInDebt';
  /** If the customer is eligible for a payment plan to aid in clearing their debt. */
  paymentPlanEligible: Scalars['Boolean']['output'];
};

export type BudgetPlanNotEligibleNoDirectDebit = {
  __typename?: 'BudgetPlanNotEligibleNoDirectDebit';
  placeholder?: Maybe<Scalars['Void']['output']>;
};

/** Budget Plan is not eligible for setup or amends because the component services have received no readings in the last 30 days. */
export type BudgetPlanNotEligibleNoRecentMeterSubmission = {
  __typename?: 'BudgetPlanNotEligibleNoRecentMeterSubmission';
  /** List of services which are missing a meter read submission within the last 30 days. */
  services: Array<Maybe<EnergyService>>;
};

export type BudgetPlanNotEligibleReason = BudgetPlanNotEligibleAwaitingFirstReview | BudgetPlanNotEligibleInDebt | BudgetPlanNotEligibleNoDirectDebit | BudgetPlanNotEligibleNoRecentMeterSubmission;

export enum BudgetPlanReviewType {
  Annual = 'ANNUAL',
  /** CoS Gain covers a new joiner's new energy and an existing customer's new energy */
  CosGain = 'COS_GAIN',
  /** Manual reviews are those that are triggered outside of the normal schedule, e.g. customer request */
  Manual = 'MANUAL'
}

export enum BudgetPlanStatus {
  Active = 'ACTIVE',
  /** Cancelled is when a customer doesn't pay their BP amount and is moved into MIA. So BP is cancelled part way through their schedule */
  Cancelled = 'CANCELLED',
  /** Closed/Ended is when the current BP has ended and a new BP has spun up */
  Closed = 'CLOSED',
  /** Pending Cancellation is when a BP cancellation has been requested but dependant systems haven't completed it yet, e.g. the credit release from the Ledgers */
  PendingCancellation = 'PENDING_CANCELLATION',
  /** Pending Setup is when a BP has been created but dependant systems haven't completed the BP configuration */
  PendingSetup = 'PENDING_SETUP',
  Unknown = 'UNKNOWN'
}

export type BudgetPlansInput = {
  status?: InputMaybe<BudgetPlanStatus>;
};

export type BusinessDetails = {
  __typename?: 'BusinessDetails';
  address: AccountPlatformPafAddress;
  businessName: Scalars['String']['output'];
  contactPersonDateOfBirth?: Maybe<Scalars['String']['output']>;
  sics?: Maybe<Array<Maybe<Sic>>>;
  type: BusinessType;
  validation: ValidationStatus;
};

export type BusinessType = Charity | Company | SoleTrader;

export type CallBundle = {
  __typename?: 'CallBundle';
  bundleStatus: CallBundleStatus;
  bundle_type: CallBundleType;
  live_date?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  product_id: Scalars['String']['output'];
};

export type CallBundleDetails = {
  __typename?: 'CallBundleDetails';
  available: Scalars['Boolean']['output'];
  bundle_description: Scalars['String']['output'];
  bundle_name: Scalars['String']['output'];
  bundle_type: CallBundleType;
  price: FixedLineMoney;
  product_id: Scalars['String']['output'];
};

export enum CallBundleStatus {
  Available = 'AVAILABLE',
  Live = 'LIVE',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN'
}

export enum CallBundleType {
  InternationalSaver = 'INTERNATIONAL_SAVER',
  OffPeakSaver = 'OFF_PEAK_SAVER',
  PeakSaver = 'PEAK_SAVER',
  Unknown = 'UNKNOWN'
}

export type CalloutBanner = {
  __typename?: 'CalloutBanner';
  colorScheme: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  linkText: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CardPaymentCheckout = {
  __typename?: 'CardPaymentCheckout';
  requiredAction?: Maybe<CardPaymentCheckoutRequiredAction>;
};

export type CardPaymentCheckoutRequiredAction = {
  __typename?: 'CardPaymentCheckoutRequiredAction';
  data: Scalars['String']['output'];
  externalPaymentToken: Scalars['String']['output'];
};

export type CardPaymentMethod = {
  __typename?: 'CardPaymentMethod';
  cardType: CardType;
  expiryDate: Scalars['Time']['output'];
  fingerprint: Scalars['String']['output'];
  firstSixDigits: Scalars['String']['output'];
  issuedIn: Scalars['String']['output'];
  issuer: Scalars['String']['output'];
  lastFourDigits: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
};

export enum CardType {
  Credit = 'CREDIT',
  Debit = 'DEBIT',
  None = 'NONE',
  Prepaid = 'PREPAID'
}

export type CbcAccount = {
  __typename?: 'CbcAccount';
  deliveryAddress: CbcAddress;
  idCheck: CbcIdCheck;
  isEnrolledForInAppChallenges: Scalars['Boolean']['output'];
  kycStatus: CbcKycStatus;
  needsKycChecks: CbcNeedsKycChecks;
  pushNotificationsPreferences: CbcPushNotificationsPreferences;
  uwAccountId: Scalars['String']['output'];
};

export type CbcAccountHolder = {
  __typename?: 'CbcAccountHolder';
  dateOfBirth: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  mobile?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CbcAccountInformation = {
  __typename?: 'CbcAccountInformation';
  accountHolders: Array<CbcAccountHolder>;
  address: CbcAddress;
  id: Scalars['String']['output'];
  monthsExemptFromCharges: Scalars['Int']['output'];
  originPromoEligible: Scalars['Boolean']['output'];
};

export type CbcAddress = {
  __typename?: 'CbcAddress';
  lines: Array<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
};

export type CbcApproveChallengeResponse = {
  __typename?: 'CbcApproveChallengeResponse';
  redirectAppUrl?: Maybe<Scalars['String']['output']>;
};

export enum CbcAutoTopupStatus {
  Cancelled = 'CANCELLED',
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Invalid = 'INVALID'
}

export enum CbcCanAddCardReason {
  AlreadyOrdered = 'ALREADY_ORDERED',
  CardLimitReached = 'CARD_LIMIT_REACHED',
  /** @deprecated Use WALLET_SUSPENDED instead */
  CardSuspended = 'CARD_SUSPENDED',
  Invalid = 'INVALID',
  NegativeBalance = 'NEGATIVE_BALANCE',
  WalletSuspended = 'WALLET_SUSPENDED'
}

export type CbcCanAddCardResponse = {
  __typename?: 'CbcCanAddCardResponse';
  canAddCard: Scalars['Boolean']['output'];
  reason?: Maybe<CbcCanAddCardReason>;
};

export enum CbcCanCancelWalletReason {
  BlockedBalance = 'BLOCKED_BALANCE',
  OpenDispute = 'OPEN_DISPUTE'
}

export type CbcCanCancelWalletResponse = {
  __typename?: 'CbcCanCancelWalletResponse';
  canCancel: Scalars['Boolean']['output'];
  reason?: Maybe<CbcCanCancelWalletReason>;
};

export enum CbcCanOrderWalletReason {
  AccountLeaving = 'ACCOUNT_LEAVING',
  ActiveWallet = 'ACTIVE_WALLET',
  IsInDebt = 'IS_IN_DEBT',
  PendingOrder = 'PENDING_ORDER',
  Unknown = 'UNKNOWN'
}

export type CbcCanOrderWalletResponse = {
  __typename?: 'CbcCanOrderWalletResponse';
  canOrderWallet: Scalars['Boolean']['output'];
  reason: CbcCanOrderWalletReason;
};

export enum CbcCancelWalletReason {
  AccountClosed = 'ACCOUNT_CLOSED',
  NoLongerInUse = 'NO_LONGER_IN_USE',
  UnawareTheyHadIt = 'UNAWARE_THEY_HAD_IT',
  Undisclosed = 'UNDISCLOSED',
  UnsatisfiedCustomer = 'UNSATISFIED_CUSTOMER'
}

export type CbcCard = {
  __typename?: 'CbcCard';
  blocked: Scalars['Boolean']['output'];
  canConvertToPhysical: Scalars['Boolean']['output'];
  canReplace: Scalars['Boolean']['output'];
  embossName: Scalars['String']['output'];
  expiryDate: Scalars['DateTime']['output'];
  flags: CbcCardFeatureFlags;
  holderDetails: CbcCardHolderDetails;
  id: Scalars['String']['output'];
  isMainCardHolder: Scalars['Boolean']['output'];
  last4Digits: Scalars['String']['output'];
  needsChipAndPinTransaction: Scalars['Boolean']['output'];
  pinBlocked: Scalars['Boolean']['output'];
  providerId: Scalars['Int']['output'];
  provisionedAt?: Maybe<Scalars['DateTime']['output']>;
  replacedAt?: Maybe<Scalars['DateTime']['output']>;
  replacesCardId?: Maybe<Scalars['String']['output']>;
  status: CbcCardStatus;
  /** @deprecated We've moved the suspend feature to the wallet instead of the card. */
  suspended: Scalars['Boolean']['output'];
  type: CbcCardType;
  walletId: Scalars['String']['output'];
};

export type CbcCardFeatureFlags = {
  __typename?: 'CbcCardFeatureFlags';
  atmWithdrawalsEnabled: Scalars['Boolean']['output'];
  contactlessEnabled: Scalars['Boolean']['output'];
  magstripeEnabled: Scalars['Boolean']['output'];
};

export type CbcCardHolderDetails = {
  __typename?: 'CbcCardHolderDetails';
  dateOfBirth: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  holderPartnerPositionTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isAccountHolder: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  optedInToMarketing: Scalars['Boolean']['output'];
  postCode: Scalars['String']['output'];
};

export type CbcCardHolderInput = {
  dateOfBirth: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  isMainCardHolder: Scalars['Boolean']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
};

export type CbcCardPaymentDetails = {
  __typename?: 'CbcCardPaymentDetails';
  cardExpiryDate: Scalars['String']['output'];
  cardIssuedIn: Scalars['String']['output'];
  cardIssuer: Scalars['String']['output'];
  cardLastFourDigits: Scalars['String']['output'];
  cardScheme: Scalars['String']['output'];
  cardType: Scalars['String']['output'];
};

export enum CbcCardReplacementReason {
  Damaged = 'DAMAGED',
  Lost = 'LOST',
  LostInTransit = 'LOST_IN_TRANSIT',
  Other = 'OTHER',
  Stolen = 'STOLEN'
}

export enum CbcCardStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Inactive = 'INACTIVE',
  Invalid = 'INVALID',
  InProvisioning = 'IN_PROVISIONING',
  ProvisioningFailed = 'PROVISIONING_FAILED'
}

export enum CbcCardType {
  Invalid = 'INVALID',
  Physical = 'PHYSICAL',
  Virtual = 'VIRTUAL'
}

export enum CbcCardUsageType {
  ChipAndPin = 'CHIP_AND_PIN',
  Contactless = 'CONTACTLESS',
  Invalid = 'INVALID',
  MagneticStripe = 'MAGNETIC_STRIPE',
  ManuallyEntered = 'MANUALLY_ENTERED',
  Online = 'ONLINE',
  Other = 'OTHER'
}

export enum CbcCashbackType {
  General = 'GENERAL',
  Invalid = 'INVALID',
  Magic = 'MAGIC',
  Retail = 'RETAIL'
}

export type CbcClientMetaData = {
  fingerprint: Scalars['String']['input'];
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CbcComputeRefundResponse = {
  __typename?: 'CbcComputeRefundResponse';
  amountInPence: Scalars['Int']['output'];
  refunds: Array<CbcRefund>;
};

export type CbcConsent = {
  __typename?: 'CbcConsent';
  accessExpiresAt: Scalars['String']['output'];
  accessGrantedAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  tppName: Scalars['String']['output'];
};

export type CbcConsentSession = {
  __typename?: 'CbcConsentSession';
  expiryTimestamp: Scalars['String']['output'];
  id: Scalars['String']['output'];
  redirectURL: Scalars['String']['output'];
  tppName: Scalars['String']['output'];
};

export enum CbcConsentStatus {
  Authorised = 'AUTHORISED',
  Denied = 'DENIED'
}

export type CbcContinue3DsTransactionResponse = {
  __typename?: 'CbcContinue3DSTransactionResponse';
  paymentMethodToken: Scalars['String']['output'];
};

export type CbcCreateLowBalanceTopupRequest = {
  amountInPence: Scalars['Int']['input'];
  paymentMethodToken: Scalars['String']['input'];
  threshold: Scalars['Int']['input'];
};

export type CbcCreateScheduledTopupRequest = {
  amountInPence: Scalars['Int']['input'];
  dayNumber: Scalars['Int']['input'];
  paymentMethodToken: Scalars['String']['input'];
  type: CbcScheduledTopupType;
};

export enum CbcDeclinedReason {
  CardBlocked = 'CARD_BLOCKED',
  CardExpired = 'CARD_EXPIRED',
  CardLost = 'CARD_LOST',
  CardStolen = 'CARD_STOLEN',
  ChipAndPinRequired = 'CHIP_AND_PIN_REQUIRED',
  ContactlessDisabled = 'CONTACTLESS_DISABLED',
  HigherRiskPaymentsDisabled = 'HIGHER_RISK_PAYMENTS_DISABLED',
  IncorrectPin = 'INCORRECT_PIN',
  InsufficientFunds = 'INSUFFICIENT_FUNDS',
  Invalid = 'INVALID',
  Other = 'OTHER'
}

export type CbcExecuteRefundRequest = {
  amountInPence: Scalars['Int']['input'];
  refunds: Array<CbcRefundInput>;
};

export type CbcExecuteRefundResponse = {
  __typename?: 'CbcExecuteRefundResponse';
  /** @deprecated There is no single refund id. If you need ids to refer to, use the ids of the items in the refunds array in the request */
  refundId: Scalars['String']['output'];
};

export type CbcGeneralCashbackCapTier = {
  __typename?: 'CbcGeneralCashbackCapTier';
  capInPence: Scalars['Int']['output'];
  maxServices?: Maybe<Scalars['Int']['output']>;
  minServices: Scalars['Int']['output'];
};

export enum CbcGetOnfidoSdkTokenCaller {
  MyAccountMobileApp = 'MY_ACCOUNT_MOBILE_APP',
  MyAccountWeb = 'MY_ACCOUNT_WEB'
}

export type CbcGroupedTransactions = {
  __typename?: 'CbcGroupedTransactions';
  cashbackEarned: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  totalSpend: Scalars['Int']['output'];
  transactions: Array<CbcTransaction>;
};

export type CbcIdCheck = {
  __typename?: 'CbcIdCheck';
  failDescription?: Maybe<CbcIdCheckFailDescription>;
  failReason?: Maybe<CbcIdCheckFailReason>;
  passedOnfidoDocumentCheck: Scalars['Boolean']['output'];
  status: CbcIdCheckStatus;
};

export enum CbcIdCheckFailDescription {
  AgeValidationFail = 'AGE_VALIDATION_FAIL',
  CompromisedDocument = 'COMPROMISED_DOCUMENT',
  DataComparisonFail = 'DATA_COMPARISON_FAIL',
  DataInconsistent = 'DATA_INCONSISTENT',
  DataValidationFail = 'DATA_VALIDATION_FAIL',
  ImageIntegrityIncorrect = 'IMAGE_INTEGRITY_INCORRECT',
  PoliceRecordedFail = 'POLICE_RECORDED_FAIL',
  VisualAuthenticityIncorrect = 'VISUAL_AUTHENTICITY_INCORRECT'
}

export enum CbcIdCheckFailReason {
  AutomatedCheckFail = 'AUTOMATED_CHECK_FAIL',
  DocumentCheckFail = 'DOCUMENT_CHECK_FAIL',
  Unknown = 'UNKNOWN'
}

export enum CbcIdCheckStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Passed = 'PASSED',
  Unknown = 'UNKNOWN'
}

export type CbcInitiatePaymentResponse = {
  __typename?: 'CbcInitiatePaymentResponse';
  paymentToken: Scalars['String']['output'];
};

export type CbcInsightsMagicWinner = {
  __typename?: 'CbcInsightsMagicWinner';
  amount: Scalars['Int']['output'];
  drawDate: Scalars['DateTime']['output'];
  location: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CbcInsightsMagicWinners = {
  __typename?: 'CbcInsightsMagicWinners';
  drawDate: Scalars['DateTime']['output'];
  winners: Array<CbcInsightsMagicWinner>;
};

export type CbcInsightsMonthlyCashback = {
  __typename?: 'CbcInsightsMonthlyCashback';
  cashbackEarnedInPence?: Maybe<Scalars['Int']['output']>;
  date: Scalars['DateTime']['output'];
  magicCashbackEarnedInPence?: Maybe<Scalars['Int']['output']>;
};

export type CbcInsightsMonthlySpend = {
  __typename?: 'CbcInsightsMonthlySpend';
  amountInPence: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type CbcInsightsMonthlyTopup = {
  __typename?: 'CbcInsightsMonthlyTopup';
  amountInPence: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
};

export type CbcInsightsTopRetailPartner = {
  __typename?: 'CbcInsightsTopRetailPartner';
  amountSpentInPence: Scalars['Int']['output'];
  cashbackEarnedInPence: Scalars['Int']['output'];
  cashbackRate: Scalars['Float']['output'];
  retailPartnerId: Scalars['String']['output'];
  retailPartnerLogoUrl?: Maybe<Scalars['String']['output']>;
  retailPartnerName: Scalars['String']['output'];
};

export type CbcInsightsTotalEarnedCashback = {
  __typename?: 'CbcInsightsTotalEarnedCashback';
  amountInPence: Scalars['Int']['output'];
  since: Scalars['DateTime']['output'];
};

export enum CbcKycStatus {
  Cdd = 'CDD',
  MigrationException = 'MIGRATION_EXCEPTION',
  Sdd = 'SDD',
  SddExpired = 'SDD_EXPIRED',
  Unknown = 'UNKNOWN'
}

export type CbcLimits = {
  __typename?: 'CbcLimits';
  atmWithdrawal: Scalars['Int']['output'];
  contactless: Scalars['Int']['output'];
  contactlessApplePay?: Maybe<Scalars['Int']['output']>;
  contactlessGooglePayLocked?: Maybe<Scalars['Int']['output']>;
  contactlessGooglePayUnlocked?: Maybe<Scalars['Int']['output']>;
};

export type CbcLowBalanceTopup = {
  __typename?: 'CbcLowBalanceTopup';
  amountInPence: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  paymentMethodToken: Scalars['String']['output'];
  status: CbcAutoTopupStatus;
  threshold: Scalars['Int']['output'];
};

export enum CbcMdesWalletType {
  Apple = 'APPLE',
  Google = 'GOOGLE',
  Mastercard = 'MASTERCARD'
}

export enum CbcNeededKycCheck {
  DocumentCheck = 'DOCUMENT_CHECK',
  IdCheck = 'ID_CHECK',
  Unknown = 'UNKNOWN'
}

export type CbcNeedsKycChecks = {
  __typename?: 'CbcNeedsKycChecks';
  applicantName: Scalars['String']['output'];
  hasExceededDocumentCheckLimit: Scalars['Boolean']['output'];
  neededCheck: CbcNeededKycCheck;
  needsKycChecks: Scalars['Boolean']['output'];
  reason: CbcNeedsKycChecksReason;
};

export enum CbcNeedsKycChecksReason {
  AwaitingResult = 'AWAITING_RESULT',
  CheckFailed = 'CHECK_FAILED',
  CheckFailedNeedsReupload = 'CHECK_FAILED_NEEDS_REUPLOAD',
  CheckFailedPermanently = 'CHECK_FAILED_PERMANENTLY',
  RecheckRequired = 'RECHECK_REQUIRED',
  Unknown = 'UNKNOWN'
}

export type CbcNotification = {
  __typename?: 'CbcNotification';
  content: Scalars['String']['output'];
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type CbcOpenBankingPaymentDetails = {
  __typename?: 'CbcOpenBankingPaymentDetails';
  bankAccountLastDigits: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
};

export enum CbcOrderSource {
  Crm = 'CRM',
  Jtc = 'JTC',
  MobileApp = 'MOBILE_APP',
  MyAccount = 'MY_ACCOUNT',
  Unknown = 'UNKNOWN'
}

export type CbcOrderSourceInput = {
  jtcApplicationId?: InputMaybe<Scalars['String']['input']>;
  source: CbcOrderSource;
};

export type CbcPaymentDetails = CbcCardPaymentDetails | CbcOpenBankingPaymentDetails;

export type CbcPaymentMethodCard = {
  __typename?: 'CbcPaymentMethodCard';
  bin: Scalars['String']['output'];
  expiryDate: Scalars['DateTime']['output'];
  fingerprint: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last4Digits: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
};

export type CbcPaymentsMethods = {
  __typename?: 'CbcPaymentsMethods';
  cards?: Maybe<Array<CbcPaymentMethodCard>>;
};

export type CbcPushNotificationsPreferences = {
  __typename?: 'CbcPushNotificationsPreferences';
  changedAt?: Maybe<Scalars['DateTime']['output']>;
  enabled: Scalars['Boolean']['output'];
};

export type CbcRefund = {
  __typename?: 'CbcRefund';
  amountInPence: Scalars['Int']['output'];
  bankAccountLastDigits: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  cardExpiry: Scalars['String']['output'];
  cardLast4Digits: Scalars['String']['output'];
  cardScheme: Scalars['String']['output'];
  method: CbcWithdrawalMethod;
  topupId: Scalars['String']['output'];
};

export type CbcRefundInput = {
  amountInPence: Scalars['Int']['input'];
  topupId: Scalars['String']['input'];
};

export type CbcScheduledTopup = {
  __typename?: 'CbcScheduledTopup';
  amountInPence: Scalars['Int']['output'];
  dayNumber: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  paymentMethodToken: Scalars['String']['output'];
  status: CbcAutoTopupStatus;
  type: CbcScheduledTopupType;
};

export enum CbcScheduledTopupType {
  Invalid = 'INVALID',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type CbcSecureCvv2 = {
  __typename?: 'CbcSecureCvv2';
  initializationVector: Scalars['String']['output'];
  secureCvv2: Scalars['String']['output'];
};

export type CbcSecurePan = {
  __typename?: 'CbcSecurePan';
  initializationVector: Scalars['String']['output'];
  securePAN: Scalars['String']['output'];
};

export type CbcSecurePin = {
  __typename?: 'CbcSecurePin';
  initializationVector: Scalars['String']['output'];
  securePin: Scalars['String']['output'];
};

export type CbcTopUpAllowance = {
  __typename?: 'CbcTopUpAllowance';
  maxAmount: Scalars['Int']['output'];
  minAmount: Scalars['Int']['output'];
};

export type CbcTopUpRequiredAction = {
  __typename?: 'CbcTopUpRequiredAction';
  externalTransactionToken: Scalars['String']['output'];
  transactionData: Scalars['Bytes']['output'];
};

export type CbcTopUpResponse = {
  __typename?: 'CbcTopUpResponse';
  authorizationCode: Scalars['String']['output'];
  gatewayId: Scalars['String']['output'];
  orderId: Scalars['String']['output'];
  paymentMethodToken: Scalars['String']['output'];
  requiredAction?: Maybe<CbcTopUpRequiredAction>;
  transactionId: Scalars['String']['output'];
  transactionToken: Scalars['String']['output'];
};

export type CbcTopupDetails = {
  __typename?: 'CbcTopupDetails';
  amountInPence: Scalars['Int']['output'];
  feeInPence?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  paymentDetails: CbcPaymentDetails;
  tags?: Maybe<Array<CbcTransactionTag>>;
  transactionDate: Scalars['DateTime']['output'];
  type: CbcTopupType;
  walletId: Scalars['String']['output'];
};

export enum CbcTopupType {
  AdhocTopup = 'ADHOC_TOPUP',
  Invalid = 'INVALID',
  LowBalanceTopup = 'LOW_BALANCE_TOPUP',
  ScheduledTopup = 'SCHEDULED_TOPUP'
}

export type CbcTotalMagicEarned = {
  __typename?: 'CbcTotalMagicEarned';
  amount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
};

export type CbcTransaction = {
  __typename?: 'CbcTransaction';
  amount: Scalars['Int']['output'];
  balanceAvailable: Scalars['Int']['output'];
  cardUsageDetails?: Maybe<Scalars['String']['output']>;
  cashbackAmount?: Maybe<Scalars['Int']['output']>;
  cashbackType?: Maybe<Scalars['String']['output']>;
  cashbackType2: CbcCashbackType;
  dateTime: Scalars['DateTime']['output'];
  declineReason?: Maybe<CbcDeclinedReason>;
  declineReasonDescription?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isSettled?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<CbcTransactionStatus>;
  successful?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<CbcTransactionTag>>;
  type?: Maybe<CbcTransactionType>;
};

export type CbcTransactionChallenge = {
  __typename?: 'CbcTransactionChallenge';
  amount: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type CbcTransactionDetails = {
  __typename?: 'CbcTransactionDetails';
  amountInPence: Scalars['Int']['output'];
  cappedCashbackEarnedInPence: Scalars['Int']['output'];
  cardHolderName: Scalars['String']['output'];
  cardId: Scalars['String']['output'];
  cardLastFourDigits: Scalars['String']['output'];
  cardUsageType: CbcCardUsageType;
  cashbackEarnedInPence: Scalars['Int']['output'];
  cashbackEarnedPercent: Scalars['Float']['output'];
  cashbackType: CbcCashbackType;
  declineReason?: Maybe<CbcDeclinedReason>;
  declineReasonDescription?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  localAmountInPence: Scalars['Int']['output'];
  localCurrency: Scalars['String']['output'];
  location: CbcTransactionLocation;
  mdesWalletType?: Maybe<CbcMdesWalletType>;
  merchantCategory: Scalars['String']['output'];
  merchantCategoryCode: Scalars['String']['output'];
  merchantId: Scalars['String']['output'];
  retailPartner?: Maybe<Retailer>;
  status: CbcTransactionStatus;
  transactionDate: Scalars['DateTime']['output'];
  walletId: Scalars['String']['output'];
};

export type CbcTransactionDetailsResponse = CbcTopupDetails | CbcTransactionDetails | CbcWithdrawalDetails;

export type CbcTransactionLocation = {
  __typename?: 'CbcTransactionLocation';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  name: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  street: Scalars['String']['output'];
};

export enum CbcTransactionStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Invalid = 'INVALID',
  Pending = 'PENDING',
  Reversed = 'REVERSED',
  Settled = 'SETTLED',
  Voided = 'VOIDED'
}

export enum CbcTransactionTag {
  AdhocTopup = 'ADHOC_TOPUP',
  AutoTopupLowBalance = 'AUTO_TOPUP_LOW_BALANCE',
  AutoTopupMonthly = 'AUTO_TOPUP_MONTHLY',
  AutoTopupWeekly = 'AUTO_TOPUP_WEEKLY',
  CashbackMagic = 'CASHBACK_MAGIC',
  Declined = 'DECLINED',
  Refund = 'REFUND',
  Withdrawal = 'WITHDRAWAL'
}

export enum CbcTransactionType {
  Authorization = 'AUTHORIZATION',
  Fee = 'FEE',
  Load = 'LOAD',
  Settlement = 'SETTLEMENT',
  Unload = 'UNLOAD'
}

export type CbcWallet = {
  __typename?: 'CbcWallet';
  address?: Maybe<CbcAddress>;
  balance?: Maybe<CbcWalletBalance>;
  canAddCard: CbcCanAddCardResponse;
  canCancel: CbcCanCancelWalletResponse;
  canPerformTopups: Scalars['Boolean']['output'];
  cards?: Maybe<Array<CbcCard>>;
  dailyCashback: Scalars['Int']['output'];
  generalCashbackCapInPence: Scalars['Int']['output'];
  generalCashbackCapTiers: Array<CbcGeneralCashbackCapTier>;
  id: Scalars['String']['output'];
  monthlyCashback: Scalars['Int']['output'];
  optedInForMagic: Scalars['Boolean']['output'];
  providerId: Scalars['Int']['output'];
  remainingFreeTopups: Scalars['Int']['output'];
  status?: Maybe<CbcWalletStatus>;
  topUpAllowance: CbcTopUpAllowance;
  transactionChallenges?: Maybe<Array<CbcTransactionChallenge>>;
};

export type CbcWalletBalance = {
  __typename?: 'CbcWalletBalance';
  available: Scalars['Int']['output'];
  blocked: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum CbcWalletStatus {
  Active = 'ACTIVE',
  Ended = 'ENDED',
  Invalid = 'INVALID',
  New = 'NEW'
}

export type CbcWithdrawalDetails = {
  __typename?: 'CbcWithdrawalDetails';
  amountInPence: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  items: Array<CbcWithdrawalItem>;
  transactionDate: Scalars['DateTime']['output'];
  walletId: Scalars['String']['output'];
};

export type CbcWithdrawalItem = {
  __typename?: 'CbcWithdrawalItem';
  amountInPence: Scalars['Int']['output'];
  bankAccountLastDigits: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  cardExpiryDate: Scalars['String']['output'];
  cardFirstSixDigits: Scalars['String']['output'];
  cardLastFourDigits: Scalars['String']['output'];
  cardScheme: Scalars['String']['output'];
  method: CbcWithdrawalMethod;
  status: CbcWithdrawalStatus;
};

export enum CbcWithdrawalMethod {
  Bacs = 'BACS',
  Card = 'CARD',
  Invalid = 'INVALID',
  OpenBanking = 'OPEN_BANKING'
}

export enum CbcWithdrawalStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Invalid = 'INVALID',
  New = 'NEW'
}

export type ChangeAccountSmartConsentLevelInput = {
  consentLevel: SmartConsentLevel;
};

export type ChangeAccountSmartConsentLevelResponse = {
  __typename?: 'ChangeAccountSmartConsentLevelResponse';
  error?: Maybe<Scalars['String']['output']>;
};

export type ChangeDirectDebitResult = {
  __typename?: 'ChangeDirectDebitResult';
  status?: Maybe<MutationStatus>;
};

export type ChangeEmailResponse = {
  __typename?: 'ChangeEmailResponse';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type ChangeEmailResult = {
  __typename?: 'ChangeEmailResult';
  status?: Maybe<MutationStatus>;
};

export type ChangePasswordResult = {
  __typename?: 'ChangePasswordResult';
  status?: Maybe<MutationStatus>;
};

export enum ChannelStatus {
  Busy = 'BUSY',
  Closed = 'CLOSED',
  Hidden = 'HIDDEN',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export type Charity = {
  __typename?: 'Charity';
  charityNumber: Scalars['String']['output'];
  companyNumber?: Maybe<Scalars['String']['output']>;
};

export type ChatState = {
  __typename?: 'ChatState';
  hasUnerasedPastConversations: Scalars['Boolean']['output'];
  isActive: Scalars['Boolean']['output'];
  startedOnThisAccount: Scalars['Boolean']['output'];
  unreadCount: Scalars['Int']['output'];
};

export type ClientApplicationInput = {
  id: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type CloseAccountRequest = {
  accountDebt: Scalars['String']['input'];
  accountID: Scalars['String']['input'];
  accountNumber: Scalars['String']['input'];
  declineServicesReason?: InputMaybe<Scalars['String']['input']>;
  forwardingAddress: Scalars['String']['input'];
  invoiceAddress?: InputMaybe<Scalars['String']['input']>;
  moveDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  supplyAddress?: InputMaybe<Scalars['String']['input']>;
  takeServices: Scalars['Boolean']['input'];
};

export type CloseAccountResponse = {
  __typename?: 'CloseAccountResponse';
  success: Scalars['Boolean']['output'];
};

export type CollectionDate = {
  __typename?: 'CollectionDate';
  nanos?: Maybe<Scalars['Int']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

export type Company = {
  __typename?: 'Company';
  companyNumber: Scalars['String']['output'];
};

export type CompletePasswordResetResult = {
  __typename?: 'CompletePasswordResetResult';
  token: OAuthToken;
};

export type Consent = {
  __typename?: 'Consent';
  PreferenceSubmissions: Array<PreferenceSubmission>;
  /** The ISO 8601 timestamp when this record was created. */
  createdAt: Scalars['String']['output'];
  /**
   * Contains all current consent preferences for this citizen.
   * e.g., 'preference.all', 'preference.sms'."
   * This value must match a valid preference ID in the DataGuard system.
   */
  preferences: Array<Preference>;
};

export type ContactChannelsChatAvailability = {
  __typename?: 'ContactChannelsChatAvailability';
  mobile: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type ContactChannelsEmailSubject = {
  emailBackoffice: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ContactChannelsEmailTopic = {
  allowAttachments: Scalars['Boolean']['input'];
  emailBackoffice: Scalars['String']['input'];
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ContactChannelsMutation = {
  __typename?: 'ContactChannelsMutation';
  /** @deprecated please use HEX sendEmail */
  sendEmail: Scalars['Boolean']['output'];
  /** @deprecated please use root */
  storeSession: Scalars['Boolean']['output'];
};


export type ContactChannelsMutationSendEmailArgs = {
  input: SendEmailContactChannelsMutationInput;
};


export type ContactChannelsMutationStoreSessionArgs = {
  input: StoreSessionMutationInput;
};

export type ContactChannelsQuery = {
  __typename?: 'ContactChannelsQuery';
  /** @deprecated please use availableContactChannels */
  availableChannels?: Maybe<Array<Maybe<AvailableContactChannels>>>;
  chatAvailability: ContactChannelsChatAvailability;
};

export type ContactName = {
  __typename?: 'ContactName';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContinueChallengedPaymentResult = {
  __typename?: 'ContinueChallengedPaymentResult';
  failureReason?: Maybe<PaymentFailureReason>;
  success: Scalars['Boolean']['output'];
};

export type CreatePaymentPlanInput = {
  accountId: Scalars['String']['input'];
  bankAccountName?: InputMaybe<Scalars['String']['input']>;
  bankAccountNumber?: InputMaybe<Scalars['String']['input']>;
  bankSortCode?: InputMaybe<Scalars['String']['input']>;
  durationInMonths: Scalars['Int']['input'];
  initialPaymentAmount: AmountInput;
  paymentDueChoice: PaymentDueChoice;
  totalPaymentAmount: AmountInput;
};

export type CreatePaymentPlanResponse = {
  __typename?: 'CreatePaymentPlanResponse';
  initialPaymentTransactionId?: Maybe<Scalars['String']['output']>;
  paymentPlanId: Scalars['String']['output'];
};

export enum Currency {
  CurrencyGbp = 'CURRENCY_GBP',
  CurrencyUnspecified = 'CURRENCY_UNSPECIFIED'
}

/** Cursor-based pagination. Use 'token' from a previous response's nextToken to fetch the next page. Preferred for infinite scrolling in UIs. */
export type CursorPaginationInput = {
  size?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerBillingMutation = {
  __typename?: 'CustomerBillingMutation';
  changeDirectDebit?: Maybe<ChangeDirectDebitResult>;
  continueChallengedPayment: ContinueChallengedPaymentResult;
  id: Scalars['ID']['output'];
  makePayment: MakePaymentResult;
  updateBillingPreferences?: Maybe<Scalars['Boolean']['output']>;
};


export type CustomerBillingMutationChangeDirectDebitArgs = {
  directDebit: BankAccountInput;
};


export type CustomerBillingMutationContinueChallengedPaymentArgs = {
  customerAccountID: Scalars['String']['input'];
  externalTransactionToken: Scalars['String']['input'];
};


export type CustomerBillingMutationMakePaymentArgs = {
  amount: AmountInput;
  clientFingerprint: Scalars['String']['input'];
  customerAccountID: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  paymentMethod: PaymentMethodInput;
  reason: PaymentReason;
  redirectURL: Scalars['String']['input'];
};


export type CustomerBillingMutationUpdateBillingPreferencesArgs = {
  input: BillingPreferencesInput;
};

export type CustomerBillingQuery = {
  __typename?: 'CustomerBillingQuery';
  accountBills: AccountBills;
  aiBillSummary: Scalars['String']['output'];
  billBreakdown: BillBreakdownResponse;
  billedPaymentDetails: PaymentDetails;
  billingPreferences: BillingPreferences;
  emailRedelivery: Scalars['String']['output'];
  getDigitalBillSummary?: Maybe<DigitalBillSummary>;
  getETSFile?: Maybe<TextFile>;
  getImageFiles?: Maybe<Array<Maybe<ImageFile>>>;
  getTargetedFiles?: Maybe<TargetedFiles>;
  id: Scalars['ID']['output'];
  paymentDetails: PaymentDetails;
  pdfUrl: Scalars['String']['output'];
  validateDirectDebit?: Maybe<ValidateDirectDebitResult>;
};


export type CustomerBillingQueryAiBillSummaryArgs = {
  input: AiBillSummaryRequest;
};


export type CustomerBillingQueryBillBreakdownArgs = {
  input: BillBreakdownRequest;
};


export type CustomerBillingQueryEmailRedeliveryArgs = {
  input?: InputMaybe<EmailRequest>;
};


export type CustomerBillingQueryGetDigitalBillSummaryArgs = {
  input?: InputMaybe<DigitalBillSummaryRequest>;
};


export type CustomerBillingQueryGetImageFilesArgs = {
  adType?: InputMaybe<AdType>;
};


export type CustomerBillingQueryPdfUrlArgs = {
  input: PdfUrlRequest;
};


export type CustomerBillingQueryValidateDirectDebitArgs = {
  directDebit: BankAccountInput;
};

export type CustomerBilling__Bill = {
  __typename?: 'CustomerBilling__Bill';
  bexBillAvailable?: Maybe<Scalars['Boolean']['output']>;
  invoiceDate?: Maybe<InvoiceDate>;
  invoiceId: Scalars['String']['output'];
  total?: Maybe<Amount>;
  url: Scalars['String']['output'];
};

/** Customer details. */
export type CustomerPrincipal = {
  __typename?: 'CustomerPrincipal';
  /** Verified email address or the only existing email attached to account */
  accountEmail?: Maybe<Scalars['String']['output']>;
  /**
   * If present, this email address is currently pending verification by the customer.
   * Once verified it will replace the accounts email address, until then it's not used.
   * @deprecated Use accountEmailPendingVerificationInfo instead.
   */
  accountEmailPendingVerification?: Maybe<Scalars['String']['output']>;
  accountEmailPendingVerificationInfo?: Maybe<AccountEmailPendingVerificationInfo>;
  /** UUID for the account the customer belongs to. */
  accountID: Scalars['ID']['output'];
  /** Friendly account identifer. */
  accountNumber: Scalars['String']['output'];
  /** UUID identifies the individial customer. */
  id: Scalars['ID']['output'];
};

export type CustomerProposition = {
  __typename?: 'CustomerProposition';
  getReferralCode?: Maybe<Scalars['String']['output']>;
};

export type CustomerSupportCustomerInstigator = {
  customerOrigin: CustomerSupportCustomerInstigatorOrigin;
};

export enum CustomerSupportCustomerInstigatorOrigin {
  App = 'APP',
  Web = 'WEB'
}

export type CustomerSupportMutations = {
  __typename?: 'CustomerSupportMutations';
  ping?: Maybe<Scalars['Void']['output']>;
  submitAssessment?: Maybe<Scalars['Void']['output']>;
};


export type CustomerSupportMutationsSubmitAssessmentArgs = {
  request: CustomerSupportSubmitAssessmentRequest;
};

export type CustomerSupportSubmission = {
  additionalDetail?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<CustomerSupportVulnerabilityCircumstanceAgeInput>;
  children?: InputMaybe<CustomerSupportVulnerabilityCircumstanceChildrenInput>;
  chronicIllness?: InputMaybe<CustomerSupportVulnerabilityCircumstanceChronicIllnessInput>;
  circumstances?: InputMaybe<Array<CustomerSupportVulnerabilityCircumstance>>;
  dailyActivity?: InputMaybe<CustomerSupportVulnerabilityCircumstanceDailyActivityInput>;
  financial?: InputMaybe<CustomerSupportVulnerabilityCircumstanceFinancialInput>;
  hearing?: InputMaybe<CustomerSupportVulnerabilityCircumstanceHearingInput>;
  medicalEquipment?: InputMaybe<CustomerSupportVulnerabilityCircumstanceMedicalEquipmentInput>;
  miscellaneous?: InputMaybe<CustomerSupportVulnerabilityCircumstanceMiscellaneousInput>;
  other?: InputMaybe<CustomerSupportVulnerabilityCircumstanceOtherInformationInput>;
  psr?: InputMaybe<CustomerSupportVulnerabilityPsr>;
  sight?: InputMaybe<CustomerSupportVulnerabilityCircumstanceSightInput>;
  submissionType: CustomerSupportSubmissionType;
  version?: InputMaybe<CustomerSupportVulnerabilityAssessmentVersion>;
};

export enum CustomerSupportSubmissionType {
  AssessmentCompleted = 'AssessmentCompleted',
  AssessmentDeclined = 'AssessmentDeclined',
  AssessmentNoChanges = 'AssessmentNoChanges'
}

export type CustomerSupportSubmitAssessmentRequest = {
  instigator: CustomerSupportCustomerInstigator;
  submission: CustomerSupportSubmission;
};

export enum CustomerSupportVulnerabilityAssessmentVersion {
  V1 = 'V1',
  V2 = 'V2'
}

export type CustomerSupportVulnerabilityCircumstance = {
  circumstancesType: CustomerSupportVulnerabilityCircumstanceType;
  detail?: InputMaybe<Scalars['String']['input']>;
  estimatedEnd?: InputMaybe<Scalars['Date']['input']>;
};

export type CustomerSupportVulnerabilityCircumstanceAgeInput = {
  between66And74?: InputMaybe<MultiChoice>;
  between75And84?: InputMaybe<MultiChoice>;
  householdHasLiveInCarer?: InputMaybe<MultiChoice>;
  over85?: InputMaybe<MultiChoice>;
  under66?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceChildrenInput = {
  childrenBetween2And4?: InputMaybe<MultiChoice>;
  childrenBetween5And15?: InputMaybe<MultiChoice>;
  childrenUnder2?: InputMaybe<MultiChoice>;
  childrenUnder16?: InputMaybe<MultiChoice>;
  pregnant?: InputMaybe<MultiChoice>;
  pregnantOrChildrenUnder5?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceChronicIllnessInput = {
  cancer?: InputMaybe<MultiChoice>;
  cardiovascularDisease?: InputMaybe<MultiChoice>;
  chronicRespiratoryDiseases?: InputMaybe<MultiChoice>;
  copd?: InputMaybe<MultiChoice>;
  diabetes?: InputMaybe<MultiChoice>;
  kidneyDisease?: InputMaybe<MultiChoice>;
  liverDisease?: InputMaybe<MultiChoice>;
  neurologicalDisorders?: InputMaybe<MultiChoice>;
  organFailure?: InputMaybe<MultiChoice>;
  other?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceDailyActivityInput = {
  difficultyWithEssentialActivities?: InputMaybe<MultiChoice>;
  difficultyWithEssentialActivitiesDetails?: InputMaybe<Scalars['String']['input']>;
  supportOnDailyBasis?: InputMaybe<MultiChoice>;
  supportOnDailyBasisDetails?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerSupportVulnerabilityCircumstanceFinancialInput = {
  inDebt?: InputMaybe<MultiChoice>;
  isACarer?: InputMaybe<MultiChoice>;
  lostOrChangedJob?: InputMaybe<MultiChoice>;
  movedHome?: InputMaybe<MultiChoice>;
  receivingJobseekersAllowance?: InputMaybe<MultiChoice>;
  recentBereavement?: InputMaybe<MultiChoice>;
  sufferingOrSufferedFromCovid19?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceHearingInput = {
  deafOrHardOfHearing?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceMedicalEquipmentInput = {
  dialysisOrFeedingPumpOrAutomatedMedication?: InputMaybe<MultiChoice>;
  heartOrLungOrVentilatorEquipment?: InputMaybe<MultiChoice>;
  medicallyDependantShowering?: InputMaybe<MultiChoice>;
  medicineRefrigeration?: InputMaybe<MultiChoice>;
  nebuliserOrApnoeaMonitor?: InputMaybe<MultiChoice>;
  oxygenConcentrator?: InputMaybe<MultiChoice>;
  stairLiftOrHoistOrElectricBed?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceMiscellaneousInput = {
  additionalPresencePreferred?: InputMaybe<MultiChoice>;
  dementiaOrCognitiveImpairment?: InputMaybe<MultiChoice>;
  developmentalCondition?: InputMaybe<MultiChoice>;
  hasCarelineInstalledOrReliantOnCommsServices?: InputMaybe<MultiChoice>;
  learningDifficultiesOrDisablities?: InputMaybe<MultiChoice>;
  medicallyDependantOnWarmHome?: InputMaybe<MultiChoice>;
  medicineRefrigeration?: InputMaybe<MultiChoice>;
  mentalHealthIssue?: InputMaybe<MultiChoice>;
  neurologicalDiseases?: InputMaybe<MultiChoice>;
  nutritionalIssues?: InputMaybe<MultiChoice>;
  physicalImpairment?: InputMaybe<MultiChoice>;
  poorSenseOfSmellOrTaste?: InputMaybe<MultiChoice>;
  recentlyRecoveringFromAHospitalVisit?: InputMaybe<MultiChoice>;
  restrictiveHandMovement?: InputMaybe<MultiChoice>;
  speechImpairment?: InputMaybe<MultiChoice>;
  temporaryYoungAdultHouseholderUnder18?: InputMaybe<MultiChoice>;
  unableToAnswerTheDoor?: InputMaybe<MultiChoice>;
  unableToCommunicateInEnglish?: InputMaybe<MultiChoice>;
  waterDependent?: InputMaybe<MultiChoice>;
};

export type CustomerSupportVulnerabilityCircumstanceOtherInformationInput = {
  other?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerSupportVulnerabilityCircumstanceSightInput = {
  legallyBlind?: InputMaybe<MultiChoice>;
  mildVisualImpairment?: InputMaybe<MultiChoice>;
  moderateVisualImpairment?: InputMaybe<MultiChoice>;
  severeVisualImpairment?: InputMaybe<MultiChoice>;
};

export enum CustomerSupportVulnerabilityCircumstanceType {
  CustomerSupportVulnerabilityCircumstanceAge = 'CustomerSupportVulnerabilityCircumstanceAge',
  CustomerSupportVulnerabilityCircumstanceCareline = 'CustomerSupportVulnerabilityCircumstanceCareline',
  CustomerSupportVulnerabilityCircumstanceChildren = 'CustomerSupportVulnerabilityCircumstanceChildren',
  CustomerSupportVulnerabilityCircumstanceFinancial = 'CustomerSupportVulnerabilityCircumstanceFinancial',
  CustomerSupportVulnerabilityCircumstanceHearing = 'CustomerSupportVulnerabilityCircumstanceHearing',
  CustomerSupportVulnerabilityCircumstanceIllnessDisability = 'CustomerSupportVulnerabilityCircumstanceIllnessDisability',
  CustomerSupportVulnerabilityCircumstanceSight = 'CustomerSupportVulnerabilityCircumstanceSight'
}

export enum CustomerSupportVulnerabilityNeedType {
  CustomerSupportVulnerabilityNeedBeenInHospital = 'CustomerSupportVulnerabilityNeedBeenInHospital',
  CustomerSupportVulnerabilityNeedBereavment = 'CustomerSupportVulnerabilityNeedBereavment',
  CustomerSupportVulnerabilityNeedLivingAloneUnder18 = 'CustomerSupportVulnerabilityNeedLivingAloneUnder18',
  CustomerSupportVulnerabilityNeedYoungestChild = 'CustomerSupportVulnerabilityNeedYoungestChild'
}

export type CustomerSupportVulnerabilityPsr = {
  psrNeeds?: InputMaybe<Array<CustomerSupportVulnerabilityPsrNeed>>;
  psrOutcome?: InputMaybe<CustomerSupportVulnerabilityPsrOutcome>;
  psrServices?: InputMaybe<CustomerSupportVulnerabilityPsrServices>;
};

export type CustomerSupportVulnerabilityPsrNeed = {
  needBeenInHospital?: InputMaybe<Scalars['Date']['input']>;
  needBereavment?: InputMaybe<Scalars['Date']['input']>;
  needLivingAloneUnder18?: InputMaybe<Scalars['Date']['input']>;
  needType: CustomerSupportVulnerabilityNeedType;
  needYoungestChild?: InputMaybe<Scalars['Date']['input']>;
};

export type CustomerSupportVulnerabilityPsrOutcome = {
  eligible?: InputMaybe<Scalars['Boolean']['input']>;
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CustomerSupportVulnerabilityPsrServices = {
  billInAudio: Scalars['Boolean']['input'];
  billInBraille: Scalars['Boolean']['input'];
  billInLargePrint: Scalars['Boolean']['input'];
  passPhrase?: InputMaybe<Scalars['String']['input']>;
  quarterlyMeterRead: Scalars['Boolean']['input'];
  sendKnobTurner: Scalars['Boolean']['input'];
};

export type DexOrder = {
  __typename?: 'DEXOrder';
  orderId: Scalars['ID']['output'];
  services: Array<DexOrderService>;
};

export type DexOrderService = {
  estimatedDate?: Maybe<Scalars['Date']['output']>;
  hasIntegrationIssues?: Maybe<IntegrationIssues>;
  lineItemId: Scalars['ID']['output'];
  product?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['ID']['output'];
  serviceStatus: DexOrderServiceStatus;
  serviceType: DexOrderServiceType;
  statusReason?: Maybe<Scalars['String']['output']>;
  subproducts?: Maybe<Array<Maybe<DexOrderSubproduct>>>;
};

export enum DexOrderServiceStatus {
  Fulfilled = 'FULFILLED',
  InProgress = 'IN_PROGRESS',
  Unspecified = 'UNSPECIFIED'
}

export enum DexOrderServiceType {
  Broadband = 'BROADBAND',
  Cashback = 'CASHBACK',
  Energy = 'ENERGY',
  Insurance = 'INSURANCE',
  Mobile = 'MOBILE',
  Unspecified = 'UNSPECIFIED'
}

export type DexOrderSubproduct = {
  __typename?: 'DEXOrderSubproduct';
  name?: Maybe<Scalars['String']['output']>;
  subproductStatus?: Maybe<DexOrderSubproductStatus>;
};

export enum DexOrderSubproductStatus {
  Dispatched = 'DISPATCHED',
  Unspecified = 'UNSPECIFIED'
}

export type DashboardServiceGroup = {
  __typename?: 'DashboardServiceGroup';
  deeplink?: Maybe<Url>;
  services?: Maybe<Array<Maybe<ServiceOverview>>>;
  status: ServiceStatus;
  statusDescription: Scalars['String']['output'];
};

export type DashboardServices = {
  __typename?: 'DashboardServices';
  broadband: DashboardServiceGroup;
  energy: DashboardServiceGroup;
  insurance: DashboardServiceGroup;
  mobile: DashboardServiceGroup;
};

export type DateAndUtcTime = {
  __typename?: 'DateAndUTCTime';
  date: Scalars['String']['output'];
  utcTime: Scalars['String']['output'];
};

export type DateRangeInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DebtDetailsResponse = {
  __typename?: 'DebtDetailsResponse';
  accountHasExistingDirectDebit: Scalars['Boolean']['output'];
  amount: Amount;
  bankAccountName?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  bankSortCode?: Maybe<Scalars['String']['output']>;
  isInitialPaymentRequired: Scalars['Boolean']['output'];
};

export enum DebtPaymentPlanIneligibleReason {
  AccountDebtAgencyIsNotNull = 'ACCOUNT_DEBT_AGENCY_IS_NOT_NULL',
  AccountHasActiveFinancialServices = 'ACCOUNT_HAS_ACTIVE_FINANCIAL_SERVICES',
  AccountHasRecentlyCanceledPaymentPlan = 'ACCOUNT_HAS_RECENTLY_CANCELED_PAYMENT_PLAN',
  AccountHasRecentlyCreatedPaymentPlan = 'ACCOUNT_HAS_RECENTLY_CREATED_PAYMENT_PLAN',
  AccountHasRecentLiveDate = 'ACCOUNT_HAS_RECENT_LIVE_DATE',
  AccountHasTelcoBarring = 'ACCOUNT_HAS_TELCO_BARRING',
  AccountInactive = 'ACCOUNT_INACTIVE',
  /** @deprecated Use ACCOUNT_DEBT_AGENCY_IS_NOT_NULL instead */
  AccountIsInRecoveryProcess = 'ACCOUNT_IS_IN_RECOVERY_PROCESS',
  AccountIsVulnerable = 'ACCOUNT_IS_VULNERABLE',
  AccountNotInDebt = 'ACCOUNT_NOT_IN_DEBT',
  Unspecified = 'UNSPECIFIED'
}

export type DebtPaymentPlanSummaryResponse = {
  __typename?: 'DebtPaymentPlanSummaryResponse';
  bankAccountName: Scalars['String']['output'];
  bankAccountNumber: Scalars['String']['output'];
  bankSortCode: Scalars['String']['output'];
  currentBillRequiresManualOnlinePayment: Scalars['Boolean']['output'];
  directDebitScenario: DirectDebitScenario;
  firstPaymentMethod: Scalars['String']['output'];
  initialPaymentAmount: Amount;
  monthlyPaymentAmount: Amount;
  numberOfPayments: Scalars['Int']['output'];
  paymentDueChoice: PaymentDueChoice;
  paymentSchedule: Array<ScheduledPayment>;
  totalPaymentAmount: Amount;
};

export type DigitalBillSummary = {
  __typename?: 'DigitalBillSummary';
  Cashback?: Maybe<Scalars['Float']['output']>;
  ElectricityCost?: Maybe<Scalars['Float']['output']>;
  GasCost?: Maybe<Scalars['Float']['output']>;
  HasBudgetPlan?: Maybe<Scalars['Boolean']['output']>;
  HasEstimatedEnergy?: Maybe<Scalars['Boolean']['output']>;
  InvoiceDate?: Maybe<Scalars['String']['output']>;
  PaymentDate?: Maybe<Scalars['String']['output']>;
};

export type DigitalBillSummaryRequest = {
  invoiceId?: InputMaybe<Scalars['String']['input']>;
};

export type DigitalSupportMutation = {
  __typename?: 'DigitalSupportMutation';
  /** @deprecated No longer supported */
  sendArticleFeedback?: Maybe<Scalars['String']['output']>;
};


export type DigitalSupportMutationSendArticleFeedbackArgs = {
  feedback: SupportArticleFeedbackRequest;
};

export type DigitalSupportQuery = {
  __typename?: 'DigitalSupportQuery';
  /** @deprecated No longer supported */
  supportArticleFAQCategories: Array<SupportArticleFaqCategory>;
  /** @deprecated No longer supported */
  supportArticleWithMetaData?: Maybe<SupportArticleWithMetaData>;
  /** @deprecated No longer supported */
  supportArticles: Array<Maybe<SupportArticleInfo>>;
};


export type DigitalSupportQuerySupportArticleWithMetaDataArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type DigitalSupportQuerySupportArticlesArgs = {
  filter?: InputMaybe<SupportArticleFilterInput>;
  platform?: InputMaybe<SupportArticlesPlatform>;
  searchEngine?: InputMaybe<SearchEngine>;
};

export type DirectDebitBankDetails = {
  __typename?: 'DirectDebitBankDetails';
  holder: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
  sortCode: Scalars['String']['output'];
};

export type DirectDebitMandate = {
  __typename?: 'DirectDebitMandate';
  bankAccount: PaymentPlatformBankAccount;
  id: Scalars['String']['output'];
  purpose: DirectDebitMandatePurpose;
};

export enum DirectDebitMandatePurpose {
  MonthlyBill = 'MONTHLY_BILL',
  NotSpecified = 'NOT_SPECIFIED'
}

export enum DirectDebitScenario {
  DirectDebitScenarioChanged = 'DIRECT_DEBIT_SCENARIO_CHANGED',
  DirectDebitScenarioNewSetup = 'DIRECT_DEBIT_SCENARIO_NEW_SETUP',
  DirectDebitScenarioUnchanged = 'DIRECT_DEBIT_SCENARIO_UNCHANGED',
  DirectDebitScenarioUnspecified = 'DIRECT_DEBIT_SCENARIO_UNSPECIFIED'
}

export enum DirectDebitValidationReason {
  ValidateDirectDebitResultAccountNotValid = 'VALIDATE_DIRECT_DEBIT_RESULT_ACCOUNT_NOT_VALID',
  ValidateDirectDebitResultAddressDoesNotMatch = 'VALIDATE_DIRECT_DEBIT_RESULT_ADDRESS_DOES_NOT_MATCH',
  ValidateDirectDebitResultNameDoesNotMatch = 'VALIDATE_DIRECT_DEBIT_RESULT_NAME_DOES_NOT_MATCH',
  ValidateDirectDebitResultUnknownError = 'VALIDATE_DIRECT_DEBIT_RESULT_UNKNOWN_ERROR'
}

export enum EditDirectDebitMandateFailureReason {
  BankAccountNotSupported = 'BANK_ACCOUNT_NOT_SUPPORTED',
  BankAccountNotValid = 'BANK_ACCOUNT_NOT_VALID',
  NotSpecified = 'NOT_SPECIFIED'
}

export type EditDirectDebitMandateInput = {
  accountReference: Scalars['String']['input'];
  bankAccount: PaymentPlatformBankAccountInput;
  clientApplication: ClientApplicationInput;
  id: Scalars['String']['input'];
  purpose: DirectDebitMandatePurpose;
  requester: RequesterInput;
};

export type EditDirectDebitMandateOutcome = EditDirectDebitMandateOutcomeFailure | EditDirectDebitMandateOutcomeSuccess;

export type EditDirectDebitMandateOutcomeFailure = {
  __typename?: 'EditDirectDebitMandateOutcomeFailure';
  failureReason?: Maybe<EditDirectDebitMandateFailureReason>;
};

export type EditDirectDebitMandateOutcomeSuccess = {
  __typename?: 'EditDirectDebitMandateOutcomeSuccess';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

export type EligibilityForDebtPaymentPlanResponse = {
  __typename?: 'EligibilityForDebtPaymentPlanResponse';
  eligible: Scalars['Boolean']['output'];
  reason?: Maybe<DebtPaymentPlanIneligibleReason>;
};

export type EmailAttachmentReference = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type EmailContactChannel = {
  __typename?: 'EmailContactChannel';
  calloutBanner?: Maybe<CalloutBanner>;
  estimatedWaitTime?: Maybe<Scalars['Int']['output']>;
  queueId?: Maybe<Scalars['String']['output']>;
  queue_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelStatus>;
};

export type EmailRequest = {
  accountId: Scalars['String']['input'];
  accountName: Scalars['String']['input'];
  accountType: AccountType;
  emailAddress: Scalars['String']['input'];
  invoiceId: Scalars['String']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

/**
 * Represents the progress of the migration status onto the Gentrack platform.
 *
 * NOT_STARTED, IN_PROGRESS or FAILED means they are still handled through Bill, or that there are no energy services.
 */
export enum EnergyAccountMigrationStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** Represents a property associated with a specific account. */
export type EnergyAccountProperty = {
  __typename?: 'EnergyAccountProperty';
  /** Reasons why this property is not eligible for budget plan. If the array is empty, they are eligible for budget plan. */
  budgetPlanEligibility?: Maybe<Array<BudgetPlanNotEligibleReason>>;
  details?: Maybe<EnergyProperty>;
  occupancy?: Maybe<Occupancy>;
  paymentTerms?: Maybe<EnergyPaymentTerms>;
  /**
   * Recommended budget plan amount for the monthly-in-arrears services on this
   * property. Null if there are no MIA services.
   */
  recommendedBudgetPlan?: Maybe<RecommendedBudgetPlan>;
  services?: Maybe<Array<EnergyService>>;
};


/** Represents a property associated with a specific account. */
export type EnergyAccountPropertyPaymentTermsArgs = {
  input?: InputMaybe<EnergyServicesFilterInput>;
};


/** Represents a property associated with a specific account. */
export type EnergyAccountPropertyServicesArgs = {
  input?: InputMaybe<EnergyServicesFilterInput>;
};

export type EnergyAgreement = {
  __typename?: 'EnergyAgreement';
  tariff?: Maybe<EnergyTariff>;
  terms?: Maybe<EnergyAgreementTerms>;
};

export type EnergyAgreementTerms = {
  __typename?: 'EnergyAgreementTerms';
  dualFuelDiscount: Amount;
  /** Charge applied if the tariff is ended before the earlyTerminationChargeToDate */
  earlyTerminationCharge: Amount;
  /** The date, prior to which, if the tariff is ended, the early termination charge will be applied */
  earlyTerminationChargeToDate?: Maybe<Scalars['DateTime']['output']>;
  /** The end date for this agreement */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Estimate of what this agreement is expected to cost, for display only.
   * Computed purely as: sum(EAC per register × matching unit rate) + (standing charge × days in the agreement year, 365 or 366 in a leap-year window).
   * Registers are paired to rates by type (DAY/NIGHT/STANDARD); when no type match exists, the first available rate is used as a fallback.
   * Excludes discounts, debt repayment, levies, VAT changes, and any other adjustment.
   * Null when EAC is unavailable (e.g. non-Gentrack meterpoints, FIT) or when the agreement has no unit rates.
   */
  estimatedCost?: Maybe<EnergyEstimatedAgreementCost>;
  /** The daily standing charge for this agreement */
  standingChargeInPence: Scalars['String']['output'];
  standingChargeTotalCosts?: Maybe<EnergyEstimatedAgreementCost>;
  /** The start date for this agreement */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  unitRates: Array<EnergyUnitRate>;
};

export type EnergyAnnualConsumption = {
  __typename?: 'EnergyAnnualConsumption';
  /**
   * Per-register breakdown. Single entry for gas (rate type GAS) and single-rate electricity (GENERAL_DOMESTIC),
   * multiple entries for time-of-use tariffs (e.g. DAY / NIGHT for Economy 7).
   */
  registerConsumption: Array<EnergyRegisterConsumption>;
  /** Sum of usageKwh across all registers, in kWh. */
  totalConsumption: Scalars['Float']['output'];
};

/**
 * Placeholder for the services type definition until we properly migrate them.
 * They need to contain budget plan
 */
export type EnergyBudgetPlan = {
  __typename?: 'EnergyBudgetPlan';
  billRunInProgress?: Maybe<Scalars['Boolean']['output']>;
  changesApplyCurrentMonth: Scalars['Boolean']['output'];
  /** Reasons why this budget plan is not eligible to be amended. If the array is empty, they are eligible for budget plan amendments. */
  eligibility?: Maybe<Array<BudgetPlanNotEligibleReason>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fortyFiveDayReviewDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lastReviewDate?: Maybe<Scalars['DateTime']['output']>;
  lastReviewType?: Maybe<BudgetPlanReviewType>;
  nextAnnualReviewDate?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Recommended review for this budget plan: the suggested new amount. Null if
   * unavailable.
   */
  recommendedBudgetPlan?: Maybe<RecommendedBudgetPlan>;
  /** Services can contain null services, which means we can't find the details for a specific service in the BP. */
  services: Array<Maybe<EnergyService>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status: BudgetPlanStatus;
  totalAmount: Amount;
  /**
   * Current ledger balance for this budget plan, combined across all services
   * it covers (e.g. gas + electricity on a dual-fuel plan). Null if the
   * balance is unavailable.
   * It reflects how the balance looks to the business:
   * positive balance will mean negative to the customer (Deficit)
   * while negative balance will mean positive for the customer (Credit)
   */
  totalBalance?: Maybe<Amount>;
};


/**
 * Placeholder for the services type definition until we properly migrate them.
 * They need to contain budget plan
 */
export type EnergyBudgetPlanServicesArgs = {
  input?: InputMaybe<EnergyServicesFilterInput>;
};

export type EnergyBudgetPlanPaymentTerm = {
  __typename?: 'EnergyBudgetPlanPaymentTerm';
  budgetPlan: EnergyBudgetPlan;
  services: Array<EnergyService>;
};

export type EnergyBudgetPlanPaymentTermFilterInput = {
  /**
   * Budget plan statuses to consider, in priority order: the plan matching the
   * earliest status in the list is returned. Omitted or null applies the default
   * [ACTIVE, PENDING_SETUP, PENDING_CANCELLATION]. An empty list matches no
   * statuses and returns null.
   */
  statuses?: InputMaybe<Array<BudgetPlanStatus>>;
};

export enum EnergyConsumptionRateType {
  Day = 'DAY',
  Gas = 'GAS',
  GeneralDomestic = 'GENERAL_DOMESTIC',
  Night = 'NIGHT',
  Storage = 'STORAGE',
  Unknown = 'UNKNOWN'
}

export type EnergyElectricityMeterpoint = {
  __typename?: 'EnergyElectricityMeterpoint';
  mpan: Scalars['String']['output'];
  profileClass?: Maybe<EnergyMeterpointProfileClass>;
};

export type EnergyEligibilityCriteria = {
  __typename?: 'EnergyEligibilityCriteria';
  criterion: EnergyEligibilityCriterion;
  met: Scalars['Boolean']['output'];
};

export enum EnergyEligibilityCriterion {
  BundleTier_1 = 'BUNDLE_TIER_1',
  BundleTier_2 = 'BUNDLE_TIER_2',
  BundleTier_3Plus = 'BUNDLE_TIER_3_PLUS',
  CommunicatingSmartMeter = 'COMMUNICATING_SMART_METER',
  DebtFree = 'DEBT_FREE',
  Ev = 'EV',
  ExistingCustomer = 'EXISTING_CUSTOMER',
  KnownCustomer = 'KNOWN_CUSTOMER',
  NewCustomer = 'NEW_CUSTOMER',
  SmartMeter = 'SMART_METER',
  Unknown = 'UNKNOWN'
}

export type EnergyEstimatedAgreementCost = {
  __typename?: 'EnergyEstimatedAgreementCost';
  annual: Amount;
  monthly: Amount;
};

export type EnergyEvComparisonElement = {
  __typename?: 'EnergyEvComparisonElement';
  monthlyCost: Scalars['Float']['output'];
  monthlyCostRounded: Scalars['Float']['output'];
  paymentType: EnergyTariffPaymentType;
  rates: Array<EnergyTariffRate>;
  standingChargePencePerDay: Scalars['Float']['output'];
  standingChargePencePerDayRounded: Scalars['Float']['output'];
  tariffName: Scalars['String']['output'];
};

export type EnergyEvEligibilityCheckInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  registrationNumber: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type EnergyEvSwitchComparison = {
  __typename?: 'EnergyEvSwitchComparison';
  coreServiceCount: Scalars['Int']['output'];
  current: EnergyEvComparisonElement;
  estimatedMonthlySaving: Scalars['Float']['output'];
  estimatedMonthlySavingRounded: Scalars['Float']['output'];
  new: EnergyEvComparisonElement;
};

export type EnergyEvSwitchToEvTariffInput = {
  applicationId: Scalars['String']['input'];
};

export type EnergyEvSwitchToEvTariffResponse = {
  __typename?: 'EnergyEvSwitchToEvTariffResponse';
  success: Scalars['Boolean']['output'];
};

export type EnergyEvTariffEligibility = {
  __typename?: 'EnergyEvTariffEligibility';
  applicationId: Scalars['String']['output'];
  eligible: Scalars['Boolean']['output'];
  reasons?: Maybe<Array<EvTariffIneligibilityReason>>;
};

export type EnergyEvVehicle = {
  __typename?: 'EnergyEvVehicle';
  fuelType: Scalars['String']['output'];
  isSupportedFuel: Scalars['Boolean']['output'];
  isVehicleTaxed: Scalars['Boolean']['output'];
};

export type EnergyEvVehicleCheck = {
  __typename?: 'EnergyEvVehicleCheck';
  error?: Maybe<EnergyEvVehicleCheckError>;
  vehicle?: Maybe<EnergyEvVehicle>;
};

export enum EnergyEvVehicleCheckError {
  ApiNotAvailable = 'API_NOT_AVAILABLE',
  CannotGetApplication = 'CANNOT_GET_APPLICATION',
  DvlaInvalidArgument = 'DVLA_INVALID_ARGUMENT',
  DvlaInvalidResponse = 'DVLA_INVALID_RESPONSE',
  DvlaServiceUnavailable = 'DVLA_SERVICE_UNAVAILABLE',
  Unknown = 'UNKNOWN',
  VehicleNotFound = 'VEHICLE_NOT_FOUND',
  WrongState = 'WRONG_STATE'
}

export type EnergyEvVehicleCheckInput = {
  vehiclePlate: Scalars['String']['input'];
};

export enum EnergyFuelType {
  Electricity = 'ELECTRICITY',
  Fit = 'FIT',
  Gas = 'GAS'
}

export type EnergyGasMeterpoint = {
  __typename?: 'EnergyGasMeterpoint';
  mprn: Scalars['String']['output'];
};

export type EnergyMeter = {
  __typename?: 'EnergyMeter';
  /**
   * in FIT meters, this will be equivalent to the serial number, as they have no id whatsoever.
   * Use this for submission, as the gql will take care of the logic behind it.
   */
  id: Scalars['String']['output'];
  installedAt?: Maybe<Scalars['DateTime']['output']>;
  isResponsive?: Maybe<Scalars['Boolean']['output']>;
  isSmart: Scalars['Boolean']['output'];
  reads: EnergyReadsGroup;
  /** For FIT and gas, expect always 1 register */
  registers: Array<EnergyMeterRegister>;
  serialNumber: Scalars['String']['output'];
  uninstalledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EnergyMeterRead = {
  __typename?: 'EnergyMeterRead';
  id: Scalars['String']['output'];
  isEstimated: Scalars['Boolean']['output'];
  isSuppressed?: Maybe<Scalars['Boolean']['output']>;
  /** This nested meter only contains id for now, avoid usage for other purposes. FIT reads won't have this field populated */
  meter?: Maybe<EnergyMeter>;
  readDate: Scalars['DateTime']['output'];
  registerReading: Array<RegisterReading>;
  source: MeterReadSource;
  state: ReadingState;
};

export type EnergyMeterRegister = {
  __typename?: 'EnergyMeterRegister';
  dials: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type EnergyMeterpoint = EnergyElectricityMeterpoint | EnergyGasMeterpoint;

export type EnergyMeterpointInput = {
  mpxn: Scalars['String']['input'];
};

export enum EnergyMeterpointProfileClass {
  ProfileClass_00 = 'PROFILE_CLASS_00',
  ProfileClass_01 = 'PROFILE_CLASS_01',
  ProfileClass_02 = 'PROFILE_CLASS_02',
  ProfileClass_03 = 'PROFILE_CLASS_03',
  ProfileClass_04 = 'PROFILE_CLASS_04',
  ProfileClass_05 = 'PROFILE_CLASS_05',
  ProfileClass_06 = 'PROFILE_CLASS_06',
  ProfileClass_07 = 'PROFILE_CLASS_07',
  ProfileClass_08 = 'PROFILE_CLASS_08',
  ProfileClassNone = 'PROFILE_CLASS_NONE'
}

export type EnergyPaymentTerms = {
  __typename?: 'EnergyPaymentTerms';
  budgetPlan?: Maybe<EnergyBudgetPlanPaymentTerm>;
  monthlyInArrears: Array<EnergyService>;
  other: Array<EnergyService>;
  prepayment: Array<EnergyService>;
};


export type EnergyPaymentTermsBudgetPlanArgs = {
  input?: InputMaybe<EnergyBudgetPlanPaymentTermFilterInput>;
};

/** Represents a property which is connected to a meterpoint */
export type EnergyProperty = {
  __typename?: 'EnergyProperty';
  /** @deprecated use EnergyAccountProperty.occupancy.address */
  address?: Maybe<EnergyPropertyAddress>;
  id: Scalars['String']['output'];
};

export type EnergyPropertyAddress = {
  __typename?: 'EnergyPropertyAddress';
  address1: Scalars['String']['output'];
  address2: Scalars['String']['output'];
  address3: Scalars['String']['output'];
  address4: Scalars['String']['output'];
  address5: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type EnergyQuote = {
  __typename?: 'EnergyQuote';
  /**
   * Estimated costs.
   *
   * Based on the current rates under EnergyQuote.terms and estimated consumption under EnergyQuotes.usage
   */
  cost?: Maybe<EnergyQuoteCost>;
  /** Based on the costs of the current tariff and estimated consumption under EnergyQuotes.usage. If either the current service cost or this quote's cost is null, the result will be null. */
  costComparison?: Maybe<EnergyQuoteCost>;
  eligibility?: Maybe<EnergyQuoteEligibility>;
  id: Scalars['String']['output'];
  isCurrentService: Scalars['Boolean']['output'];
  tariff?: Maybe<EnergyTariff>;
  terms?: Maybe<EnergyAgreementTerms>;
  type?: Maybe<EnergyQuoteType>;
  /** Estimated usage to generate this quote. */
  usage?: Maybe<Array<EnergyUsage>>;
};

export type EnergyQuoteCost = {
  __typename?: 'EnergyQuoteCost';
  annualCharge: Amount;
  monthlyCharge: Amount;
};

export type EnergyQuoteEligibility = {
  __typename?: 'EnergyQuoteEligibility';
  /** Reason for ineligibility, if applicable */
  criteria: Array<EnergyEligibilityCriteria>;
  isEligible: Scalars['Boolean']['output'];
};

export type EnergyQuoteFilterInput = {
  /** If not set, will default to every metering type. When set, it will only return the metering types in the array */
  meteringType?: InputMaybe<Array<EnergyTariffMeteringType>>;
};

export enum EnergyQuoteSortField {
  Cost = 'COST'
}

export type EnergyQuoteSortInput = {
  direction: SortDirection;
  field: EnergyQuoteSortField;
};

export enum EnergyQuoteType {
  Fixed = 'FIXED',
  Tracker = 'TRACKER',
  Undefined = 'UNDEFINED',
  Unknown = 'UNKNOWN',
  Variable = 'VARIABLE'
}

export type EnergyQuotesInput = {
  filterBy?: InputMaybe<EnergyQuoteFilterInput>;
  sortBy?: InputMaybe<EnergyQuoteSortInput>;
};

export type EnergyReadsGroup = {
  __typename?: 'EnergyReadsGroup';
  /** History is not supported on FIT and it will always return an empty array */
  history: MeterReadsHistoryResponse;
  latestRead?: Maybe<EnergyMeterRead>;
};


export type EnergyReadsGroupHistoryArgs = {
  input?: InputMaybe<MeterReadsHistoryInput>;
};


export type EnergyReadsGroupLatestReadArgs = {
  input?: InputMaybe<LatestReadInput>;
};

export type EnergyRegisterConsumption = {
  __typename?: 'EnergyRegisterConsumption';
  rateType: EnergyConsumptionRateType;
  usageKwh: Scalars['Float']['output'];
};

export type EnergySbAppointment = {
  __typename?: 'EnergySBAppointment';
  contactDetails: EnergySbContactDetails;
  id: Scalars['String']['output'];
  siteAddress: EnergySiteAddress;
  slot: EnergySbAvailableSlot;
  status: EnergySbBookingStatus;
  vulnerabilityDetails?: Maybe<EnergySbVulnerabilityDetails>;
};

export type EnergySbAvailableDate = {
  __typename?: 'EnergySBAvailableDate';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type EnergySbAvailableSlot = {
  __typename?: 'EnergySBAvailableSlot';
  date: EnergySbAvailableDate;
  endTime: Scalars['Int']['output'];
  startTime: Scalars['Int']['output'];
};

export type EnergySbAvailableSlotsInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  endDate: EnergySbDateInput;
  startDate: EnergySbDateInput;
};

export type EnergySbAvailableSlotsPointOfSaleInput = {
  accountNumber: Scalars['String']['input'];
  endDate: EnergySbDateInput;
  startDate: EnergySbDateInput;
};

export type EnergySbBookAppointmentInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  contactDetails: EnergySbContactDetailsInput;
  platform?: InputMaybe<EnergySbPlatform>;
  slot: EnergySbSlotInput;
  vulnerabilityDetails: EnergySbVulnerabilityDetailsInput;
};

export type EnergySbBookAppointmentPointOfSaleInput = {
  accountNumber: Scalars['String']['input'];
  contactDetails: EnergySbContactDetailsInput;
  platform: EnergySbPlatform;
  slot: EnergySbSlotInput;
  vulnerabilityDetails: EnergySbVulnerabilityDetailsInput;
};

export type EnergySbBookingAppointmentResponse = {
  __typename?: 'EnergySBBookingAppointmentResponse';
  bookingId: Scalars['String']['output'];
};

export enum EnergySbBookingStatus {
  BookingStatusAborted = 'BOOKING_STATUS_ABORTED',
  BookingStatusCompleted = 'BOOKING_STATUS_COMPLETED',
  BookingStatusScheduled = 'BOOKING_STATUS_SCHEDULED',
  BookingStatusUnknown = 'BOOKING_STATUS_UNKNOWN'
}

export type EnergySbContactDetails = {
  __typename?: 'EnergySBContactDetails';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type EnergySbContactDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type EnergySbCustomer = {
  __typename?: 'EnergySBCustomer';
  accountId: Scalars['ID']['output'];
  accountNumber: Scalars['String']['output'];
  appointment?: Maybe<EnergySbAppointment>;
  contactDetails: EnergySbContactDetails;
  siteAddress: EnergySiteAddress;
};

export type EnergySbCustomerPointOfSale = {
  __typename?: 'EnergySBCustomerPointOfSale';
  accountNumber: Scalars['String']['output'];
  contactDetails: EnergySbContactDetails;
  siteAddress: EnergySiteAddress;
};

export type EnergySbCustomerPointOfSaleInput = {
  accountNumber: Scalars['String']['input'];
};

export type EnergySbDateInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export enum EnergySbPlatform {
  PlatformApp = 'PLATFORM_APP',
  PlatformMyAccount = 'PLATFORM_MY_ACCOUNT',
  PlatformUnknown = 'PLATFORM_UNKNOWN',
  PlatformWeb = 'PLATFORM_WEB'
}

export type EnergySbRegisterInterestInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  interested: Scalars['Boolean']['input'];
  reason?: InputMaybe<EnergySbRegisterInterestReason>;
};

export enum EnergySbRegisterInterestReason {
  Accuracy = 'ACCURACY',
  AutomaticSending = 'AUTOMATIC_SENDING',
  Control = 'CONTROL',
  Cost = 'COST',
  Health = 'HEALTH',
  Inconvenience = 'INCONVENIENCE',
  SecurityAndPrivacy = 'SECURITY_AND_PRIVACY',
  Technology = 'TECHNOLOGY',
  Unknown = 'UNKNOWN'
}

export type EnergySbRegisterInterestResponse = {
  __typename?: 'EnergySBRegisterInterestResponse';
  registrationId: Scalars['String']['output'];
};

export type EnergySbRescheduleAppointmentInput = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  bookingId: Scalars['String']['input'];
  contactDetails: EnergySbContactDetailsInput;
  platform?: InputMaybe<EnergySbPlatform>;
  slot: EnergySbSlotInput;
  vulnerabilityDetails: EnergySbVulnerabilityDetailsInput;
};

export type EnergySbRescheduleAppointmentResponse = {
  __typename?: 'EnergySBRescheduleAppointmentResponse';
  bookingId: Scalars['String']['output'];
};

export type EnergySbSlotInput = {
  date: EnergySbDateInput;
  endTime: Scalars['Int']['input'];
  startTime: Scalars['Int']['input'];
};

export enum EnergySbVulnerability {
  VulnerabilityForeignLanguageOnly = 'VULNERABILITY_FOREIGN_LANGUAGE_ONLY',
  VulnerabilityHearing = 'VULNERABILITY_HEARING',
  VulnerabilityIllness = 'VULNERABILITY_ILLNESS',
  VulnerabilityLearningDifficulties = 'VULNERABILITY_LEARNING_DIFFICULTIES',
  VulnerabilityOther = 'VULNERABILITY_OTHER',
  VulnerabilityPensionableAge = 'VULNERABILITY_PENSIONABLE_AGE',
  VulnerabilityPhysicalOrRestrictedMovement = 'VULNERABILITY_PHYSICAL_OR_RESTRICTED_MOVEMENT',
  VulnerabilitySight = 'VULNERABILITY_SIGHT',
  VulnerabilityUnknown = 'VULNERABILITY_UNKNOWN'
}

export type EnergySbVulnerabilityDetails = {
  __typename?: 'EnergySBVulnerabilityDetails';
  other?: Maybe<Scalars['String']['output']>;
  vulnerabilities?: Maybe<Array<EnergySbVulnerability>>;
};

export type EnergySbVulnerabilityDetailsInput = {
  other?: InputMaybe<Scalars['String']['input']>;
  vulnerabilities: Array<EnergySbVulnerability>;
};

export type EnergyService = {
  __typename?: 'EnergyService';
  agreement?: Maybe<EnergyAgreement>;
  billingPlatform?: Maybe<BillingPlatform>;
  eligibility?: Maybe<EnergyServiceEligibility>;
  endDateTime?: Maybe<Scalars['DateTime']['output']>;
  /**
   * named energyTariff to avoid naming conflicts with existing gql at the moment
   * @deprecated Use EnergyService.agreement.tariff
   */
  energyTariff?: Maybe<EnergyTariff>;
  fuelType: EnergyFuelType;
  id: Scalars['String']['output'];
  isLive?: Maybe<Scalars['Boolean']['output']>;
  meterpoint?: Maybe<MeterpointEnergy>;
  occupancy?: Maybe<Occupancy>;
  quotes?: Maybe<Array<EnergyQuote>>;
  reference: Scalars['String']['output'];
  scheduledStartDateTime?: Maybe<Scalars['DateTime']['output']>;
  /** FIT services will always return serviceState as UNKNOWN, as they are not validated */
  serviceState: EnergyServiceState;
  smartConsentLevel: SmartConsentLevel;
  startDateTime?: Maybe<Scalars['DateTime']['output']>;
};


export type EnergyServiceQuotesArgs = {
  input?: InputMaybe<EnergyQuotesInput>;
};

export type EnergyServiceEligibility = {
  __typename?: 'EnergyServiceEligibility';
  smartBooking: Scalars['Boolean']['output'];
};

export enum EnergyServiceState {
  /** * State to indicate the Service has been cancelled and will never be started. */
  Cancelled = 'CANCELLED',
  /** * State to indicate that the Service has been created */
  Created = 'CREATED',
  /** * State to indicate the Service has ended. */
  Ended = 'ENDED',
  /** * State to indicate the Service has failed validation */
  Held = 'HELD',
  /** * State to indicate the Service is live. */
  Started = 'STARTED',
  Unknown = 'UNKNOWN',
  /** * State to indicate that the Service has been validated. Not used for fabricated Services. */
  Validated = 'VALIDATED'
}

export type EnergyServiceTariffInput = {
  serviceId: Scalars['String']['input'];
  tariffId: Scalars['String']['input'];
};

export type EnergyServicesFilterInput = {
  /** This is how much time to include previously ended services in, in seconds. Defaults to 30 days (2592000 seconds) */
  includeEndedWithin?: InputMaybe<Scalars['Int']['input']>;
  /** Filter services by state. If not provided or empty, defaults to [CREATED, ENDED, HELD, STARTED, VALIDATED]. */
  states?: InputMaybe<Array<EnergyServiceState>>;
};

export type EnergySite = {
  __typename?: 'EnergySite';
  address: SiteAddress;
  id: Scalars['String']['output'];
};

export type EnergySiteAddress = {
  __typename?: 'EnergySiteAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  addressLine3?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  postcode: Scalars['String']['output'];
  premise?: Maybe<Scalars['String']['output']>;
  town: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
  uprn: Scalars['String']['output'];
};

export type EnergySmartBooking = {
  __typename?: 'EnergySmartBooking';
  appointments?: Maybe<Array<EnergySmartBookingAppointment>>;
  availableSlots?: Maybe<EnergySmartBookingAvailableSlots>;
  eligibility?: Maybe<EnergySmartBookingEligibility>;
  pointOfSale?: Maybe<EnergySmartBookingPointOfSale>;
};


export type EnergySmartBookingAppointmentsArgs = {
  input?: InputMaybe<EnergySmartBookingAppointmentsInput>;
};


export type EnergySmartBookingAvailableSlotsArgs = {
  dateRange: DateRangeInput;
};

export type EnergySmartBookingAppointment = {
  __typename?: 'EnergySmartBookingAppointment';
  contactDetails: EnergySmartBookingContactDetails;
  id: Scalars['String']['output'];
  siteAddress: SiteAddress;
  slot: TimeSlot;
  status: EnergySmartBookingAppointmentStatus;
  vulnerabilityDetails?: Maybe<EnergySmartBookingVulnerabilityDetails>;
};

export type EnergySmartBookingAppointmentInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  contactDetails: EnergySmartBookingContactDetailsInput;
  platform: EnergySmartBookingPlatform;
  pointOfSale?: InputMaybe<Scalars['Boolean']['input']>;
  slot: TimeSlotInput;
  vulnerabilityDetails: EnergySmartBookingVulnerabilityDetailsInput;
};

export type EnergySmartBookingAppointmentRescheduleInput = {
  bookingId: Scalars['String']['input'];
  contactDetails: EnergySmartBookingContactDetailsInput;
  platform: EnergySmartBookingPlatform;
  slot: TimeSlotInput;
  vulnerabilityDetails: EnergySmartBookingVulnerabilityDetailsInput;
};

export type EnergySmartBookingAppointmentResponse = {
  __typename?: 'EnergySmartBookingAppointmentResponse';
  data?: Maybe<SmartBookingAppointmentResponseData>;
  error?: Maybe<SmartBookingAppointmentFailure>;
  success: Scalars['Boolean']['output'];
};

export enum EnergySmartBookingAppointmentStatus {
  Aborted = 'ABORTED',
  Completed = 'COMPLETED',
  Scheduled = 'SCHEDULED',
  Unknown = 'UNKNOWN'
}

export type EnergySmartBookingAppointmentsInput = {
  status?: InputMaybe<EnergySmartBookingAppointmentStatus>;
};

export type EnergySmartBookingAvailableSlots = {
  __typename?: 'EnergySmartBookingAvailableSlots';
  error?: Maybe<EnergySmartBookingAvailableSlotsFailure>;
  slots?: Maybe<Array<TimeSlot>>;
  success: Scalars['Boolean']['output'];
};

export type EnergySmartBookingAvailableSlotsFailure = {
  __typename?: 'EnergySmartBookingAvailableSlotsFailure';
  code: EnergySmartBookingAvailableSlotsFailureReason;
  message: Scalars['String']['output'];
};

export enum EnergySmartBookingAvailableSlotsFailureReason {
  DataLoad = 'DATA_LOAD',
  SlotsNotAvailable = 'SLOTS_NOT_AVAILABLE',
  Unauthenticated = 'UNAUTHENTICATED'
}

export type EnergySmartBookingContactDetails = {
  __typename?: 'EnergySmartBookingContactDetails';
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type EnergySmartBookingContactDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type EnergySmartBookingEligibility = {
  __typename?: 'EnergySmartBookingEligibility';
  eligible: Scalars['Boolean']['output'];
  reasons?: Maybe<Array<EnergySmartBookingIneligibilityReasons>>;
};

export enum EnergySmartBookingIneligibilityReasons {
  AbortedBookings = 'ABORTED_BOOKINGS',
  AccountPsrVulnerabilities = 'ACCOUNT_PSR_VULNERABILITIES',
  AlreadySmart = 'ALREADY_SMART',
  AltHan = 'ALT_HAN',
  BookingCompleted = 'BOOKING_COMPLETED',
  BookingReferenceMissing = 'BOOKING_REFERENCE_MISSING',
  BookingScheduled = 'BOOKING_SCHEDULED',
  ComplexTariff = 'COMPLEX_TARIFF',
  GasServiceOnly = 'GAS_SERVICE_ONLY',
  MeterLargeCapacity = 'METER_LARGE_CAPACITY',
  MissingMeterpointData = 'MISSING_METERPOINT_DATA',
  MissingMeterData = 'MISSING_METER_DATA',
  MissingSiteData = 'MISSING_SITE_DATA',
  NotActive = 'NOT_ACTIVE',
  NoWanCoverage = 'NO_WAN_COVERAGE',
  SmartBookingOptOut = 'SMART_BOOKING_OPT_OUT',
  Unknown = 'UNKNOWN'
}

export enum EnergySmartBookingPlatform {
  App = 'APP',
  MyAccount = 'MY_ACCOUNT',
  Unknown = 'UNKNOWN',
  Web = 'WEB'
}

export type EnergySmartBookingPointOfSale = {
  __typename?: 'EnergySmartBookingPointOfSale';
  availableSlots?: Maybe<EnergySmartBookingAvailableSlots>;
  customer: EnergySmartBookingPointOfSaleCustomer;
};


export type EnergySmartBookingPointOfSaleAvailableSlotsArgs = {
  dateRange: DateRangeInput;
};


export type EnergySmartBookingPointOfSaleCustomerArgs = {
  accountNumber: Scalars['String']['input'];
};

export type EnergySmartBookingPointOfSaleCustomer = {
  __typename?: 'EnergySmartBookingPointOfSaleCustomer';
  accountNumber: Scalars['String']['output'];
  contactDetails: EnergySmartBookingContactDetails;
  siteAddress: SiteAddress;
};

export type EnergySmartBookingRegisterInterestInput = {
  interested: Scalars['Boolean']['input'];
  reason?: InputMaybe<EnergySmartBookingRegisterInterestReason>;
};

export enum EnergySmartBookingRegisterInterestReason {
  Accuracy = 'ACCURACY',
  AutomaticSending = 'AUTOMATIC_SENDING',
  Control = 'CONTROL',
  Cost = 'COST',
  Health = 'HEALTH',
  Inconvenience = 'INCONVENIENCE',
  SecurityAndPrivacy = 'SECURITY_AND_PRIVACY',
  Technology = 'TECHNOLOGY',
  Unknown = 'UNKNOWN'
}

export type EnergySmartBookingRegisterInterestResponse = {
  __typename?: 'EnergySmartBookingRegisterInterestResponse';
  data?: Maybe<EnergySmartBookingRegisterInterestResponseData>;
  error?: Maybe<SmartBookingAppointmentFailure>;
  success: Scalars['Boolean']['output'];
};

export type EnergySmartBookingRegisterInterestResponseData = {
  __typename?: 'EnergySmartBookingRegisterInterestResponseData';
  registrationId: Scalars['String']['output'];
};

export enum EnergySmartBookingVulnerabilities {
  ForeignLanguageOnly = 'FOREIGN_LANGUAGE_ONLY',
  Hearing = 'HEARING',
  Illness = 'ILLNESS',
  LearningDifficulties = 'LEARNING_DIFFICULTIES',
  Other = 'OTHER',
  PensionableAge = 'PENSIONABLE_AGE',
  PhysicalOrRestrictedMovement = 'PHYSICAL_OR_RESTRICTED_MOVEMENT',
  Sight = 'SIGHT',
  Unknown = 'UNKNOWN'
}

export type EnergySmartBookingVulnerabilityDetails = {
  __typename?: 'EnergySmartBookingVulnerabilityDetails';
  other?: Maybe<Scalars['String']['output']>;
  vulnerabilities?: Maybe<Array<EnergySmartBookingVulnerabilities>>;
};

export type EnergySmartBookingVulnerabilityDetailsInput = {
  other?: InputMaybe<Scalars['String']['input']>;
  vulnerabilities?: InputMaybe<Array<EnergySmartBookingVulnerabilities>>;
};

export enum EnergySupplyType {
  Electricity = 'ELECTRICITY',
  Gas = 'GAS',
  Unknown = 'UNKNOWN'
}

export type EnergyTariff = {
  __typename?: 'EnergyTariff';
  accountType: EnergyTariffAccountType;
  description: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  effectiveDates?: Maybe<TariffEffectiveDates>;
  id: Scalars['String']['output'];
  isElectricVehicleTariff?: Maybe<Scalars['Boolean']['output']>;
  meteringType: EnergyTariffMeteringType;
  name: Scalars['String']['output'];
  paymentType: EnergyTariffPaymentType;
  product: EnergyTariffProduct;
  supplyType: EnergySupplyType;
  tariffType: EnergyTariffType;
  termMonths?: Maybe<Scalars['Int']['output']>;
};

export enum EnergyTariffAccountType {
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL',
  Unknown = 'UNKNOWN'
}

export enum EnergyTariffMeteringType {
  E7 = 'E7',
  Gas = 'GAS',
  Gd = 'GD',
  Gde3R = 'GDE3R',
  Storage = 'STORAGE',
  StorageS3R = 'STORAGE_S3R',
  Unknown = 'UNKNOWN'
}

export enum EnergyTariffPaymentType {
  Cash = 'CASH',
  DirectDebit = 'DIRECT_DEBIT',
  Prepayment = 'PREPAYMENT',
  Unknown = 'UNKNOWN'
}

export enum EnergyTariffProduct {
  Ev = 'EV',
  Fit = 'FIT',
  Fixed = 'FIXED',
  Prepay = 'PREPAY',
  Seg = 'SEG',
  Svt = 'SVT',
  Tracker = 'TRACKER',
  Unknown = 'UNKNOWN'
}

export type EnergyTariffRate = {
  __typename?: 'EnergyTariffRate';
  name: Scalars['String']['output'];
  pencePerKilowattHour: Scalars['Float']['output'];
  pencePerKilowattHourRounded: Scalars['Float']['output'];
};

export type EnergyTariffSwitchResponse = {
  __typename?: 'EnergyTariffSwitchResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum EnergyTariffType {
  Fixed = 'FIXED',
  Unknown = 'UNKNOWN',
  Variable = 'VARIABLE'
}

export type EnergyTariffsInput = {
  accountType?: InputMaybe<EnergyTariffAccountType>;
  paymentType?: InputMaybe<EnergyTariffPaymentType>;
  tariffType?: InputMaybe<EnergyTariffType>;
};

export type EnergyUw4BAccount = {
  __typename?: 'EnergyUW4BAccount';
  accountId: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  accountType: EnergyUw4BAccountType;
};

export type EnergyUw4BAccountInput = {
  accountId: Scalars['String']['input'];
};

export enum EnergyUw4BAccountType {
  Business = 'BUSINESS',
  Residential = 'RESIDENTIAL',
  Unspecified = 'UNSPECIFIED'
}

export type EnergyUw4BCompany = {
  __typename?: 'EnergyUW4BCompany';
  companyNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sic: Array<EnergyUw4BsicCode>;
};

export type EnergyUw4BCompanyInput = {
  companyNumber: Scalars['String']['input'];
};

export type EnergyUw4BsicCode = {
  __typename?: 'EnergyUW4BSICCode';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  riskLevel: EnergyUw4BsicCodeRiskLevel;
};

export enum EnergyUw4BsicCodeRiskLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  NotFound = 'NOT_FOUND',
  NoRisk = 'NO_RISK'
}

export type EnergyUnitRate = {
  __typename?: 'EnergyUnitRate';
  rateInPence: Scalars['String']['output'];
  type: EnergyUnitRateType;
};

export enum EnergyUnitRateType {
  Day = 'DAY',
  Gas = 'GAS',
  Night = 'NIGHT',
  Standard = 'STANDARD',
  Unknown = 'UNKNOWN'
}

export type EnergyUsage = {
  __typename?: 'EnergyUsage';
  /** The type of this usage (e.g day/night/standard) corresponding to a register on the meter. */
  type: EnergyUnitRateType;
  /** Estimated annual usage for this register (in kWh) */
  usage: Scalars['Int']['output'];
};

export enum EquipmentStatus {
  AwaitingDispatch = 'AWAITING_DISPATCH',
  Delayed = 'DELAYED',
  Delivered = 'DELIVERED',
  Dispatched = 'DISPATCHED'
}

export enum EvTariffIneligibilityReason {
  AccountInDebt = 'ACCOUNT_IN_DEBT',
  MeterNotSmartMeter = 'METER_NOT_SMART_METER',
  SmartMeterModeNotCredit = 'SMART_METER_MODE_NOT_CREDIT',
  SmartMeterNotCommunicating = 'SMART_METER_NOT_COMMUNICATING',
  Unknown = 'UNKNOWN',
  VehicleNotElectric = 'VEHICLE_NOT_ELECTRIC',
  VehicleNotFound = 'VEHICLE_NOT_FOUND',
  VehicleNotTaxed = 'VEHICLE_NOT_TAXED'
}

export type Expiry = {
  __typename?: 'Expiry';
  month: Scalars['String']['output'];
  year: Scalars['String']['output'];
};

export enum FaultLocation {
  FaultLocationInsideOfHome = 'FAULT_LOCATION_INSIDE_OF_HOME',
  FaultLocationOutsideOfHome = 'FAULT_LOCATION_OUTSIDE_OF_HOME'
}

export enum Feedback {
  Errors = 'ERRORS',
  Inaccurate = 'INACCURATE',
  Irrelevant = 'IRRELEVANT',
  MissingInfo = 'MISSING_INFO',
  Other = 'OTHER',
  Unclear = 'UNCLEAR'
}

export type FinanceAccount = {
  __typename?: 'FinanceAccount';
  dueBalance: FinanceDueBalance;
  id: Scalars['String']['output'];
  overdueBalance: FinanceOverdueBalance;
};

/** The possible currencies */
export enum FinanceCurrency {
  Gbp = 'GBP',
  None = 'NONE'
}

/** The amount of due balance */
export type FinanceDueBalance = {
  __typename?: 'FinanceDueBalance';
  currency: FinanceCurrency;
  showNotification: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

/** The amount of overdue balance */
export type FinanceOverdueBalance = {
  __typename?: 'FinanceOverdueBalance';
  currency: FinanceCurrency;
  showNotification: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type FinancePaymentMethod = {
  __typename?: 'FinancePaymentMethod';
  createdAt: Scalars['Time']['output'];
  details: FinancePaymentMethodDetails;
  token: Scalars['UUID']['output'];
  type: FinancePaymentMethodType;
};

export type FinancePaymentMethodDetails = CardPaymentMethod | OpenBankingPaymentMethod;

export enum FinancePaymentMethodType {
  Card = 'CARD',
  OpenBanking = 'OPEN_BANKING'
}

export type FinanceQuery = {
  __typename?: 'FinanceQuery';
  account: FinanceAccount;
};


export type FinanceQueryAccountArgs = {
  id: Scalars['String']['input'];
};

export type FixedLineAddress = {
  __typename?: 'FixedLineAddress';
  alk: Scalars['String']['output'];
  building_name: Scalars['String']['output'];
  building_number: Scalars['String']['output'];
  county: Scalars['String']['output'];
  css_district_code: Scalars['String']['output'];
  department: Scalars['String']['output'];
  dependent_locality: Scalars['String']['output'];
  dependent_thoroughfare: Scalars['String']['output'];
  double_dependent_locality: Scalars['String']['output'];
  locality: Scalars['String']['output'];
  organisation_name: Scalars['String']['output'];
  po_box: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  record_source: FixedLineAddressSource;
  sub_building: Scalars['String']['output'];
  thoroughfare: Scalars['String']['output'];
  town: Scalars['String']['output'];
  uprn: Scalars['String']['output'];
};

export enum FixedLineAddressSource {
  Openreach = 'OPENREACH',
  RoyalMail = 'ROYAL_MAIL',
  Unknown = 'UNKNOWN',
  UserDefined = 'USER_DEFINED'
}

export type FixedLineAppointment = {
  __typename?: 'FixedLineAppointment';
  appointmentSlotFrom?: Maybe<Scalars['DateTime']['output']>;
  appointmentSlotTo?: Maybe<Scalars['DateTime']['output']>;
  fixedLineAppointmentStatus?: Maybe<FixedLineAppointmentStatus>;
  hasChanged?: Maybe<Scalars['Boolean']['output']>;
};

export type FixedLineAppointmentDetails = {
  id: Scalars['String']['input'];
};

export enum FixedLineAppointmentStatus {
  FixedLineAppointmentStatusAwaitingConfirmation = 'FIXED_LINE_APPOINTMENT_STATUS_AWAITING_CONFIRMATION',
  FixedLineAppointmentStatusConfirmed = 'FIXED_LINE_APPOINTMENT_STATUS_CONFIRMED',
  FixedLineAppointmentStatusUnspecified = 'FIXED_LINE_APPOINTMENT_STATUS_UNSPECIFIED'
}

export type FixedLineBroadbandCredentials = {
  __typename?: 'FixedLineBroadbandCredentials';
  password: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

export type FixedLineBroadbandDetailsResponse = {
  __typename?: 'FixedLineBroadbandDetailsResponse';
  equipment_package_details: Scalars['String']['output'];
  equipment_package_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  service_reference: Scalars['String']['output'];
  show_webmail: Scalars['Boolean']['output'];
  status: FixedLineMyServicesBroadbandStatus;
};

export type FixedLineBroadbandEquipment = {
  router?: InputMaybe<FixedLineRouter>;
  whole_home_wifi?: InputMaybe<FixedLineWholeHomeWifi>;
};

export type FixedLineBroadbandQuoteDetails = {
  __typename?: 'FixedLineBroadbandQuoteDetails';
  contract_length?: Maybe<Scalars['Int']['output']>;
  minimum_term?: Maybe<Scalars['Int']['output']>;
  speeds: Array<Maybe<FixedLineBroadbandSpeeds>>;
};

export enum FixedLineBroadbandSpeedType {
  BusinessThroughputOffpeak = 'BUSINESS_THROUGHPUT_OFFPEAK',
  BusinessThroughputPeak = 'BUSINESS_THROUGHPUT_PEAK',
  Defaults = 'DEFAULTS',
  ResidentialThroughputOffpeak = 'RESIDENTIAL_THROUGHPUT_OFFPEAK',
  ResidentialThroughputPeak = 'RESIDENTIAL_THROUGHPUT_PEAK',
  Sync = 'SYNC',
  Unknown = 'UNKNOWN'
}

export type FixedLineBroadbandSpeeds = {
  __typename?: 'FixedLineBroadbandSpeeds';
  downstream_average: Scalars['String']['output'];
  downstream_max: Scalars['String']['output'];
  downstream_min: Scalars['String']['output'];
  guaranteed_downstream: Scalars['String']['output'];
  guaranteed_upstream: Scalars['String']['output'];
  type: FixedLineBroadbandSpeedType;
  upstream_average: Scalars['String']['output'];
  upstream_max: Scalars['String']['output'];
  upstream_min: Scalars['String']['output'];
};

export type FixedLineCallBundleAvailabilityResponse = {
  __typename?: 'FixedLineCallBundleAvailabilityResponse';
  bundle_details?: Maybe<Array<Maybe<CallBundleDetails>>>;
};

export type FixedLineCallingBundles = {
  __typename?: 'FixedLineCallingBundles';
  international_saver: Scalars['Boolean']['output'];
  off_peak_saver: Scalars['Boolean']['output'];
  peak_saver: Scalars['Boolean']['output'];
};

export type FixedLineCallingFeatures = {
  caller_display: Scalars['Boolean']['input'];
  ex_directory: Scalars['Boolean']['input'];
  number_withheld: Scalars['Boolean']['input'];
  off_peak_saver: Scalars['Boolean']['input'];
  peak_saver: Scalars['Boolean']['input'];
  telephone_preference_service: Scalars['Boolean']['input'];
};

export type FixedLineContractRenewalDate = {
  current_supplier: Scalars['String']['input'];
  end_date: Scalars['String']['input'];
};

export type FixedLineContractRenewalDateResponse = {
  __typename?: 'FixedLineContractRenewalDateResponse';
  end_date: Scalars['String']['output'];
};

export type FixedLineDiagnostics = {
  __typename?: 'FixedLineDiagnostics';
  activeLineTestID: Scalars['String']['output'];
  hasOpenFault: Scalars['Boolean']['output'];
  lineTestEligible: Scalars['Boolean']['output'];
};

export type FixedLineEeccContractResponse = {
  __typename?: 'FixedLineEeccContractResponse';
  created_at: Scalars['String']['output'];
  download_link: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type FixedLineEquipment = {
  __typename?: 'FixedLineEquipment';
  equipment: FixedLineEquipmentType;
  monthly_cost: FixedLineMoney;
};

export type FixedLineEquipmentQuote = {
  __typename?: 'FixedLineEquipmentQuote';
  account_number: Scalars['String']['output'];
  available_equipment?: Maybe<Array<FixedLineEquipment>>;
  created_at: Scalars['String']['output'];
  customer_name: Scalars['String']['output'];
  delivery_address: FixedLineAddress;
  existing_equipment?: Maybe<Array<FixedLineEquipment>>;
  id: Scalars['String']['output'];
  previous_monthly_cost: FixedLineMoney;
  selected_equipment?: Maybe<Array<FixedLineEquipment>>;
  total_monthly_cost: FixedLineMoney;
  total_postage_cost: FixedLineMoney;
  updated_at: Scalars['String']['output'];
};

export enum FixedLineEquipmentType {
  EeroV6 = 'EERO_V6',
  MediaAccessTg588VV2 = 'MEDIA_ACCESS_TG588V_V2',
  TechnicolorDga0122 = 'TECHNICOLOR_DGA0122',
  TechnicolorDga4134 = 'TECHNICOLOR_DGA4134'
}

export enum FixedLineEquipmentUpgradeAvailability {
  Available = 'AVAILABLE',
  UnavailableAtEquipmentLimit = 'UNAVAILABLE_AT_EQUIPMENT_LIMIT',
  UnavailableInDebt = 'UNAVAILABLE_IN_DEBT',
  UnavailableNoBroadbandService = 'UNAVAILABLE_NO_BROADBAND_SERVICE',
  UnavailableUpgradeInLast_48Hours = 'UNAVAILABLE_UPGRADE_IN_LAST_48_HOURS'
}

export type FixedLineEquipmentUpgradeAvailabilityResponse = {
  __typename?: 'FixedLineEquipmentUpgradeAvailabilityResponse';
  available: FixedLineEquipmentUpgradeAvailability;
};

export type FixedLineGetAllLineTestResultsInput = {
  service_id?: InputMaybe<Scalars['String']['input']>;
};

export type FixedLineGetAllLineTestResultsResponse = {
  __typename?: 'FixedLineGetAllLineTestResultsResponse';
  tests: Array<FixedLineGetLineTestResultResponse>;
};

export type FixedLineGetLineTestResultResponse = {
  __typename?: 'FixedLineGetLineTestResultResponse';
  created_at?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  fault_location?: Maybe<FaultLocation>;
  result?: Maybe<LineTestResult>;
  service_id: Scalars['String']['output'];
  status?: Maybe<LineTestStatus>;
  test_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
};

export type FixedLineGetLineTestTimelineInput = {
  service_id: Scalars['String']['input'];
  test_id: Scalars['String']['input'];
};

export type FixedLineGetLineTestTimelineResponse = {
  __typename?: 'FixedLineGetLineTestTimelineResponse';
  currentStep: LineTestTimelineStep;
  hasCustomerFeedback: Scalars['Boolean']['output'];
  steps: Array<Maybe<FixedLineLineTestTimelineStep>>;
};

export type FixedLineHomephoneDetailsResponse = {
  __typename?: 'FixedLineHomephoneDetailsResponse';
  calling_bundles?: Maybe<Array<Maybe<CallBundle>>>;
  id: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  service_reference: Scalars['String']['output'];
  status: FixedLineMyServicesHomephoneStatus;
};

export type FixedLineIntegrationIssues = IntegrationIssues & {
  __typename?: 'FixedLineIntegrationIssues';
  appointmentStatusUpdates?: Maybe<Scalars['Boolean']['output']>;
  subProductStatusUpdates?: Maybe<Scalars['Boolean']['output']>;
};

export type FixedLineLineCharacteristics = {
  access_line_key: Scalars['String']['input'];
  cli?: InputMaybe<Scalars['String']['input']>;
  css_district_code: Scalars['String']['input'];
  is_virgin_media_customer?: InputMaybe<Scalars['Boolean']['input']>;
  requested_telephone_number?: InputMaybe<Scalars['String']['input']>;
};

export type FixedLineLineTestTimelineStep = {
  __typename?: 'FixedLineLineTestTimelineStep';
  body: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  step: LineTestTimelineStep;
};

export type FixedLineMoney = {
  __typename?: 'FixedLineMoney';
  amount: Scalars['String']['output'];
  currency_code: Scalars['String']['output'];
};

export enum FixedLineMyServicesBroadbandStatus {
  Live = 'LIVE',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type FixedLineMyServicesEquipment = {
  __typename?: 'FixedLineMyServicesEquipment';
  description: Scalars['String']['output'];
  equipment_type: FixedLineMyServicesEquipmentType;
  quantity: Scalars['Int']['output'];
  serial_number: Scalars['String']['output'];
};

export enum FixedLineMyServicesEquipmentType {
  Eero = 'EERO',
  Router = 'ROUTER',
  Unknown = 'UNKNOWN'
}

export enum FixedLineMyServicesHomephoneStatus {
  Live = 'LIVE',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type FixedLineMyServicesResponse = {
  __typename?: 'FixedLineMyServicesResponse';
  services?: Maybe<Array<FixedLineMyServicesService>>;
};

export type FixedLineMyServicesService = {
  __typename?: 'FixedLineMyServicesService';
  id: Scalars['String']['output'];
  live_date: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  reference: Scalars['String']['output'];
  status: FixedLineMyServicesServiceStatus;
  type: FixedLineMyServicesServiceType;
};

export enum FixedLineMyServicesServiceStatus {
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Live = 'LIVE',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type FixedLineMyServicesServiceType = FixedLineMyServicesServiceTypeBroadband | FixedLineMyServicesServiceTypeVoice;

export type FixedLineMyServicesServiceTypeBroadband = {
  __typename?: 'FixedLineMyServicesServiceTypeBroadband';
  contract_end_date: Scalars['String']['output'];
  equipment?: Maybe<Array<FixedLineMyServicesEquipment>>;
};

export type FixedLineMyServicesServiceTypeVoice = {
  __typename?: 'FixedLineMyServicesServiceTypeVoice';
  bundle_change_in_progress: Scalars['Boolean']['output'];
  call_bundles?: Maybe<Array<Scalars['String']['output']>>;
  calling_bundles?: Maybe<FixedLineCallingBundles>;
  calling_features?: Maybe<Array<Scalars['String']['output']>>;
  equipment: FixedLineMyServicesEquipment;
};

export type FixedLinePartialAddress = {
  alk?: InputMaybe<Scalars['String']['input']>;
  building_name?: InputMaybe<Scalars['String']['input']>;
  building_number?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  css_district_code?: InputMaybe<Scalars['String']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  dependent_locality?: InputMaybe<Scalars['String']['input']>;
  dependent_thoroughfare?: InputMaybe<Scalars['String']['input']>;
  double_dependent_locality?: InputMaybe<Scalars['String']['input']>;
  locality?: InputMaybe<Scalars['String']['input']>;
  organisation_name?: InputMaybe<Scalars['String']['input']>;
  po_box?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  sub_building?: InputMaybe<Scalars['String']['input']>;
  thoroughfare?: InputMaybe<Scalars['String']['input']>;
  town?: InputMaybe<Scalars['String']['input']>;
  uprn?: InputMaybe<Scalars['String']['input']>;
};

export type FixedLineQuote = {
  __typename?: 'FixedLineQuote';
  appointmentRequired?: Maybe<Scalars['Boolean']['output']>;
  charges?: Maybe<Array<Maybe<FixedLineQuoteCharge>>>;
  product: FixedLineQuoteProduct;
  quote_id: Scalars['String']['output'];
  requestedCompletionDate?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  requestedDateRequired?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<FixedLineQuoteStatus>;
  switching?: Maybe<FixedLineQuoteSwitching>;
  tryBeforeYouBuyEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type FixedLineQuoteCharge = {
  __typename?: 'FixedLineQuoteCharge';
  amount: Scalars['String']['output'];
  description: Scalars['String']['output'];
  instalments: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: FixedLineQuoteChargeType;
};

export enum FixedLineQuoteChargeType {
  Addon = 'ADDON',
  Delivery = 'DELIVERY',
  Equipment = 'EQUIPMENT',
  Installation = 'INSTALLATION',
  Service = 'SERVICE',
  Subservice = 'SUBSERVICE',
  Unknown = 'UNKNOWN'
}

export type FixedLineQuoteProduct = {
  __typename?: 'FixedLineQuoteProduct';
  broadband_only: Scalars['Boolean']['output'];
  description: Scalars['String']['output'];
  details: FixedLineBroadbandQuoteDetails;
  include_voip?: Maybe<Scalars['Boolean']['output']>;
  landline_type?: Maybe<LandlineType>;
  name: Scalars['String']['output'];
  product_class: Scalars['String']['output'];
  product_id: Scalars['String']['output'];
  sub_products?: Maybe<Array<FixedLineQuoteProduct>>;
};

export type FixedLineQuoteRequest = {
  address?: InputMaybe<FixedLinePartialAddress>;
  appointment?: InputMaybe<FixedLineAppointmentDetails>;
  basket_id?: InputMaybe<Scalars['String']['input']>;
  broadband_equipment?: InputMaybe<FixedLineBroadbandEquipment>;
  calling_features?: InputMaybe<FixedLineCallingFeatures>;
  include_voip?: InputMaybe<Scalars['Boolean']['input']>;
  is_customer_vulnerable?: InputMaybe<Scalars['Boolean']['input']>;
  line_characteristics: FixedLineLineCharacteristics;
  requested_completion_date?: InputMaybe<Scalars['FixedLineDateTimeRFC3339']['input']>;
  switching?: InputMaybe<FixedLineSwitching>;
};

export type FixedLineQuoteResponse = {
  __typename?: 'FixedLineQuoteResponse';
  basket_id: Scalars['String']['output'];
  quotes?: Maybe<Array<Maybe<FixedLineQuote>>>;
  status: FixedLineQuoteResponseStatus;
};

export enum FixedLineQuoteResponseStatus {
  ContactDetailsMissing = 'CONTACT_DETAILS_MISSING',
  Unspecified = 'UNSPECIFIED'
}

export type FixedLineQuoteStatus = {
  __typename?: 'FixedLineQuoteStatus';
  description?: Maybe<Scalars['String']['output']>;
  status: FixedLineQuoteStatusEnum;
};

export enum FixedLineQuoteStatusEnum {
  Incomplete = 'INCOMPLETE',
  Ineligible = 'INELIGIBLE',
  Orderable = 'ORDERABLE',
  Unspecified = 'UNSPECIFIED'
}

export type FixedLineQuoteSwitching = {
  __typename?: 'FixedLineQuoteSwitching';
  explicit_consent?: Maybe<Scalars['Boolean']['output']>;
  losing_provider?: Maybe<Scalars['String']['output']>;
};

export enum FixedLineRouter {
  None = 'NONE',
  WifiHub = 'WIFI_HUB'
}

export type FixedLineService = DexOrderService & {
  __typename?: 'FixedLineService';
  estimatedDate?: Maybe<Scalars['Date']['output']>;
  fixedLineAppointment?: Maybe<FixedLineAppointment>;
  hasIntegrationIssues?: Maybe<FixedLineIntegrationIssues>;
  lineItemId: Scalars['ID']['output'];
  product?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['ID']['output'];
  serviceStatus: DexOrderServiceStatus;
  serviceType: DexOrderServiceType;
  statusReason?: Maybe<Scalars['String']['output']>;
  subproducts?: Maybe<Array<Maybe<DexOrderSubproduct>>>;
};

export type FixedLineServiceException = {
  __typename?: 'FixedLineServiceException';
  code: Scalars['String']['output'];
  created_at?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  last_updated_at?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FixedLineSubProductRequest = {
  products?: InputMaybe<Array<CallBundleType>>;
  service_id: Scalars['String']['input'];
};

export type FixedLineSubProductResponse = {
  __typename?: 'FixedLineSubProductResponse';
  start_date?: Maybe<Scalars['FixedLineDateTimeRFC3339']['output']>;
};

export type FixedLineSwitching = {
  correlation_id?: InputMaybe<Scalars['String']['input']>;
  explicit_consent?: InputMaybe<Scalars['Boolean']['input']>;
  losing_provider?: InputMaybe<Scalars['String']['input']>;
  losing_provider_account_number?: InputMaybe<Scalars['String']['input']>;
  switch_order_reference?: InputMaybe<Scalars['String']['input']>;
};

export type FixedLineWholeHomeWifi = {
  num_eeros: Scalars['Int']['input'];
};

export enum FlowType {
  NotSpecified = 'NOT_SPECIFIED',
  Purchase = 'PURCHASE',
  Verification = 'VERIFICATION'
}

export type GetFirstCustomerTrackingResult = {
  __typename?: 'GetFirstCustomerTrackingResult';
  recodedAt: DateAndUtcTime;
};

export type GetFixedLineEquipmentQuoteRequest = {
  quote_id?: InputMaybe<Scalars['String']['input']>;
  selected_equipment?: InputMaybe<Array<FixedLineEquipmentType>>;
};

export type HelpAndSupportLink = {
  __typename?: 'HelpAndSupportLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type HelpAndSupportSubject = {
  __typename?: 'HelpAndSupportSubject';
  backofficeEmailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Added temporarily for the sake of migration within the mobile app. */
  id?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  links: Array<HelpAndSupportLink>;
  prioritiseCalling: Scalars['Boolean']['output'];
};

export type HelpAndSupportTopic = {
  __typename?: 'HelpAndSupportTopic';
  allowEmailAttachments: Scalars['Boolean']['output'];
  backofficeEmailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `name` instead. */
  category: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subjects: Array<HelpAndSupportSubject>;
};

export type HelpArticle = {
  __typename?: 'HelpArticle';
  content: HelpArticleContent;
  disableFeedback?: Maybe<Scalars['Boolean']['output']>;
  meta: HelpArticleMeta;
  related: Array<Maybe<RelatedHelpArticle>>;
  selfServeForms: Array<Maybe<SelfServeForm>>;
  /** @deprecated Use `selfServeForms` instead. */
  selfServeFormsV2: Array<Maybe<SelfServeFormV2>>;
  title: Scalars['String']['output'];
};


export type HelpArticleContentArgs = {
  platform: HelpArticlePlatform;
  theme: HelpArticleContentTheme;
};

export type HelpArticleCategory = {
  __typename?: 'HelpArticleCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subCategories?: Maybe<Array<HelpArticleCategory>>;
};

export type HelpArticleContent = {
  __typename?: 'HelpArticleContent';
  html: Scalars['String']['output'];
};

export enum HelpArticleContentTheme {
  Dark = 'DARK',
  Light = 'LIGHT',
  Unknown = 'UNKNOWN'
}

export enum HelpArticleFeedback {
  Errors = 'ERRORS',
  Inaccurate = 'INACCURATE',
  Irrelevant = 'IRRELEVANT',
  MissingInfo = 'MISSING_INFO',
  Other = 'OTHER',
  Unclear = 'UNCLEAR'
}

export type HelpArticleFeedbackInput = {
  articleID: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  customerAccountNumber: Scalars['String']['input'];
  feedback: HelpArticleFeedback;
  source: HelpArticlePlatform;
  submissionTime: Scalars['String']['input'];
};

export type HelpArticleMeta = {
  __typename?: 'HelpArticleMeta';
  category?: Maybe<HelpArticleCategory>;
  id: Scalars['String']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export enum HelpArticlePlatform {
  Mobile = 'MOBILE',
  Unknown = 'UNKNOWN',
  Web = 'WEB'
}

export enum HelpArticleSearchEngine {
  /** @deprecated No longer supported */
  ElasticSearch = 'ELASTIC_SEARCH',
  /** @deprecated No longer supported */
  Google = 'GOOGLE',
  /** @deprecated No longer supported */
  Unknown = 'UNKNOWN'
}

export type HelpArticleSearchInput = {
  categoryID?: InputMaybe<Scalars['String']['input']>;
  phrase?: InputMaybe<Scalars['String']['input']>;
  platform: HelpArticlePlatform;
  suggested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HelpArticleSearchResult = {
  __typename?: 'HelpArticleSearchResult';
  meta: HelpArticleMeta;
  title: Scalars['String']['output'];
};

export type HelpDecisionTree = {
  __typename?: 'HelpDecisionTree';
  roots: Array<HelpDecisionTreeRoot>;
};

export enum HelpDecisionTreeCategoryFilter {
  Broadband = 'BROADBAND'
}

export type HelpDecisionTreeNode = HelpDecisionTreeNodeArticle | HelpDecisionTreeNodeCategory;

export type HelpDecisionTreeNodeArticle = {
  __typename?: 'HelpDecisionTreeNodeArticle';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type HelpDecisionTreeNodeCategory = {
  __typename?: 'HelpDecisionTreeNodeCategory';
  children: Array<HelpDecisionTreeNode>;
  description: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
};

export type HelpDecisionTreeRoot = {
  __typename?: 'HelpDecisionTreeRoot';
  children: Array<HelpDecisionTreeNode>;
  heading: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
};

export type ImageFile = {
  __typename?: 'ImageFile';
  fileName: Scalars['String']['output'];
  resourceURL: Scalars['String']['output'];
  uploadedAt: Scalars['Int']['output'];
};

export type InitCardPaymentInput = {
  accountReference?: InputMaybe<Scalars['String']['input']>;
  browserInfo: Scalars['String']['input'];
  externalPaymentMethodToken?: InputMaybe<Scalars['String']['input']>;
  ip: Scalars['String']['input'];
  paymentMethodToken?: InputMaybe<Scalars['String']['input']>;
  paymentToken: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
  saveCard?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Insight = {
  __typename?: 'Insight';
  description: Scalars['String']['output'];
  id: InsightType;
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum InsightType {
  CashbackAverageMonthly = 'CASHBACK_AVERAGE_MONTHLY',
  CashbackAverageMonthlyIncrease = 'CASHBACK_AVERAGE_MONTHLY_INCREASE',
  CashbackHighestMonth = 'CASHBACK_HIGHEST_MONTH',
  CashbackHighestMonthRecord = 'CASHBACK_HIGHEST_MONTH_RECORD',
  CashbackLifetimeEarned = 'CASHBACK_LIFETIME_EARNED',
  CashbackYearlyEarned = 'CASHBACK_YEARLY_EARNED',
  CashbackYearlyEarnedComparison = 'CASHBACK_YEARLY_EARNED_COMPARISON'
}

export type InsuranceAccount = {
  __typename?: 'InsuranceAccount';
  address?: Maybe<InsuranceAddress>;
  commsPreference?: Maybe<InsuranceCommsPreference>;
  ctaPrompts?: Maybe<InsuranceCtaPrompts>;
  eligibility?: Maybe<InsuranceEligibility>;
  eligiblePromotions?: Maybe<Array<Maybe<InsurancePromotion>>>;
  holders?: Maybe<Array<Maybe<InsuranceAccountHolders>>>;
  homeQuotes?: Maybe<Array<Maybe<InsuranceHomeQuote>>>;
  homeQuotesV2?: Maybe<Array<Maybe<InsuranceHomeQuoteV2>>>;
  id: Scalars['String']['output'];
  joinDate?: Maybe<Scalars['String']['output']>;
  motorQuotes?: Maybe<Array<Maybe<InsuranceMotorQuote>>>;
  number: Scalars['String']['output'];
  paymentMethod?: Maybe<InsurancePaymentMethod>;
  policies?: Maybe<Array<Maybe<InsurancePolicy>>>;
  policyCount?: Maybe<InsurancePolicyCount>;
  productClaims?: Maybe<Array<Maybe<InsuranceProductClaim>>>;
  quotes?: Maybe<Array<Maybe<InsuranceQuote>>>;
};

export type InsuranceAccountHolders = {
  __typename?: 'InsuranceAccountHolders';
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type InsuranceAddress = {
  __typename?: 'InsuranceAddress';
  line1: Scalars['String']['output'];
  line2: Scalars['String']['output'];
  line3: Scalars['String']['output'];
  line4: Scalars['String']['output'];
  line5: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  uprn?: Maybe<Scalars['String']['output']>;
};

export type InsuranceAddressInput = {
  line1: Scalars['String']['input'];
  line2?: InputMaybe<Scalars['String']['input']>;
  line3?: InputMaybe<Scalars['String']['input']>;
  line4?: InputMaybe<Scalars['String']['input']>;
  line5?: InputMaybe<Scalars['String']['input']>;
  postcode: Scalars['String']['input'];
  uprn?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceAddressV2 = {
  __typename?: 'InsuranceAddressV2';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  house: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  street: Scalars['String']['output'];
  uprn?: Maybe<Scalars['String']['output']>;
};

export type InsuranceAddressV2Input = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  house: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
  street: Scalars['String']['input'];
  uprn?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceCtaPrompts = {
  __typename?: 'InsuranceCTAPrompts';
  collectExternalHomeInsuranceRenewalDate?: Maybe<Scalars['Boolean']['output']>;
  getHomeInsuranceQuote?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceCancellationBreakdown = {
  __typename?: 'InsuranceCancellationBreakdown';
  adminFee: Scalars['String']['output'];
  remainingPolicyPremium: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export enum InsuranceCannotQuoteReason {
  AccountAlreadyHasPolicy = 'ACCOUNT_ALREADY_HAS_POLICY',
  AccountDoesNotHaveDirectDebit = 'ACCOUNT_DOES_NOT_HAVE_DIRECT_DEBIT',
  AccountDoesNotHaveEmail = 'ACCOUNT_DOES_NOT_HAVE_EMAIL',
  AccountDoesNotHavePhone = 'ACCOUNT_DOES_NOT_HAVE_PHONE',
  AccountHasBadRating = 'ACCOUNT_HAS_BAD_RATING',
  AccountHasDept = 'ACCOUNT_HAS_DEPT',
  AccountHasNoServices = 'ACCOUNT_HAS_NO_SERVICES',
  AccountIsBarred = 'ACCOUNT_IS_BARRED',
  AccountIsBlacklisted = 'ACCOUNT_IS_BLACKLISTED',
  AccountIsDead = 'ACCOUNT_IS_DEAD',
  AccountIsNewPartner = 'ACCOUNT_IS_NEW_PARTNER',
  AccountIsNotResidential = 'ACCOUNT_IS_NOT_RESIDENTIAL',
  AccountTooOld = 'ACCOUNT_TOO_OLD',
  Unknown = 'UNKNOWN'
}

export type InsuranceCatalog = {
  __typename?: 'InsuranceCatalog';
  billProtector?: Maybe<InsuranceCatalogProduct>;
  boiler?: Maybe<InsuranceCatalogProduct>;
  boilerOneClaim?: Maybe<InsuranceCatalogProduct>;
  boilerTwoClaims?: Maybe<InsuranceCatalogProduct>;
  incomeProtector?: Maybe<InsuranceCatalogProduct>;
};

export type InsuranceCatalogProduct = {
  __typename?: 'InsuranceCatalogProduct';
  annualPremium: Scalars['String']['output'];
  monthlyPremium: Scalars['String']['output'];
  protectorProduct?: Maybe<InsuranceCatalogProtectorProduct>;
};

export type InsuranceCatalogProtectorProduct = {
  __typename?: 'InsuranceCatalogProtectorProduct';
  accidentalCoverPayout: Scalars['String']['output'];
  unemploymentBenefitPayout: Scalars['String']['output'];
};

export enum InsuranceClaimOutcome {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Settled = 'SETTLED',
  Unknown = 'UNKNOWN',
  Withdrawn = 'WITHDRAWN'
}

export enum InsuranceClaimStatus {
  Closed = 'CLOSED',
  Open = 'OPEN',
  Unknown = 'UNKNOWN'
}

export enum InsuranceCommsPreference {
  Email = 'EMAIL',
  Letter = 'LETTER',
  Unknown = 'UNKNOWN'
}

export type InsuranceCoverDetail = {
  __typename?: 'InsuranceCoverDetail';
  name: Scalars['String']['output'];
  section: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InsuranceCreateBoilerQuoteInput = {
  accountId: Scalars['String']['input'];
  address: InsuranceAddressInput;
  startDate: Scalars['DateTime']['input'];
};

export type InsuranceDevToolsFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type InsuranceDocument = {
  __typename?: 'InsuranceDocument';
  creationDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type InsuranceEligibility = {
  __typename?: 'InsuranceEligibility';
  collectExternalHomeInsuranceRenewalDate?: Maybe<Scalars['Boolean']['output']>;
  quoteBoilerInsurance?: Maybe<InsuranceQuoteEligibility>;
  quoteHomeInsurance?: Maybe<InsuranceQuoteEligibility>;
  quoteMotorInsurance?: Maybe<InsuranceQuoteEligibility>;
  quoteProtector?: Maybe<InsuranceQuoteEligibility>;
};

export type InsuranceExternalRenewalDate = {
  __typename?: 'InsuranceExternalRenewalDate';
  accountId: Scalars['String']['output'];
  capturedAt?: Maybe<Scalars['DateTime']['output']>;
  productClass?: Maybe<InsuranceProductClass>;
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
};

export type InsuranceHomeAddon = {
  __typename?: 'InsuranceHomeAddon';
  id: Scalars['String']['output'];
  price: Scalars['String']['output'];
  selected: Scalars['Boolean']['output'];
};

export type InsuranceHomeAddonInput = {
  id: Scalars['String']['input'];
  selected: Scalars['Boolean']['input'];
};

export enum InsuranceHomeAddonType {
  HomeEmergency = 'HOME_EMERGENCY',
  LegalExpenses = 'LEGAL_EXPENSES'
}

export type InsuranceHomeAddonV2 = {
  __typename?: 'InsuranceHomeAddonV2';
  applied: Scalars['Boolean']['output'];
  price: Scalars['String']['output'];
  type: InsuranceHomeAddonType;
};

export enum InsuranceHomeAlarmType {
  AudibleOnly = 'AUDIBLE_ONLY',
  BtAbc = 'BT_ABC',
  BtRedcare = 'BT_REDCARE',
  CentralStationDirectLine = 'CENTRAL_STATION_DIRECT_LINE',
  Line_999 = 'LINE_999',
  NacossSaib = 'NACOSS_SAIB',
  Other = 'OTHER'
}

export enum InsuranceHomeBicycleType {
  Mountain = 'MOUNTAIN',
  Racing = 'RACING',
  Tandem = 'TANDEM',
  Touring = 'TOURING'
}

export type InsuranceHomeBicycles = {
  __typename?: 'InsuranceHomeBicycles';
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InsuranceHomeBicycleType>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceHomeBicyclesInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InsuranceHomeBicycleType>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum InsuranceHomeBusinessUse {
  ClericalOnly = 'CLERICAL_ONLY',
  No = 'NO',
  Other = 'OTHER'
}

export enum InsuranceHomeBusinessVisitors {
  LessThan_20 = 'LESS_THAN_20',
  MoreThan_20 = 'MORE_THAN_20',
  None = 'NONE'
}

export enum InsuranceHomeChannel {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export enum InsuranceHomeClaimsStatus {
  Outstanding = 'OUTSTANDING',
  Settled = 'SETTLED'
}

export type InsuranceHomeCover = {
  __typename?: 'InsuranceHomeCover';
  accidentalDamageBuildings?: Maybe<Scalars['Boolean']['output']>;
  accidentalDamageContents?: Maybe<Scalars['Boolean']['output']>;
  bicycles?: Maybe<Array<Maybe<InsuranceHomeBicycles>>>;
  buildingClaimFreeYears?: Maybe<Scalars['Int']['output']>;
  buildingExcess?: Maybe<Scalars['Int']['output']>;
  contentsClaimFreeYears?: Maybe<Scalars['Int']['output']>;
  contentsExcess?: Maybe<Scalars['Int']['output']>;
  disclosures?: Maybe<InsuranceHomeDisclosures>;
  personalPossessions?: Maybe<InsuranceHomePersonalPossessions>;
  startDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<InsuranceHomeCoverType>;
};

export type InsuranceHomeCoverInput = {
  accidentalDamageBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  accidentalDamageContents?: InputMaybe<Scalars['Boolean']['input']>;
  bicycles?: InputMaybe<Array<InputMaybe<InsuranceHomeBicyclesInput>>>;
  buildingClaimFreeYears?: InputMaybe<Scalars['Int']['input']>;
  buildingExcess?: InputMaybe<Scalars['Int']['input']>;
  contentsClaimFreeYears?: InputMaybe<Scalars['Int']['input']>;
  contentsExcess?: InputMaybe<Scalars['Int']['input']>;
  disclosures?: InputMaybe<InsuranceHomeDisclosuresInput>;
  personalPossessions?: InputMaybe<InsuranceHomePersonalPossessionsInput>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<InsuranceHomeCoverType>;
};

export enum InsuranceHomeCoverType {
  Buildings = 'BUILDINGS',
  BuildingsContents = 'BUILDINGS_CONTENTS',
  Contents = 'CONTENTS'
}

export type InsuranceHomeDisclosures = {
  __typename?: 'InsuranceHomeDisclosures';
  criminalConvictions?: Maybe<Scalars['Boolean']['output']>;
  declaredBankrupt?: Maybe<Scalars['Boolean']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  noFlooding?: Maybe<Scalars['Boolean']['output']>;
  noSubsidenceLandslip?: Maybe<Scalars['Boolean']['output']>;
  previousPolicyConditions?: Maybe<Scalars['Boolean']['output']>;
  selfContainedProperty?: Maybe<Scalars['Boolean']['output']>;
  ukResident?: Maybe<Scalars['Boolean']['output']>;
  unsatisfiedCourtJudgment?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceHomeDisclosuresInput = {
  criminalConvictions?: InputMaybe<Scalars['Boolean']['input']>;
  declaredBankrupt?: InputMaybe<Scalars['Boolean']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  noFlooding?: InputMaybe<Scalars['Boolean']['input']>;
  noSubsidenceLandslip?: InputMaybe<Scalars['Boolean']['input']>;
  previousPolicyConditions?: InputMaybe<Scalars['Boolean']['input']>;
  selfContainedProperty?: InputMaybe<Scalars['Boolean']['input']>;
  ukResident?: InputMaybe<Scalars['Boolean']['input']>;
  unsatisfiedCourtJudgment?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InsuranceHomeDoorType {
  Bs3621 = 'BS3621',
  MorticeDeadlock = 'MORTICE_DEADLOCK',
  MorticeSecurityBolts = 'MORTICE_SECURITY_BOLTS',
  Multipoint = 'MULTIPOINT',
  Other = 'OTHER',
  SurfaceSecurityBolts = 'SURFACE_SECURITY_BOLTS'
}

export type InsuranceHomeEmployment = {
  __typename?: 'InsuranceHomeEmployment';
  fullTimeBusiness?: Maybe<Scalars['String']['output']>;
  fullTimeOccupation?: Maybe<Scalars['String']['output']>;
  partTimeBusiness?: Maybe<Scalars['String']['output']>;
  partTimeEmployment?: Maybe<Scalars['Boolean']['output']>;
  partTimeOccupation?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomeEmploymentInput = {
  fullTimeBusiness?: InputMaybe<Scalars['String']['input']>;
  fullTimeOccupation?: InputMaybe<Scalars['String']['input']>;
  partTimeBusiness?: InputMaybe<Scalars['String']['input']>;
  partTimeEmployment?: InputMaybe<Scalars['Boolean']['input']>;
  partTimeOccupation?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceHomeEndorsement = {
  __typename?: 'InsuranceHomeEndorsement';
  excessAmount: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InsuranceHomeEndorsementV2 = {
  __typename?: 'InsuranceHomeEndorsementV2';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InsuranceHomeExcess = {
  __typename?: 'InsuranceHomeExcess';
  compulsoryAmount: Scalars['String']['output'];
  label: Scalars['String']['output'];
  totalAmount: Scalars['String']['output'];
  voluntaryAmount: Scalars['String']['output'];
};

export type InsuranceHomeExcessV2 = {
  __typename?: 'InsuranceHomeExcessV2';
  amount: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export enum InsuranceHomeExitDoorType {
  Bs3621 = 'BS3621',
  MorticeDeadlock = 'MORTICE_DEADLOCK',
  Multipoint = 'MULTIPOINT',
  Other = 'OTHER'
}

export type InsuranceHomeHouseholdClaims = {
  __typename?: 'InsuranceHomeHouseholdClaims';
  amount?: Maybe<Scalars['String']['output']>;
  cover?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['Boolean']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  status?: Maybe<InsuranceHomeClaimsStatus>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomeHouseholdClaimsInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  cover?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<InsuranceHomeClaimsStatus>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceHomeInsurerQuote = {
  __typename?: 'InsuranceHomeInsurerQuote';
  annualPremium?: Maybe<Scalars['String']['output']>;
  annualPremiumExcAddons?: Maybe<Scalars['String']['output']>;
  coverDetails?: Maybe<Array<Maybe<InsuranceCoverDetail>>>;
  declined: Scalars['Boolean']['output'];
  declinedReason?: Maybe<Scalars['String']['output']>;
  endorsements?: Maybe<Array<Maybe<InsuranceHomeEndorsementV2>>>;
  excesses?: Maybe<Array<Maybe<InsuranceHomeExcessV2>>>;
  instalments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  insurer: Scalars['String']['output'];
};

export enum InsuranceHomeOwnership {
  OwnedOnMortgage = 'OWNED_ON_MORTGAGE',
  OwnedOutright = 'OWNED_OUTRIGHT',
  RentedFurnished = 'RENTED_FURNISHED',
  RentedUnfurnished = 'RENTED_UNFURNISHED',
  TiedOccupancyFurnished = 'TIED_OCCUPANCY_FURNISHED',
  TiedOccupancyUnfurnished = 'TIED_OCCUPANCY_UNFURNISHED'
}

export type InsuranceHomePersonalPossessions = {
  __typename?: 'InsuranceHomePersonalPossessions';
  specifiedItems?: Maybe<Array<Maybe<InsuranceHomeSpecifiedItem>>>;
  unspecifiedCover?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceHomePersonalPossessionsInput = {
  specifiedItems?: InputMaybe<Array<InputMaybe<InsuranceHomeSpecifiedItemInput>>>;
  unspecifiedCover?: InputMaybe<Scalars['Int']['input']>;
};

export type InsuranceHomePolicyHolder = {
  __typename?: 'InsuranceHomePolicyHolder';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employment?: Maybe<InsuranceHomeEmployment>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomePolicyHolderInput = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employment?: InputMaybe<InsuranceHomeEmploymentInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum InsuranceHomePolicyHolderType {
  JointPolicyHolder = 'JOINT_POLICY_HOLDER',
  JustMe = 'JUST_ME'
}

export type InsuranceHomeProperty = {
  __typename?: 'InsuranceHomeProperty';
  alarms?: Maybe<InsuranceHomePropertyAlarms>;
  construction?: Maybe<InsuranceHomePropertyConstruction>;
  details?: Maybe<InsuranceHomePropertyDetails>;
  locks?: Maybe<InsuranceHomePropertyLocks>;
  occupancy?: Maybe<InsuranceHomePropertyOccupancy>;
};

export type InsuranceHomePropertyAlarms = {
  __typename?: 'InsuranceHomePropertyAlarms';
  alarmMaintained?: Maybe<Scalars['Boolean']['output']>;
  alarmType?: Maybe<InsuranceHomeAlarmType>;
  hasAlarm?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceHomePropertyAlarmsInput = {
  alarmMaintained?: InputMaybe<Scalars['Boolean']['input']>;
  alarmType?: InputMaybe<InsuranceHomeAlarmType>;
  hasAlarm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceHomePropertyConstruction = {
  __typename?: 'InsuranceHomePropertyConstruction';
  architectureInterestCode?: Maybe<Scalars['String']['output']>;
  dateBuilt?: Maybe<Scalars['String']['output']>;
  flatRoofPercentage?: Maybe<Scalars['Int']['output']>;
  roofConstruction?: Maybe<Scalars['String']['output']>;
  wallConstruction?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<InsuranceHomeYearBuilt>;
};

export type InsuranceHomePropertyConstructionInput = {
  architectureInterestCode?: InputMaybe<Scalars['String']['input']>;
  dateBuilt?: InputMaybe<Scalars['String']['input']>;
  flatRoofPercentage?: InputMaybe<Scalars['Int']['input']>;
  roofConstruction?: InputMaybe<Scalars['String']['input']>;
  wallConstruction?: InputMaybe<Scalars['String']['input']>;
  yearBuilt?: InputMaybe<InsuranceHomeYearBuilt>;
};

export type InsuranceHomePropertyDetails = {
  __typename?: 'InsuranceHomePropertyDetails';
  numberBathrooms?: Maybe<Scalars['Int']['output']>;
  numberBedrooms?: Maybe<Scalars['Int']['output']>;
  numberOtherRooms?: Maybe<Scalars['Int']['output']>;
  ownershipStatus?: Maybe<InsuranceHomeOwnership>;
  type?: Maybe<InsuranceHomePropertyType>;
  typeCode?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomePropertyDetailsInput = {
  numberBathrooms?: InputMaybe<Scalars['Int']['input']>;
  numberBedrooms?: InputMaybe<Scalars['Int']['input']>;
  numberOtherRooms?: InputMaybe<Scalars['Int']['input']>;
  ownershipStatus?: InputMaybe<InsuranceHomeOwnership>;
  type?: InputMaybe<InsuranceHomePropertyType>;
  typeCode?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceHomePropertyInput = {
  alarms?: InputMaybe<InsuranceHomePropertyAlarmsInput>;
  construction?: InputMaybe<InsuranceHomePropertyConstructionInput>;
  details?: InputMaybe<InsuranceHomePropertyDetailsInput>;
  locks?: InputMaybe<InsuranceHomePropertyLocksInput>;
  occupancy?: InputMaybe<InsuranceHomePropertyOccupancyInput>;
};

export type InsuranceHomePropertyLocks = {
  __typename?: 'InsuranceHomePropertyLocks';
  finalExitDoorType?: Maybe<InsuranceHomeExitDoorType>;
  otherDoors?: Maybe<Scalars['Boolean']['output']>;
  otherDoorsType?: Maybe<InsuranceHomeDoorType>;
  patioDoors?: Maybe<Scalars['Boolean']['output']>;
  patioDoorsType?: Maybe<InsuranceHomeDoorType>;
  windowLocks?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceHomePropertyLocksInput = {
  finalExitDoorType?: InputMaybe<InsuranceHomeExitDoorType>;
  otherDoors?: InputMaybe<Scalars['Boolean']['input']>;
  otherDoorsType?: InputMaybe<InsuranceHomeDoorType>;
  patioDoors?: InputMaybe<Scalars['Boolean']['input']>;
  patioDoorsType?: InputMaybe<InsuranceHomeDoorType>;
  windowLocks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceHomePropertyOccupancy = {
  __typename?: 'InsuranceHomePropertyOccupancy';
  boarders?: Maybe<Scalars['Int']['output']>;
  businessChildMind?: Maybe<Scalars['Boolean']['output']>;
  businessUse?: Maybe<InsuranceHomeBusinessUse>;
  businessVisitors?: Maybe<InsuranceHomeBusinessVisitors>;
  let?: Maybe<Scalars['Boolean']['output']>;
  numberAdults?: Maybe<Scalars['Int']['output']>;
  numberChildren?: Maybe<Scalars['Int']['output']>;
  payingGuests?: Maybe<Scalars['Boolean']['output']>;
  smoker?: Maybe<Scalars['Boolean']['output']>;
  soleFamily?: Maybe<Scalars['Boolean']['output']>;
  unoccupied?: Maybe<Scalars['Boolean']['output']>;
  unoccupiedDays?: Maybe<InsuranceHomeUnoccupiedDays>;
  unoccupiedReason?: Maybe<InsuranceHomeUnoccupiedReason>;
};

export type InsuranceHomePropertyOccupancyInput = {
  boarders?: InputMaybe<Scalars['Int']['input']>;
  businessChildMind?: InputMaybe<Scalars['Boolean']['input']>;
  businessUse?: InputMaybe<InsuranceHomeBusinessUse>;
  businessVisitors?: InputMaybe<InsuranceHomeBusinessVisitors>;
  let?: InputMaybe<Scalars['Boolean']['input']>;
  numberAdults?: InputMaybe<Scalars['Int']['input']>;
  numberChildren?: InputMaybe<Scalars['Int']['input']>;
  payingGuests?: InputMaybe<Scalars['Boolean']['input']>;
  smoker?: InputMaybe<Scalars['Boolean']['input']>;
  soleFamily?: InputMaybe<Scalars['Boolean']['input']>;
  unoccupied?: InputMaybe<Scalars['Boolean']['input']>;
  unoccupiedDays?: InputMaybe<InsuranceHomeUnoccupiedDays>;
  unoccupiedReason?: InputMaybe<InsuranceHomeUnoccupiedReason>;
};

export enum InsuranceHomePropertyType {
  Bungalow = 'BUNGALOW',
  Flat = 'FLAT',
  House = 'HOUSE',
  Zz = 'ZZ'
}

export type InsuranceHomeQuote = {
  __typename?: 'InsuranceHomeQuote';
  accountId?: Maybe<Scalars['String']['output']>;
  addons?: Maybe<Array<Maybe<InsuranceHomeAddon>>>;
  address?: Maybe<InsuranceAddress>;
  annualPolicyPremium?: Maybe<Scalars['String']['output']>;
  annualPremium?: Maybe<Scalars['String']['output']>;
  converted: Scalars['Boolean']['output'];
  cover?: Maybe<InsuranceHomeCover>;
  createdDate: Scalars['DateTime']['output'];
  documents?: Maybe<Array<Maybe<InsuranceDocument>>>;
  endorsements?: Maybe<Array<Maybe<InsuranceHomeEndorsement>>>;
  excesses?: Maybe<Array<Maybe<InsuranceHomeExcess>>>;
  firstPayment?: Maybe<Scalars['String']['output']>;
  householdClaims?: Maybe<Array<Maybe<InsuranceHomeHouseholdClaims>>>;
  id: Scalars['String']['output'];
  insurer?: Maybe<InsuranceInsurer>;
  jointPolicyHolder?: Maybe<InsuranceHomePolicyHolder>;
  latestSubmissionDate: Scalars['DateTime']['output'];
  monthlyPolicyPremium?: Maybe<Scalars['String']['output']>;
  monthlyPremium?: Maybe<Scalars['String']['output']>;
  policyHolder?: Maybe<InsuranceHomePolicyHolderType>;
  previousPremium?: Maybe<Scalars['String']['output']>;
  previousProvider?: Maybe<Scalars['String']['output']>;
  primaryPolicyHolder?: Maybe<InsuranceHomePolicyHolder>;
  product: InsuranceProduct;
  property?: Maybe<InsuranceHomeProperty>;
  reference?: Maybe<Scalars['String']['output']>;
  selectedInsurer?: Maybe<Scalars['String']['output']>;
  status: InsuranceHomeQuoteStatus;
};

export enum InsuranceHomeQuoteStatus {
  Cancelled = 'CANCELLED',
  Converted = 'CONVERTED',
  Effective = 'EFFECTIVE',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export enum InsuranceHomeQuoteType {
  Mta = 'MTA',
  NewBusiness = 'NEW_BUSINESS',
  Renewal = 'RENEWAL'
}

export type InsuranceHomeQuoteV2 = {
  __typename?: 'InsuranceHomeQuoteV2';
  accountId: Scalars['String']['output'];
  addons?: Maybe<Array<Maybe<InsuranceHomeAddonV2>>>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<InsuranceDocument>>>;
  id: Scalars['String']['output'];
  insurerQuote?: Maybe<InsuranceHomeInsurerQuote>;
  mtaActionDate?: Maybe<Scalars['Date']['output']>;
  mtaEffectiveAt?: Maybe<Scalars['DateTime']['output']>;
  mtaParentQuoteId?: Maybe<Scalars['String']['output']>;
  parentPolicyId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  provider: InsuranceProvider;
  quoteType: InsuranceHomeQuoteType;
  reference?: Maybe<Scalars['String']['output']>;
  risk?: Maybe<InsuranceHomeRiskData>;
  status: InsuranceHomeQuoteStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type InsuranceHomeRiskBicycle = {
  __typename?: 'InsuranceHomeRiskBicycle';
  description?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type InsuranceHomeRiskBicycleInput = {
  description: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type InsuranceHomeRiskClaim = {
  __typename?: 'InsuranceHomeRiskClaim';
  date: Scalars['Date']['output'];
  livingAtProperty: Scalars['Boolean']['output'];
  settled: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type InsuranceHomeRiskClaimInput = {
  date: Scalars['Date']['input'];
  livingAtProperty: Scalars['Boolean']['input'];
  settled: Scalars['Boolean']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type InsuranceHomeRiskConstruction = {
  __typename?: 'InsuranceHomeRiskConstruction';
  architectureDetails?: Maybe<Scalars['String']['output']>;
  builtYear?: Maybe<Scalars['Int']['output']>;
  heatingType?: Maybe<Scalars['String']['output']>;
  movedInDate?: Maybe<Scalars['Date']['output']>;
  rebuildCost?: Maybe<Scalars['Int']['output']>;
  roofConstruction?: Maybe<Scalars['String']['output']>;
  roofFlatPercentage?: Maybe<Scalars['Int']['output']>;
  wallConstruction?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomeRiskConstructionInput = {
  architectureDetails?: InputMaybe<Scalars['String']['input']>;
  builtYear?: InputMaybe<Scalars['Int']['input']>;
  heatingType?: InputMaybe<Scalars['String']['input']>;
  movedInDate?: InputMaybe<Scalars['Date']['input']>;
  rebuildCost?: InputMaybe<Scalars['Int']['input']>;
  roofConstruction?: InputMaybe<Scalars['String']['input']>;
  roofFlatPercentage?: InputMaybe<Scalars['Int']['input']>;
  wallConstruction?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceHomeRiskCover = {
  __typename?: 'InsuranceHomeRiskCover';
  accidentalDamageBuildings?: Maybe<Scalars['Boolean']['output']>;
  accidentalDamageContents?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<InsuranceAddressV2>;
  belongingsAwayFromHomeCover?: Maybe<Scalars['Boolean']['output']>;
  belongingsAwayFromHomeValue?: Maybe<Scalars['Int']['output']>;
  bicycles?: Maybe<Array<Maybe<InsuranceHomeRiskBicycle>>>;
  buildingClaimFreeYears?: Maybe<Scalars['Int']['output']>;
  contentsClaimFreeYears?: Maybe<Scalars['Int']['output']>;
  entireContentsValue?: Maybe<Scalars['Int']['output']>;
  items?: Maybe<Array<Maybe<InsuranceHomeRiskItem>>>;
  previousPremium?: Maybe<Scalars['Int']['output']>;
  previousProvider?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  type?: Maybe<InsuranceHomeRiskCoverType>;
  voluntaryBuildingExcess?: Maybe<Scalars['String']['output']>;
  voluntaryContentsExcess?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomeRiskCoverInput = {
  accidentalDamageBuildings?: InputMaybe<Scalars['Boolean']['input']>;
  accidentalDamageContents?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<InsuranceAddressV2Input>;
  belongingsAwayFromHomeCover?: InputMaybe<Scalars['Boolean']['input']>;
  belongingsAwayFromHomeValue?: InputMaybe<Scalars['Int']['input']>;
  bicycles?: InputMaybe<Array<InputMaybe<InsuranceHomeRiskBicycleInput>>>;
  buildingClaimFreeYears?: InputMaybe<Scalars['Int']['input']>;
  contentsClaimFreeYears?: InputMaybe<Scalars['Int']['input']>;
  entireContentsValue?: InputMaybe<Scalars['Int']['input']>;
  items?: InputMaybe<Array<InputMaybe<InsuranceHomeRiskItemInput>>>;
  previousPremium?: InputMaybe<Scalars['Int']['input']>;
  previousProvider?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
  type?: InputMaybe<InsuranceHomeRiskCoverType>;
  voluntaryBuildingExcess?: InputMaybe<Scalars['String']['input']>;
  voluntaryContentsExcess?: InputMaybe<Scalars['String']['input']>;
};

export enum InsuranceHomeRiskCoverType {
  Buildings = 'BUILDINGS',
  BuildingsContents = 'BUILDINGS_CONTENTS',
  Contents = 'CONTENTS'
}

export type InsuranceHomeRiskData = {
  __typename?: 'InsuranceHomeRiskData';
  addons?: Maybe<Array<Maybe<InsuranceHomeAddonType>>>;
  claims?: Maybe<Array<Maybe<InsuranceHomeRiskClaim>>>;
  construction?: Maybe<InsuranceHomeRiskConstruction>;
  cover?: Maybe<InsuranceHomeRiskCover>;
  disclosures?: Maybe<InsuranceHomeRiskDisclosures>;
  jointHolder?: Maybe<InsuranceHomeRiskJointHolder>;
  multipleHolders?: Maybe<Scalars['Boolean']['output']>;
  occupancy?: Maybe<InsuranceHomeRiskOccupancy>;
  primaryHolder?: Maybe<InsuranceHomeRiskPrimaryHolder>;
  property?: Maybe<InsuranceHomeRiskProperty>;
  security?: Maybe<InsuranceHomeRiskSecurity>;
};

export type InsuranceHomeRiskDisclosures = {
  __typename?: 'InsuranceHomeRiskDisclosures';
  criminalConvictionAt?: Maybe<Scalars['Date']['output']>;
  criminalConvictionType?: Maybe<Scalars['String']['output']>;
  criminalConvictions?: Maybe<Scalars['Boolean']['output']>;
  declaredBankrupt?: Maybe<Scalars['Boolean']['output']>;
  previousPolicyConditions?: Maybe<Scalars['Boolean']['output']>;
  unsatisfiedCourtJudgment?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceHomeRiskDisclosuresInput = {
  criminalConvictionAt?: InputMaybe<Scalars['Date']['input']>;
  criminalConvictionType?: InputMaybe<Scalars['String']['input']>;
  criminalConvictions?: InputMaybe<Scalars['Boolean']['input']>;
  declaredBankrupt?: InputMaybe<Scalars['Boolean']['input']>;
  previousPolicyConditions?: InputMaybe<Scalars['Boolean']['input']>;
  unsatisfiedCourtJudgment?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceHomeRiskInput = {
  addons?: InputMaybe<Array<InputMaybe<InsuranceHomeAddonType>>>;
  claims?: InputMaybe<Array<InputMaybe<InsuranceHomeRiskClaimInput>>>;
  construction?: InputMaybe<InsuranceHomeRiskConstructionInput>;
  cover?: InputMaybe<InsuranceHomeRiskCoverInput>;
  disclosures?: InputMaybe<InsuranceHomeRiskDisclosuresInput>;
  jointHolder?: InputMaybe<InsuranceHomeRiskJointHolderInput>;
  multipleHolders?: InputMaybe<Scalars['Boolean']['input']>;
  occupancy?: InputMaybe<InsuranceHomeRiskOccupancyInput>;
  primaryHolder?: InputMaybe<InsuranceHomeRiskPrimaryHolderInput>;
  property?: InputMaybe<InsuranceHomeRiskPropertyInput>;
  security?: InputMaybe<InsuranceHomeRiskSecurityInput>;
};

export type InsuranceHomeRiskItem = {
  __typename?: 'InsuranceHomeRiskItem';
  awayFromHome: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type InsuranceHomeRiskItemInput = {
  awayFromHome: Scalars['Boolean']['input'];
  description: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type InsuranceHomeRiskJointHolder = {
  __typename?: 'InsuranceHomeRiskJointHolder';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  employmentFullTimeBusiness?: Maybe<Scalars['String']['output']>;
  employmentFullTimeOccupation?: Maybe<Scalars['String']['output']>;
  employmentPartTime?: Maybe<Scalars['Boolean']['output']>;
  employmentPartTimeBusiness?: Maybe<Scalars['String']['output']>;
  employmentPartTimeOccupation?: Maybe<Scalars['String']['output']>;
  employmentPartTimeStatus?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  ukResidentFromBirth?: Maybe<Scalars['Boolean']['output']>;
  ukResidentSince?: Maybe<Scalars['Date']['output']>;
};

export type InsuranceHomeRiskJointHolderInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  employmentFullTimeBusiness?: InputMaybe<Scalars['String']['input']>;
  employmentFullTimeOccupation?: InputMaybe<Scalars['String']['input']>;
  employmentPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  employmentPartTimeBusiness?: InputMaybe<Scalars['String']['input']>;
  employmentPartTimeOccupation?: InputMaybe<Scalars['String']['input']>;
  employmentPartTimeStatus?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  ukResidentFromBirth?: InputMaybe<Scalars['Boolean']['input']>;
  ukResidentSince?: InputMaybe<Scalars['Date']['input']>;
};

export type InsuranceHomeRiskOccupancy = {
  __typename?: 'InsuranceHomeRiskOccupancy';
  adults?: Maybe<Scalars['Int']['output']>;
  boarders?: Maybe<Scalars['Boolean']['output']>;
  businessUse?: Maybe<Scalars['String']['output']>;
  businessVisitors?: Maybe<Scalars['Int']['output']>;
  children?: Maybe<Scalars['Int']['output']>;
  dayNight?: Maybe<Scalars['String']['output']>;
  let?: Maybe<Scalars['Boolean']['output']>;
  mainResidence?: Maybe<Scalars['Boolean']['output']>;
  payingGuests?: Maybe<Scalars['Boolean']['output']>;
  residenceType?: Maybe<Scalars['String']['output']>;
  smoker?: Maybe<Scalars['Boolean']['output']>;
  soleFamily?: Maybe<Scalars['Boolean']['output']>;
  unoccupied?: Maybe<Scalars['Boolean']['output']>;
  unoccupiedDays?: Maybe<Scalars['String']['output']>;
};

export type InsuranceHomeRiskOccupancyInput = {
  adults?: InputMaybe<Scalars['Int']['input']>;
  boarders?: InputMaybe<Scalars['Boolean']['input']>;
  businessUse?: InputMaybe<Scalars['String']['input']>;
  businessVisitors?: InputMaybe<Scalars['Int']['input']>;
  children?: InputMaybe<Scalars['Int']['input']>;
  dayNight?: InputMaybe<Scalars['String']['input']>;
  let?: InputMaybe<Scalars['Boolean']['input']>;
  mainResidence?: InputMaybe<Scalars['Boolean']['input']>;
  payingGuests?: InputMaybe<Scalars['Boolean']['input']>;
  residenceType?: InputMaybe<Scalars['String']['input']>;
  smoker?: InputMaybe<Scalars['Boolean']['input']>;
  soleFamily?: InputMaybe<Scalars['Boolean']['input']>;
  unoccupied?: InputMaybe<Scalars['Boolean']['input']>;
  unoccupiedDays?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceHomeRiskPrimaryHolder = {
  __typename?: 'InsuranceHomeRiskPrimaryHolder';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employmentFullTimeBusiness?: Maybe<Scalars['String']['output']>;
  employmentFullTimeOccupation?: Maybe<Scalars['String']['output']>;
  employmentPartTime?: Maybe<Scalars['Boolean']['output']>;
  employmentPartTimeBusiness?: Maybe<Scalars['String']['output']>;
  employmentPartTimeOccupation?: Maybe<Scalars['String']['output']>;
  employmentPartTimeStatus?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  ukResidentFromBirth?: Maybe<Scalars['Boolean']['output']>;
  ukResidentSince?: Maybe<Scalars['Date']['output']>;
};

export type InsuranceHomeRiskPrimaryHolderInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  employmentFullTimeBusiness?: InputMaybe<Scalars['String']['input']>;
  employmentFullTimeOccupation?: InputMaybe<Scalars['String']['input']>;
  employmentPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  employmentPartTimeBusiness?: InputMaybe<Scalars['String']['input']>;
  employmentPartTimeOccupation?: InputMaybe<Scalars['String']['input']>;
  employmentPartTimeStatus?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  ukResidentFromBirth?: InputMaybe<Scalars['Boolean']['input']>;
  ukResidentSince?: InputMaybe<Scalars['Date']['input']>;
};

export type InsuranceHomeRiskProperty = {
  __typename?: 'InsuranceHomeRiskProperty';
  bathrooms?: Maybe<Scalars['Int']['output']>;
  bedrooms?: Maybe<Scalars['Int']['output']>;
  buildingWorks?: Maybe<Scalars['Boolean']['output']>;
  bungalowType?: Maybe<Scalars['String']['output']>;
  flatFloor?: Maybe<Scalars['String']['output']>;
  flatFloors?: Maybe<Scalars['Int']['output']>;
  flatType?: Maybe<Scalars['String']['output']>;
  flats?: Maybe<Scalars['Int']['output']>;
  flooded?: Maybe<Scalars['Boolean']['output']>;
  houseType?: Maybe<Scalars['String']['output']>;
  maintained?: Maybe<Scalars['Boolean']['output']>;
  nearTrees?: Maybe<Scalars['Boolean']['output']>;
  nearWater?: Maybe<Scalars['Boolean']['output']>;
  otherRooms?: Maybe<Scalars['Int']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  propertyType?: Maybe<InsuranceHomeRiskPropertyType>;
  selfContained?: Maybe<Scalars['Boolean']['output']>;
  subsidenceLandslip?: Maybe<Scalars['Boolean']['output']>;
  subsidenceLandslipAt?: Maybe<Scalars['Date']['output']>;
  townhouseType?: Maybe<Scalars['String']['output']>;
  underpinned?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceHomeRiskPropertyInput = {
  bathrooms?: InputMaybe<Scalars['Int']['input']>;
  bedrooms?: InputMaybe<Scalars['Int']['input']>;
  buildingWorks?: InputMaybe<Scalars['Boolean']['input']>;
  bungalowType?: InputMaybe<Scalars['String']['input']>;
  flatFloor?: InputMaybe<Scalars['String']['input']>;
  flatFloors?: InputMaybe<Scalars['Int']['input']>;
  flatType?: InputMaybe<Scalars['String']['input']>;
  flats?: InputMaybe<Scalars['Int']['input']>;
  flooded?: InputMaybe<Scalars['Boolean']['input']>;
  houseType?: InputMaybe<Scalars['String']['input']>;
  maintained?: InputMaybe<Scalars['Boolean']['input']>;
  nearTrees?: InputMaybe<Scalars['Boolean']['input']>;
  nearWater?: InputMaybe<Scalars['Boolean']['input']>;
  otherRooms?: InputMaybe<Scalars['Int']['input']>;
  ownershipType?: InputMaybe<Scalars['String']['input']>;
  propertyType?: InputMaybe<InsuranceHomeRiskPropertyType>;
  selfContained?: InputMaybe<Scalars['Boolean']['input']>;
  subsidenceLandslip?: InputMaybe<Scalars['Boolean']['input']>;
  subsidenceLandslipAt?: InputMaybe<Scalars['Date']['input']>;
  townhouseType?: InputMaybe<Scalars['String']['input']>;
  underpinned?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum InsuranceHomeRiskPropertyType {
  Bungalow = 'BUNGALOW',
  Flat = 'FLAT',
  House = 'HOUSE',
  Townhouse = 'TOWNHOUSE'
}

export type InsuranceHomeRiskSecurity = {
  __typename?: 'InsuranceHomeRiskSecurity';
  alarm?: Maybe<Scalars['Boolean']['output']>;
  alarmMaintained?: Maybe<Scalars['Boolean']['output']>;
  alarmType?: Maybe<Scalars['String']['output']>;
  externalDoors?: Maybe<Scalars['Boolean']['output']>;
  externalDoorsLockType?: Maybe<Scalars['String']['output']>;
  neighbourWatch?: Maybe<Scalars['Boolean']['output']>;
  patioDoors?: Maybe<Scalars['Boolean']['output']>;
  patioDoorsLockType?: Maybe<Scalars['String']['output']>;
  smokeAlarms?: Maybe<Scalars['Boolean']['output']>;
  windowLocks?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceHomeRiskSecurityInput = {
  alarm?: InputMaybe<Scalars['Boolean']['input']>;
  alarmMaintained?: InputMaybe<Scalars['Boolean']['input']>;
  alarmType?: InputMaybe<Scalars['String']['input']>;
  externalDoors?: InputMaybe<Scalars['Boolean']['input']>;
  externalDoorsLockType?: InputMaybe<Scalars['String']['input']>;
  neighbourWatch?: InputMaybe<Scalars['Boolean']['input']>;
  patioDoors?: InputMaybe<Scalars['Boolean']['input']>;
  patioDoorsLockType?: InputMaybe<Scalars['String']['input']>;
  smokeAlarms?: InputMaybe<Scalars['Boolean']['input']>;
  windowLocks?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceHomeSpecifiedItem = {
  __typename?: 'InsuranceHomeSpecifiedItem';
  awayFromHome?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceHomeSpecifiedItemInput = {
  awayFromHome?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum InsuranceHomeUnoccupiedDays {
  Days_60_89 = 'DAYS_60_89',
  Days_90_119 = 'DAYS_90_119',
  Days_120_179 = 'DAYS_120_179',
  Days_180Plus = 'DAYS_180_PLUS'
}

export enum InsuranceHomeUnoccupiedReason {
  ExtendedHoliday = 'EXTENDED_HOLIDAY',
  Other = 'OTHER',
  Renovations = 'RENOVATIONS',
  SecondHome = 'SECOND_HOME'
}

export enum InsuranceHomeYearBuilt {
  Year_1700_1749 = 'YEAR_1700_1749',
  Year_1750_1799 = 'YEAR_1750_1799',
  Year_1800_1849 = 'YEAR_1800_1849',
  Year_1850_1899 = 'YEAR_1850_1899',
  Year_1900_1919 = 'YEAR_1900_1919',
  Year_1920_1945 = 'YEAR_1920_1945',
  Year_1946_1979 = 'YEAR_1946_1979',
  Year_1980_1989 = 'YEAR_1980_1989',
  Year_1990_1999 = 'YEAR_1990_1999',
  Year_2000_2008 = 'YEAR_2000_2008',
  Year_2009Plus = 'YEAR_2009_PLUS',
  YearPre_1700 = 'YEAR_PRE_1700'
}

export type InsuranceInsurer = {
  __typename?: 'InsuranceInsurer';
  fee?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum InsuranceJourney {
  HomeNewBusiness = 'HOME_NEW_BUSINESS',
  Motor = 'MOTOR'
}

export type InsuranceList = {
  __typename?: 'InsuranceList';
  entries: Array<InsuranceListEntry>;
  name: Scalars['String']['output'];
};

export type InsuranceListEntry = {
  __typename?: 'InsuranceListEntry';
  key: Scalars['String']['output'];
  parent: Scalars['String']['output'];
  removed: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type InsuranceMotorAddon = {
  __typename?: 'InsuranceMotorAddon';
  applied: Scalars['Boolean']['output'];
  price: Scalars['String']['output'];
  type: InsuranceMotorAddonType;
};

export enum InsuranceMotorAddonType {
  CarBreakdownRoadsideAssist = 'CAR_BREAKDOWN_ROADSIDE_ASSIST',
  CarBreakdownUkAndEuropeanAssist = 'CAR_BREAKDOWN_UK_AND_EUROPEAN_ASSIST',
  CarBreakdownUkRecovery = 'CAR_BREAKDOWN_UK_RECOVERY',
  CarLegalExpenses = 'CAR_LEGAL_EXPENSES'
}

export type InsuranceMotorClaim = {
  __typename?: 'InsuranceMotorClaim';
  atFault?: Maybe<Scalars['String']['output']>;
  claimDate?: Maybe<Scalars['Date']['output']>;
  cost?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  incurredOnPolicy?: Maybe<Scalars['Boolean']['output']>;
  injuryInvolved?: Maybe<Scalars['Boolean']['output']>;
  ncdAffected?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InsuranceMotorClaimInput = {
  atFault?: InputMaybe<Scalars['String']['input']>;
  claimDate?: InputMaybe<Scalars['Date']['input']>;
  cost?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  incurredOnPolicy?: InputMaybe<Scalars['Boolean']['input']>;
  injuryInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  ncdAffected?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceMotorConviction = {
  __typename?: 'InsuranceMotorConviction';
  convictionDate?: Maybe<Scalars['Date']['output']>;
  disqualified?: Maybe<Scalars['Boolean']['output']>;
  fine?: Maybe<Scalars['Int']['output']>;
  monthsBanned?: Maybe<Scalars['Int']['output']>;
  offenceCode?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  receivedFine?: Maybe<Scalars['Boolean']['output']>;
  receivedPoints?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceMotorConvictionInput = {
  convictionDate?: InputMaybe<Scalars['Date']['input']>;
  disqualified?: InputMaybe<Scalars['Boolean']['input']>;
  fine?: InputMaybe<Scalars['Int']['input']>;
  monthsBanned?: InputMaybe<Scalars['Int']['input']>;
  offenceCode?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  receivedFine?: InputMaybe<Scalars['Boolean']['input']>;
  receivedPoints?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceMotorEndorsement = {
  __typename?: 'InsuranceMotorEndorsement';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type InsuranceMotorExcess = {
  __typename?: 'InsuranceMotorExcess';
  amount: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type InsuranceMotorInsurerQuote = {
  __typename?: 'InsuranceMotorInsurerQuote';
  annualPremium?: Maybe<Scalars['String']['output']>;
  annualPremiumExcAddons?: Maybe<Scalars['String']['output']>;
  coverDetails?: Maybe<Array<Maybe<InsuranceCoverDetail>>>;
  declined: Scalars['Boolean']['output'];
  declinedReason?: Maybe<Scalars['String']['output']>;
  endorsements?: Maybe<Array<Maybe<InsuranceMotorEndorsement>>>;
  excesses?: Maybe<Array<Maybe<InsuranceMotorExcess>>>;
  instalments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  insurer: Scalars['String']['output'];
  protectedNcdNetPremium?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
};

export type InsuranceMotorMakeModelResult = {
  __typename?: 'InsuranceMotorMakeModelResult';
  abiCode: Scalars['String']['output'];
  bodyType?: Maybe<Scalars['String']['output']>;
  cc: Scalars['Int']['output'];
  doors?: Maybe<Scalars['Int']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  gearbox?: Maybe<Scalars['String']['output']>;
  make: Scalars['String']['output'];
  mark?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  series?: Maybe<Scalars['Int']['output']>;
  thatchamCategory?: Maybe<Scalars['String']['output']>;
  yearFrom: Scalars['Int']['output'];
  yearTo?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceMotorMedicalCondition = {
  __typename?: 'InsuranceMotorMedicalCondition';
  dvlaNotified?: Maybe<Scalars['Boolean']['output']>;
  licenceExpiryDate?: Maybe<Scalars['Date']['output']>;
  licenceIssued?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceMotorMedicalConditionInput = {
  dvlaNotified?: InputMaybe<Scalars['Boolean']['input']>;
  licenceExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  licenceIssued?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceMotorModification = {
  __typename?: 'InsuranceMotorModification';
  details?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InsuranceMotorModificationInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceMotorQualification = {
  __typename?: 'InsuranceMotorQualification';
  qualification?: Maybe<Scalars['String']['output']>;
};

export type InsuranceMotorQualificationInput = {
  qualification?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceMotorQuote = {
  __typename?: 'InsuranceMotorQuote';
  accountId: Scalars['String']['output'];
  addons?: Maybe<Array<Maybe<InsuranceMotorAddon>>>;
  convertedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<Maybe<InsuranceDocument>>>;
  id: Scalars['String']['output'];
  insurerQuote?: Maybe<InsuranceMotorInsurerQuote>;
  mtaActionDate?: Maybe<Scalars['Date']['output']>;
  mtaActionTime?: Maybe<Scalars['Time']['output']>;
  mtaEffectiveAt?: Maybe<Scalars['DateTime']['output']>;
  mtaParentQuoteId?: Maybe<Scalars['String']['output']>;
  parentPolicyId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  quoteType: InsuranceMotorQuoteType;
  reference?: Maybe<Scalars['String']['output']>;
  risk?: Maybe<InsuranceMotorRiskData>;
  status: InsuranceMotorQuoteStatus;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum InsuranceMotorQuoteStatus {
  Cancelled = 'CANCELLED',
  Converted = 'CONVERTED',
  Effective = 'EFFECTIVE',
  Expired = 'EXPIRED',
  Open = 'OPEN',
  Pending = 'PENDING'
}

export enum InsuranceMotorQuoteType {
  Mta = 'MTA',
  NewBusiness = 'NEW_BUSINESS',
  Renewal = 'RENEWAL'
}

export type InsuranceMotorRiskCover = {
  __typename?: 'InsuranceMotorRiskCover';
  coverType?: Maybe<Scalars['String']['output']>;
  ncd?: Maybe<InsuranceMotorRiskNcd>;
};

export type InsuranceMotorRiskCoverInput = {
  coverType?: InputMaybe<Scalars['String']['input']>;
  ncd?: InputMaybe<InsuranceMotorRiskNcdInput>;
};

export type InsuranceMotorRiskData = {
  __typename?: 'InsuranceMotorRiskData';
  addons?: Maybe<Array<Maybe<InsuranceMotorAddonType>>>;
  cover?: Maybe<InsuranceMotorRiskCover>;
  drivers?: Maybe<Array<Maybe<InsuranceMotorRiskDriver>>>;
  hasAdditionalDrivers?: Maybe<Scalars['Boolean']['output']>;
  proposer?: Maybe<InsuranceMotorRiskProposer>;
  startDate?: Maybe<Scalars['Date']['output']>;
  startTime?: Maybe<Scalars['Time']['output']>;
  vehicles?: Maybe<Array<Maybe<InsuranceMotorRiskVehicle>>>;
};

export type InsuranceMotorRiskDriver = {
  __typename?: 'InsuranceMotorRiskDriver';
  claims?: Maybe<Array<Maybe<InsuranceMotorClaim>>>;
  convictions?: Maybe<Array<Maybe<InsuranceMotorConviction>>>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  hadTermsApplied?: Maybe<Scalars['Boolean']['output']>;
  hasAccessToOtherVehicles?: Maybe<Scalars['Boolean']['output']>;
  hasAdditionalQualifications?: Maybe<Scalars['Boolean']['output']>;
  hasBeenRefusedCover?: Maybe<Scalars['Boolean']['output']>;
  hasCountyCourtJudgements?: Maybe<Scalars['Boolean']['output']>;
  hasDvlaMedicalConditions?: Maybe<Scalars['Boolean']['output']>;
  hasOtherPartTimeEmployment?: Maybe<Scalars['Boolean']['output']>;
  hasUnspentCriminalConvictions?: Maybe<Scalars['Boolean']['output']>;
  isMainUser?: Maybe<Scalars['Boolean']['output']>;
  isProposer?: Maybe<Scalars['Boolean']['output']>;
  isUkResidentFromBirth?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licence?: Maybe<InsuranceMotorRiskLicence>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  medicalConditions?: Maybe<Array<Maybe<InsuranceMotorMedicalCondition>>>;
  occupations?: Maybe<Array<Maybe<InsuranceMotorRiskOccupation>>>;
  qualifications?: Maybe<Array<Maybe<InsuranceMotorQualification>>>;
  relationship?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  ukResidenceMonths?: Maybe<Scalars['Int']['output']>;
  ukResidenceYears?: Maybe<Scalars['Int']['output']>;
  vehiclesAvailableToFamily?: Maybe<Scalars['Int']['output']>;
  vehiclesDriven?: Maybe<Scalars['Int']['output']>;
  vehiclesOwned?: Maybe<Scalars['Int']['output']>;
  wantsToProvideLicenceNumber?: Maybe<Scalars['Boolean']['output']>;
};

export type InsuranceMotorRiskDriverInput = {
  claims?: InputMaybe<Array<InputMaybe<InsuranceMotorClaimInput>>>;
  convictions?: InputMaybe<Array<InputMaybe<InsuranceMotorConvictionInput>>>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  hadTermsApplied?: InputMaybe<Scalars['Boolean']['input']>;
  hasAccessToOtherVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  hasAdditionalQualifications?: InputMaybe<Scalars['Boolean']['input']>;
  hasBeenRefusedCover?: InputMaybe<Scalars['Boolean']['input']>;
  hasCountyCourtJudgements?: InputMaybe<Scalars['Boolean']['input']>;
  hasDvlaMedicalConditions?: InputMaybe<Scalars['Boolean']['input']>;
  hasOtherPartTimeEmployment?: InputMaybe<Scalars['Boolean']['input']>;
  hasUnspentCriminalConvictions?: InputMaybe<Scalars['Boolean']['input']>;
  isMainUser?: InputMaybe<Scalars['Boolean']['input']>;
  isProposer?: InputMaybe<Scalars['Boolean']['input']>;
  isUkResidentFromBirth?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  licence?: InputMaybe<InsuranceMotorRiskLicenceInput>;
  maritalStatus?: InputMaybe<Scalars['String']['input']>;
  medicalConditions?: InputMaybe<Array<InputMaybe<InsuranceMotorMedicalConditionInput>>>;
  occupations?: InputMaybe<Array<InputMaybe<InsuranceMotorRiskOccupationInput>>>;
  qualifications?: InputMaybe<Array<InputMaybe<InsuranceMotorQualificationInput>>>;
  relationship?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  ukResidenceMonths?: InputMaybe<Scalars['Int']['input']>;
  ukResidenceYears?: InputMaybe<Scalars['Int']['input']>;
  vehiclesAvailableToFamily?: InputMaybe<Scalars['Int']['input']>;
  vehiclesDriven?: InputMaybe<Scalars['Int']['input']>;
  vehiclesOwned?: InputMaybe<Scalars['Int']['input']>;
  wantsToProvideLicenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InsuranceMotorRiskInput = {
  addons?: InputMaybe<Array<InputMaybe<InsuranceMotorAddonType>>>;
  cover?: InputMaybe<InsuranceMotorRiskCoverInput>;
  drivers?: InputMaybe<Array<InputMaybe<InsuranceMotorRiskDriverInput>>>;
  hasAdditionalDrivers?: InputMaybe<Scalars['Boolean']['input']>;
  proposer?: InputMaybe<InsuranceMotorRiskProposerInput>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  vehicles?: InputMaybe<Array<InputMaybe<InsuranceMotorRiskVehicleInput>>>;
};

export type InsuranceMotorRiskLicence = {
  __typename?: 'InsuranceMotorRiskLicence';
  datePassed?: Maybe<Scalars['Date']['output']>;
  dlnAuthorised?: Maybe<Scalars['String']['output']>;
  licenceNumber?: Maybe<Scalars['String']['output']>;
  licenceRestrictions?: Maybe<Scalars['String']['output']>;
  licenceType?: Maybe<Scalars['String']['output']>;
};

export type InsuranceMotorRiskLicenceInput = {
  datePassed?: InputMaybe<Scalars['Date']['input']>;
  licenceNumber?: InputMaybe<Scalars['String']['input']>;
  licenceRestrictions?: InputMaybe<Scalars['String']['input']>;
  licenceType?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceMotorRiskNcd = {
  __typename?: 'InsuranceMotorRiskNcd';
  previousInsurer?: Maybe<Scalars['String']['output']>;
  protected?: Maybe<Scalars['Boolean']['output']>;
  verificationYears?: Maybe<Scalars['String']['output']>;
  voluntaryExcess?: Maybe<Scalars['String']['output']>;
  years?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceMotorRiskNcdInput = {
  previousInsurer?: InputMaybe<Scalars['String']['input']>;
  protected?: InputMaybe<Scalars['Boolean']['input']>;
  voluntaryExcess?: InputMaybe<Scalars['String']['input']>;
  years?: InputMaybe<Scalars['Int']['input']>;
};

export type InsuranceMotorRiskOccupation = {
  __typename?: 'InsuranceMotorRiskOccupation';
  employersBusiness?: Maybe<Scalars['String']['output']>;
  employmentStatus?: Maybe<Scalars['String']['output']>;
  isPartTime?: Maybe<Scalars['Boolean']['output']>;
  isPrimaryOccupation?: Maybe<Scalars['Boolean']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
};

export type InsuranceMotorRiskOccupationInput = {
  employersBusiness?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  isPartTime?: InputMaybe<Scalars['Boolean']['input']>;
  isPrimaryOccupation?: InputMaybe<Scalars['Boolean']['input']>;
  occupation?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceMotorRiskProposer = {
  __typename?: 'InsuranceMotorRiskProposer';
  address?: Maybe<InsuranceAddressV2>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isHomeOwner?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InsuranceMotorRiskProposerInput = {
  address?: InputMaybe<InsuranceAddressV2Input>;
  county?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type InsuranceMotorRiskVehicle = {
  __typename?: 'InsuranceMotorRiskVehicle';
  abiCode?: Maybe<Scalars['String']['output']>;
  annualMileage?: Maybe<Scalars['Int']['output']>;
  bodyType?: Maybe<Scalars['String']['output']>;
  businessMileage?: Maybe<Scalars['Int']['output']>;
  cc?: Maybe<Scalars['Int']['output']>;
  chassisNumber?: Maybe<Scalars['String']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  currentMileage?: Maybe<Scalars['Int']['output']>;
  datePurchased?: Maybe<Scalars['Date']['output']>;
  doors?: Maybe<Scalars['Int']['output']>;
  estimatedValue?: Maybe<Scalars['String']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  garageAddress?: Maybe<InsuranceAddressV2>;
  gearbox?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  hasAlarm?: Maybe<Scalars['Boolean']['output']>;
  hasTracker?: Maybe<Scalars['Boolean']['output']>;
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isKeptAtHome?: Maybe<Scalars['Boolean']['output']>;
  isLeftHandDrive?: Maybe<Scalars['Boolean']['output']>;
  isModified?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationUnknown?: Maybe<Scalars['Boolean']['output']>;
  keeper?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  manualGroup?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modifications?: Maybe<Array<Maybe<InsuranceMotorModification>>>;
  overnightParking?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  pricePaid?: Maybe<Scalars['String']['output']>;
  registeredYear?: Maybe<Scalars['Int']['output']>;
  registration?: Maybe<Scalars['String']['output']>;
  seats?: Maybe<Scalars['Int']['output']>;
  vehicleUse?: Maybe<Scalars['String']['output']>;
  yearOfManufacture?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceMotorRiskVehicleInput = {
  abiCode?: InputMaybe<Scalars['String']['input']>;
  annualMileage?: InputMaybe<Scalars['Int']['input']>;
  bodyType?: InputMaybe<Scalars['String']['input']>;
  businessMileage?: InputMaybe<Scalars['Int']['input']>;
  cc?: InputMaybe<Scalars['Int']['input']>;
  chassisNumber?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  currentMileage?: InputMaybe<Scalars['Int']['input']>;
  datePurchased?: InputMaybe<Scalars['Date']['input']>;
  doors?: InputMaybe<Scalars['Int']['input']>;
  estimatedValue?: InputMaybe<Scalars['String']['input']>;
  fuel?: InputMaybe<Scalars['String']['input']>;
  garageAddress?: InputMaybe<InsuranceAddressV2Input>;
  gearbox?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  hasAlarm?: InputMaybe<Scalars['Boolean']['input']>;
  hasTracker?: InputMaybe<Scalars['Boolean']['input']>;
  isImported?: InputMaybe<Scalars['Boolean']['input']>;
  isKeptAtHome?: InputMaybe<Scalars['Boolean']['input']>;
  isLeftHandDrive?: InputMaybe<Scalars['Boolean']['input']>;
  isModified?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationUnknown?: InputMaybe<Scalars['Boolean']['input']>;
  keeper?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  manualGroup?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modifications?: InputMaybe<Array<InputMaybe<InsuranceMotorModificationInput>>>;
  overnightParking?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  pricePaid?: InputMaybe<Scalars['String']['input']>;
  registeredYear?: InputMaybe<Scalars['Int']['input']>;
  registration?: InputMaybe<Scalars['String']['input']>;
  seats?: InputMaybe<Scalars['Int']['input']>;
  vehicleUse?: InputMaybe<Scalars['String']['input']>;
  yearOfManufacture?: InputMaybe<Scalars['Int']['input']>;
};

export type InsuranceMotorVehicle = {
  __typename?: 'InsuranceMotorVehicle';
  abiCode: Scalars['String']['output'];
  bodyType?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Scalars['Int']['output']>;
  colour?: Maybe<Scalars['String']['output']>;
  doors?: Maybe<Scalars['Int']['output']>;
  estimatedValue?: Maybe<Scalars['String']['output']>;
  fuel?: Maybe<Scalars['String']['output']>;
  gearbox?: Maybe<Scalars['String']['output']>;
  isImported?: Maybe<Scalars['Boolean']['output']>;
  isLeftHandDrive?: Maybe<Scalars['Boolean']['output']>;
  make: Scalars['String']['output'];
  mark?: Maybe<Scalars['String']['output']>;
  model: Scalars['String']['output'];
  registeredYear?: Maybe<Scalars['Int']['output']>;
  registration: Scalars['String']['output'];
  seats?: Maybe<Scalars['Int']['output']>;
  yearOfManufacture?: Maybe<Scalars['Int']['output']>;
};

export type InsuranceMoveProtectorPolicyResult = {
  __typename?: 'InsuranceMoveProtectorPolicyResult';
  policyId: Scalars['String']['output'];
  quoteId: Scalars['String']['output'];
  startDate: Scalars['Date']['output'];
};

export enum InsurancePaymentMethod {
  Cheque = 'CHEQUE',
  DirectDebit = 'DIRECT_DEBIT',
  PaidInFull = 'PAID_IN_FULL',
  Unspecified = 'UNSPECIFIED'
}

export type InsurancePendingCancellation = {
  __typename?: 'InsurancePendingCancellation';
  adminFeeWaived: Scalars['Boolean']['output'];
  breakdown?: Maybe<InsuranceCancellationBreakdown>;
  canWithdraw: Scalars['Boolean']['output'];
  cancellationDate: Scalars['Date']['output'];
  customerReason?: Maybe<InsurancePolicyCustomerRequestCancellationReason>;
  reason?: Maybe<InsurancePolicyCancellationReason>;
};

export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  /** @deprecated Use `docs` instead */
  Documents?: Maybe<Array<Maybe<InsurancePolicyDocument>>>;
  accountId: Scalars['String']['output'];
  addons?: Maybe<Array<InsurancePolicyAddon>>;
  address?: Maybe<InsuranceAddress>;
  annualPrice: Scalars['String']['output'];
  autoRenewalPreferred?: Maybe<Scalars['Boolean']['output']>;
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  canCancelCustomerRequestReasons: Array<Maybe<InsurancePolicyCustomerRequestCancellationReason>>;
  canCancelReasons: Array<Maybe<InsurancePolicyCancellationReason>>;
  cancellationDate?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use `cancellationDate` instead */
  cancelledDate?: Maybe<Scalars['DateTime']['output']>;
  changes?: Maybe<Array<Maybe<InsurancePolicyChange>>>;
  docs?: Maybe<Array<Maybe<InsuranceDocument>>>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  insurer?: Maybe<InsuranceInsurer>;
  monthlyPrice: Scalars['String']['output'];
  pendingCancellation?: Maybe<InsurancePendingCancellation>;
  product: InsuranceProduct;
  productClass: InsuranceProductClass;
  quoteId: Scalars['String']['output'];
  redacted?: Maybe<Scalars['Boolean']['output']>;
  reference: Scalars['String']['output'];
  scheduledAddressChange?: Maybe<InsuranceScheduledAddressChange>;
  scheduledCancellationDate?: Maybe<Scalars['DateTime']['output']>;
  startDate: Scalars['DateTime']['output'];
};

export enum InsurancePolicyAddon {
  CarBreakdownRoadsideAssist = 'CAR_BREAKDOWN_ROADSIDE_ASSIST',
  CarBreakdownUkAndEuropeanAssist = 'CAR_BREAKDOWN_UK_AND_EUROPEAN_ASSIST',
  CarBreakdownUkRecovery = 'CAR_BREAKDOWN_UK_RECOVERY',
  CarLegalExpenses = 'CAR_LEGAL_EXPENSES',
  HomeEmergency = 'HOME_EMERGENCY',
  LegalExpenses = 'LEGAL_EXPENSES'
}

export type InsurancePolicyCancellationFees = {
  __typename?: 'InsurancePolicyCancellationFees';
  cancellationFee: Scalars['String']['output'];
  remainingMonthlyPremium: Scalars['String']['output'];
  remainingPolicyPremium: Scalars['String']['output'];
};

export type InsurancePolicyCancellationFeesV2 = {
  __typename?: 'InsurancePolicyCancellationFeesV2';
  adminFee: Scalars['String']['output'];
  coverEnd: Scalars['Date']['output'];
  remainingPolicyPremium: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export enum InsurancePolicyCancellationReason {
  CustomerAccountClosed = 'CUSTOMER_ACCOUNT_CLOSED',
  CustomerDeceased = 'CUSTOMER_DECEASED',
  CustomerHasDebt = 'CUSTOMER_HAS_DEBT',
  CustomerNeverBilled = 'CUSTOMER_NEVER_BILLED',
  CustomerRequested = 'CUSTOMER_REQUESTED',
  CustomerTooOld = 'CUSTOMER_TOO_OLD',
  InsurerRequested = 'INSURER_REQUESTED',
  SystemManual = 'SYSTEM_MANUAL',
  Unknown = 'UNKNOWN',
  UwCancelled = 'UW_CANCELLED'
}

export type InsurancePolicyChange = {
  __typename?: 'InsurancePolicyChange';
  change: Scalars['String']['output'];
  date: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  source: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type InsurancePolicyCount = {
  __typename?: 'InsurancePolicyCount';
  billProtector?: Maybe<InsurancePolicyTypeCount>;
  boiler?: Maybe<InsurancePolicyTypeCount>;
  home?: Maybe<InsurancePolicyTypeCount>;
  incomeProtector?: Maybe<InsurancePolicyTypeCount>;
  motor?: Maybe<InsurancePolicyTypeCount>;
};

export enum InsurancePolicyCustomerRequestCancellationReason {
  BetterPriceWithAnotherInsurer = 'BETTER_PRICE_WITH_ANOTHER_INSURER',
  CancellingAllUwServices = 'CANCELLING_ALL_UW_SERVICES',
  DuplicatePolicy = 'DUPLICATE_POLICY',
  HomeMove = 'HOME_MOVE',
  LookingToReduceBills = 'LOOKING_TO_REDUCE_BILLS',
  MtaDeclineOrTooExpensive = 'MTA_DECLINE_OR_TOO_EXPENSIVE',
  PolicyCoverNotSuitable = 'POLICY_COVER_NOT_SUITABLE',
  PoorClaimsExperience = 'POOR_CLAIMS_EXPERIENCE',
  PreExistingCover = 'PRE_EXISTING_COVER',
  ReasonNotListed = 'REASON_NOT_LISTED',
  TakingAnotherPolicyWithUw = 'TAKING_ANOTHER_POLICY_WITH_UW',
  Unknown = 'UNKNOWN',
  WouldNotRevealReason = 'WOULD_NOT_REVEAL_REASON'
}

export type InsurancePolicyDocument = {
  __typename?: 'InsurancePolicyDocument';
  date: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type InsurancePolicySummary = {
  __typename?: 'InsurancePolicySummary';
  accountNumber: Scalars['String']['output'];
  addons: Array<InsurancePolicyAddon>;
  cancellationDate?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  insurer: Scalars['String']['output'];
  parentPolicyId?: Maybe<Scalars['String']['output']>;
  postCode: Scalars['String']['output'];
  product?: Maybe<InsuranceProduct>;
  productClass?: Maybe<InsuranceProductClass>;
  redacted: Scalars['Boolean']['output'];
  reference: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  status: Scalars['String']['output'];
};

export type InsurancePolicyTypeCount = {
  __typename?: 'InsurancePolicyTypeCount';
  active?: Maybe<Scalars['Int']['output']>;
  cancelled?: Maybe<Scalars['Int']['output']>;
  ended?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum InsuranceProduct {
  BillProtector = 'BILL_PROTECTOR',
  Boiler = 'BOILER',
  HomeBuilding = 'HOME_BUILDING',
  HomeBuildingContents = 'HOME_BUILDING_CONTENTS',
  HomeContents = 'HOME_CONTENTS',
  IncomeProtector = 'INCOME_PROTECTOR',
  MotorFullyComprehensive = 'MOTOR_FULLY_COMPREHENSIVE',
  MotorThirdParty = 'MOTOR_THIRD_PARTY',
  MotorThirdPartyFireTheft = 'MOTOR_THIRD_PARTY_FIRE_THEFT',
  Unknown = 'UNKNOWN'
}

export type InsuranceProductClaim = {
  __typename?: 'InsuranceProductClaim';
  accountId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  incidentDate: Scalars['DateTime']['output'];
  number: Scalars['String']['output'];
  outcome: InsuranceClaimOutcome;
  paidToDate: Scalars['String']['output'];
  policyReference: Scalars['String']['output'];
  product: InsuranceProduct;
  productClass: InsuranceProductClass;
  status: InsuranceClaimStatus;
  type: Scalars['String']['output'];
};

export enum InsuranceProductClass {
  BillProtector = 'BILL_PROTECTOR',
  Boiler = 'BOILER',
  Home = 'HOME',
  IncomeProtector = 'INCOME_PROTECTOR',
  Motor = 'MOTOR',
  Unknown = 'UNKNOWN'
}

export type InsurancePromotion = {
  __typename?: 'InsurancePromotion';
  endDate: Scalars['DateTime']['output'];
  name: Scalars['String']['output'];
  product: InsuranceProduct;
  promotionPremiumPrice: Scalars['String']['output'];
  promotionTermMonths: Scalars['Int']['output'];
  startDate: Scalars['DateTime']['output'];
};

export enum InsuranceProvider {
  Durell = 'DURELL',
  Ogi = 'OGI'
}

export type InsuranceQuote = {
  __typename?: 'InsuranceQuote';
  accountId?: Maybe<Scalars['String']['output']>;
  address?: Maybe<InsuranceAddress>;
  annualPremium: Scalars['String']['output'];
  converted: Scalars['Boolean']['output'];
  createdDate: Scalars['DateTime']['output'];
  docs?: Maybe<Array<Maybe<InsuranceDocument>>>;
  holderNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['String']['output'];
  monthlyPremium: Scalars['String']['output'];
  product: InsuranceProduct;
  productClass: InsuranceProductClass;
  promotion?: Maybe<InsurancePromotion>;
  reference: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
};

export type InsuranceQuoteEligibility = {
  __typename?: 'InsuranceQuoteEligibility';
  canQuote: Scalars['Boolean']['output'];
  cannotQuoteReason: InsuranceCannotQuoteReason;
};

export type InsuranceScheduledAddressChange = {
  __typename?: 'InsuranceScheduledAddressChange';
  newAddress?: Maybe<InsuranceAddress>;
  scheduledDate?: Maybe<Scalars['DateTime']['output']>;
};

export type InsuranceUpdateHomeQuoteInput = {
  accountId: Scalars['String']['input'];
  addons?: InputMaybe<Array<InputMaybe<InsuranceHomeAddonInput>>>;
  address?: InputMaybe<InsuranceAddressInput>;
  channel?: InputMaybe<InsuranceHomeChannel>;
  cover?: InputMaybe<InsuranceHomeCoverInput>;
  householdClaims?: InputMaybe<Array<InputMaybe<InsuranceHomeHouseholdClaimsInput>>>;
  jointPolicyHolder?: InputMaybe<InsuranceHomePolicyHolderInput>;
  policyHolder?: InputMaybe<InsuranceHomePolicyHolderType>;
  previousPremium?: InputMaybe<Scalars['String']['input']>;
  previousProvider?: InputMaybe<Scalars['String']['input']>;
  primaryPolicyHolder?: InputMaybe<InsuranceHomePolicyHolderInput>;
  property?: InputMaybe<InsuranceHomePropertyInput>;
  quoteId: Scalars['String']['input'];
};

export type InsuranceUpdatePolicyAddressInput = {
  address?: InputMaybe<InsuranceAddressInput>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  policyId: Scalars['String']['input'];
  product: InsuranceProduct;
};

export type InsuranceUserExtraActions = {
  __typename?: 'InsuranceUserExtraActions';
  backdateCancel: Scalars['Boolean']['output'];
  quoteBoiler: Scalars['Boolean']['output'];
  skipEligibility: Scalars['Boolean']['output'];
};

export type InsuranceWaivedFeesInput = {
  cancellationFee: Scalars['Boolean']['input'];
  remainingPremium: Scalars['Boolean']['input'];
  waivedFeesReason?: InputMaybe<InsuranceWaivedFeesReason>;
};

export enum InsuranceWaivedFeesReason {
  Unknown = 'UNKNOWN'
}

export type IntegrationBanking = {
  __typename?: 'IntegrationBanking';
  enabled: Scalars['Boolean']['output'];
};

export type IntegrationCard = {
  __typename?: 'IntegrationCard';
  allowRetainingPaymentMethod: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  temporarilyDisabled: Scalars['Boolean']['output'];
};

export type IntegrationIssues = {
  subProductStatusUpdates?: Maybe<Scalars['Boolean']['output']>;
};

export type IntegrationOpenBanking = {
  __typename?: 'IntegrationOpenBanking';
  enabled: Scalars['Boolean']['output'];
  temporarilyDisabled: Scalars['Boolean']['output'];
};

export type IntegrationProfile = {
  __typename?: 'IntegrationProfile';
  banking?: Maybe<IntegrationBanking>;
  card?: Maybe<IntegrationCard>;
  enforceRetainingPaymentMethod: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  openBanking?: Maybe<IntegrationOpenBanking>;
  ui: IntegrationProfileUi;
};

export type IntegrationProfileUi = {
  __typename?: 'IntegrationProfileUI';
  cardPaymentMessage: Scalars['String']['output'];
  displayHeader: Scalars['String']['output'];
  failureUrl?: Maybe<Scalars['String']['output']>;
  paymentOptionChildComponentName: IntegrationProfileUiComponent;
  redirectUrl: Scalars['String']['output'];
  skipErrorPage: Scalars['Boolean']['output'];
  skipSuccessPage: Scalars['Boolean']['output'];
  skipSummaryPage: Scalars['Boolean']['output'];
  temporarilyDisabledCardsMessage?: Maybe<Scalars['String']['output']>;
  temporarilyDisabledOpenBankingMessage?: Maybe<Scalars['String']['output']>;
};

export type IntegrationProfileUiComponent = {
  __typename?: 'IntegrationProfileUIComponent';
  banking: Scalars['String']['output'];
  card: Scalars['String']['output'];
  openBanking: Scalars['String']['output'];
};

export type InvoiceDate = {
  __typename?: 'InvoiceDate';
  nanos?: Maybe<Scalars['Int']['output']>;
  seconds?: Maybe<Scalars['Int']['output']>;
};

/** Issuer lists the supported token issuing domains. */
export enum IssuingDomain {
  Customer = 'CUSTOMER',
  Partner = 'PARTNER'
}

export enum LandlineType {
  Analog = 'ANALOG',
  Digital = 'DIGITAL',
  Unknown = 'UNKNOWN'
}

export type LatestReadInput = {
  excludeEstimated?: InputMaybe<Scalars['Boolean']['input']>;
  excludeFuture?: InputMaybe<Scalars['Boolean']['input']>;
  includeRejected?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegacyBusinessDetails = {
  __typename?: 'LegacyBusinessDetails';
  changes?: Maybe<Array<AccountPlatformChange>>;
  isMarkedAsDeceased: Scalars['Boolean']['output'];
  isMarkedAsFraud: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  legacyDateOfBirth1?: Maybe<Scalars['String']['output']>;
  legacyDateOfBirth2?: Maybe<Scalars['String']['output']>;
  supplyDetails?: Maybe<AccountPlatformContactDetails>;
};

export enum LineTestResult {
  LineTestResultFailed = 'LINE_TEST_RESULT_FAILED',
  LineTestResultInconclusive = 'LINE_TEST_RESULT_INCONCLUSIVE',
  LineTestResultPassed = 'LINE_TEST_RESULT_PASSED',
  LineTestResultPending = 'LINE_TEST_RESULT_PENDING',
  LineTestResultPrematureTermination = 'LINE_TEST_RESULT_PREMATURE_TERMINATION',
  LineTestResultTimedOut = 'LINE_TEST_RESULT_TIMED_OUT'
}

export enum LineTestStatus {
  LineTestStatusCompleted = 'LINE_TEST_STATUS_COMPLETED',
  LineTestStatusFailed = 'LINE_TEST_STATUS_FAILED',
  LineTestStatusPending = 'LINE_TEST_STATUS_PENDING',
  LineTestStatusRequested = 'LINE_TEST_STATUS_REQUESTED',
  LineTestStatusTimedOut = 'LINE_TEST_STATUS_TIMED_OUT'
}

export enum LineTestTimelineStep {
  FaultEscalated = 'FAULT_ESCALATED',
  FaultIdentified = 'FAULT_IDENTIFIED',
  FaultReported = 'FAULT_REPORTED',
  FaultResolved = 'FAULT_RESOLVED',
  WorkInProgress = 'WORK_IN_PROGRESS'
}

export type ListDirectDebitMandatesInput = {
  accountReference: Scalars['String']['input'];
  purpose: DirectDebitMandatePurpose;
};

export type ListFinancePaymentMethodsInput = {
  accountReference: Scalars['String']['input'];
  includeExpiredCards?: InputMaybe<Scalars['Boolean']['input']>;
  integrationKey?: InputMaybe<Scalars['String']['input']>;
  type: FinancePaymentMethodType;
};

export type ListPaymentMethodsResult = {
  __typename?: 'ListPaymentMethodsResult';
  paymentMethods?: Maybe<Array<Maybe<PaymentMethodDetails>>>;
};

export type ListRetailPartnerOptions = {
  limit: Scalars['Int']['input'];
  marketingTiers?: InputMaybe<Array<Scalars['Int']['input']>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ListRetailPartnersResponse = {
  __typename?: 'ListRetailPartnersResponse';
  retailers: Array<Retailer>;
  totalCount: Scalars['Int']['output'];
};

export type ListTransactionsOptions = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
  transactionTypes?: InputMaybe<Array<CbcTransactionType>>;
};

export type MakePaymentResult = {
  __typename?: 'MakePaymentResult';
  failureReason?: Maybe<PaymentFailureReason>;
  requiredAction?: Maybe<RequiredAction>;
  success: Scalars['Boolean']['output'];
};

export type MessengerContactChannel = {
  __typename?: 'MessengerContactChannel';
  calloutBanner?: Maybe<CalloutBanner>;
  estimatedWaitTime?: Maybe<Scalars['Int']['output']>;
  queueId?: Maybe<Scalars['String']['output']>;
  queue_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelStatus>;
};

export enum MeterReadSource {
  AutomaticMeter = 'AUTOMATIC_METER',
  Customer = 'CUSTOMER',
  CustomerApp = 'CUSTOMER_APP',
  CustomerEmail = 'CUSTOMER_EMAIL',
  CustomerIvr = 'CUSTOMER_IVR',
  CustomerTelephone = 'CUSTOMER_TELEPHONE',
  CustomerWeb = 'CUSTOMER_WEB',
  Industry = 'INDUSTRY',
  Manual = 'MANUAL',
  SmartMeter = 'SMART_METER',
  System = 'SYSTEM',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export type MeterReadingError = {
  __typename?: 'MeterReadingError';
  error?: Maybe<MeterReadingErrorDetail>;
  registerId: Scalars['String']['output'];
};

export enum MeterReadingErrorCode {
  ConsumptionHigherThanUpperThreshold = 'CONSUMPTION_HIGHER_THAN_UPPER_THRESHOLD',
  ConsumptionLessThanLowerThreshold = 'CONSUMPTION_LESS_THAN_LOWER_THRESHOLD',
  DuplicateReadingDate = 'DUPLICATE_READING_DATE',
  EarlierReadingExists = 'EARLIER_READING_EXISTS',
  FirstReadTooFarFromSsd = 'FIRST_READ_TOO_FAR_FROM_SSD',
  InvalidDecimalPlaces = 'INVALID_DECIMAL_PLACES',
  InvalidNumberFormat = 'INVALID_NUMBER_FORMAT',
  InvalidQuality = 'INVALID_QUALITY',
  InvalidRegisterIdentifier = 'INVALID_REGISTER_IDENTIFIER',
  InvalidSource = 'INVALID_SOURCE',
  LargerThanDials = 'LARGER_THAN_DIALS',
  LastReadTooFarFromSed = 'LAST_READ_TOO_FAR_FROM_SED',
  MeterHasNoRegisters = 'METER_HAS_NO_REGISTERS',
  MeterMissingEacaq = 'METER_MISSING_EACAQ',
  MeterMissingEuc = 'METER_MISSING_EUC',
  MeterNotAttachedToMeterPoint = 'METER_NOT_ATTACHED_TO_METER_POINT',
  MeterRegisterConfigPeriodMissing = 'METER_REGISTER_CONFIG_PERIOD_MISSING',
  MultipleWarnings = 'MULTIPLE_WARNINGS',
  Negative = 'NEGATIVE',
  NotSupplier = 'NOT_SUPPLIER',
  NoMeterPointTimeSeries = 'NO_METER_POINT_TIME_SERIES',
  NoPreviousReading = 'NO_PREVIOUS_READING',
  ReadingDttmHasTime = 'READING_DTTM_HAS_TIME',
  ReadingDttmNotAligned = 'READING_DTTM_NOT_ALIGNED',
  ReadingDttmNotValid = 'READING_DTTM_NOT_VALID',
  ReadingInFuture = 'READING_IN_FUTURE',
  ReadingLowerThanLastActual = 'READING_LOWER_THAN_LAST_ACTUAL',
  ReadingLowerThanLastCustomer = 'READING_LOWER_THAN_LAST_CUSTOMER',
  ReadingLowerThanOpeningRead = 'READING_LOWER_THAN_OPENING_READ',
  ReadingMismatch = 'READING_MISMATCH',
  ReadAfterServiceEndDate = 'READ_AFTER_SERVICE_END_DATE',
  ReadBeforePreviousRead = 'READ_BEFORE_PREVIOUS_READ',
  ReadBeforeServiceStartDate = 'READ_BEFORE_SERVICE_START_DATE',
  ReadTooHigh = 'READ_TOO_HIGH',
  ReadTooLow = 'READ_TOO_LOW',
  ReadTooOld = 'READ_TOO_OLD',
  RegisterNotConnectedToMeterPoint = 'REGISTER_NOT_CONNECTED_TO_METER_POINT',
  RegisterNotFound = 'REGISTER_NOT_FOUND',
  RequiredRegisterIdentifierMissing = 'REQUIRED_REGISTER_IDENTIFIER_MISSING',
  SedNotConfirmed = 'SED_NOT_CONFIRMED',
  TooLarge = 'TOO_LARGE',
  Unknown = 'UNKNOWN',
  ZeroConsumption = 'ZERO_CONSUMPTION'
}

export type MeterReadingErrorDetail = {
  __typename?: 'MeterReadingErrorDetail';
  code: MeterReadingErrorCode;
  message: Scalars['String']['output'];
  severity: MeterReadingErrorSeverity;
};

export enum MeterReadingErrorSeverity {
  Error = 'ERROR',
  Unknown = 'UNKNOWN',
  Warning = 'WARNING'
}

export type MeterReadingInputCustomer = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  isFit?: InputMaybe<Scalars['Boolean']['input']>;
  meterSerialNumber: Scalars['String']['input'];
  readDate?: InputMaybe<Scalars['DateTime']['input']>;
  readings: Array<RegisterReadingInput>;
  serviceId: Scalars['String']['input'];
  source: MeterReadSource;
};

export type MeterReadingResponse = {
  __typename?: 'MeterReadingResponse';
  errors?: Maybe<Array<MeterReadingError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type MeterReadsFilterInput = {
  dateRange?: InputMaybe<DateRangeInput>;
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>;
  isRejected?: InputMaybe<Scalars['Boolean']['input']>;
  meterIds?: InputMaybe<Array<Scalars['String']['input']>>;
  onlyAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<MeterReadSource>>;
};

export type MeterReadsHistoryInput = {
  cursorPaginationInput?: InputMaybe<CursorPaginationInput>;
  filters?: InputMaybe<MeterReadsFilterInput>;
  /** If both pagination inputs are provided, offsetPaginationInput will be used */
  offsetPaginationInput?: InputMaybe<OffsetPaginationInput>;
  /** @deprecated Use cursorPaginationInput or offsetPaginationInput instead */
  paginationInput?: InputMaybe<CursorPaginationInput>;
};

export type MeterReadsHistoryResponse = {
  __typename?: 'MeterReadsHistoryResponse';
  /** nextToken is used for cursor-based pagination. It will be empty string if no cursor pagination is used */
  nextToken: Scalars['String']['output'];
  reads: Array<EnergyMeterRead>;
  /** totalCount is only returned for the offset-based pagination. It will be null if no offset pagination is used */
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MeterpointEnergy = {
  installedMeter?: Maybe<EnergyMeter>;
  meters: Array<EnergyMeter>;
  /** Fit services have phantom meterpoints to keep structure, so mpxn will be an empty string */
  mpxn: Scalars['String']['output'];
  /**
   * The physical property at which this meterpoint exists.
   * This is only present for meterpoints registered in Gentrack.
   */
  property?: Maybe<EnergyProperty>;
  /** @deprecated use EnergyService.occupancy.address */
  site?: Maybe<EnergySite>;
};

export type MeterpointEnergyElectricity = MeterpointEnergy & {
  __typename?: 'MeterpointEnergyElectricity';
  /**
   * Estimated annual consumption (EAC) for the meterpoint, sourced from Junifer.
   * Electricity meterpoints may report multiple registers (e.g. Day / Night for Economy 7).
   * Only available for meterpoints supplied by Gentrack.
   */
  annualConsumption?: Maybe<EnergyAnnualConsumption>;
  installedMeter?: Maybe<EnergyMeter>;
  meters: Array<EnergyMeter>;
  mpxn: Scalars['String']['output'];
  property?: Maybe<EnergyProperty>;
  /** @deprecated use EnergyService.occupancy.address */
  site?: Maybe<EnergySite>;
};

export type MeterpointEnergyFit = MeterpointEnergy & {
  __typename?: 'MeterpointEnergyFit';
  installedMeter?: Maybe<EnergyMeter>;
  meters: Array<EnergyMeter>;
  /** Fit services have phantom meterpoints to keep structure, so mpxn will be an empty string */
  mpxn: Scalars['String']['output'];
  property?: Maybe<EnergyProperty>;
  site?: Maybe<EnergySite>;
};

export type MeterpointEnergyGas = MeterpointEnergy & {
  __typename?: 'MeterpointEnergyGas';
  /**
   * Estimated annual quantity (AQ) for the meterpoint, sourced from Junifer.
   * Gas meterpoints always report a single register with rate type GAS.
   * Only available for meterpoints supplied by Gentrack.
   */
  annualConsumption?: Maybe<EnergyAnnualConsumption>;
  installedMeter?: Maybe<EnergyMeter>;
  meters: Array<EnergyMeter>;
  mpxn: Scalars['String']['output'];
  property?: Maybe<EnergyProperty>;
  /** @deprecated use EnergyService.occupancy.address */
  site?: Maybe<EnergySite>;
};

export type MobileAbandonHandsetOrderRequest = {
  orderId: Scalars['ID']['input'];
};

export type MobileAbandonHandsetOrderResponse = {
  __typename?: 'MobileAbandonHandsetOrderResponse';
  accepted: Scalars['Boolean']['output'];
};

export type MobileActivatableSimResponse = {
  __typename?: 'MobileActivatableSimResponse';
  msisdn: Scalars['String']['output'];
  serviceID?: Maybe<Scalars['String']['output']>;
};

export type MobileActivateSimRequest = {
  cli?: InputMaybe<Scalars['String']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
};

export type MobileActivateSimResponse = {
  __typename?: 'MobileActivateSimResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileActiveContractForServiceV2Request = {
  serviceId: Scalars['String']['input'];
};

export type MobileActiveContractForServiceV2Response = {
  __typename?: 'MobileActiveContractForServiceV2Response';
  contractMonths?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  handset?: Maybe<MobileContractHandset>;
  id: Scalars['String']['output'];
  monthlyPrice: MobileMoney;
  signedAt?: Maybe<Scalars['String']['output']>;
  status: MobileHandsetContractStatus;
};

export type MobileAddSimAvailableUpgrades = {
  __typename?: 'MobileAddSimAvailableUpgrades';
  availableTariffs?: Maybe<Array<MobileServiceTariff>>;
  budgetControl: Scalars['Boolean']['output'];
  mobileService?: Maybe<MobileService>;
};

export type MobileAddSimPendingService = {
  __typename?: 'MobileAddSimPendingService';
  budgetControl: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  simType?: Maybe<SimType>;
  status: MobileServiceState;
  tariff: MobileServiceTariff;
};

export type MobileAddSimQuoteRequest = {
  quoteId: Scalars['String']['input'];
};

export type MobileAddSimQuoteResponse = {
  __typename?: 'MobileAddSimQuoteResponse';
  additionalAvailablePlans: Array<MobileServiceTariff>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableHandsets?: Maybe<Array<Maybe<MobileHandset>>>;
  billCustomerAddress?: Maybe<MobileBillCustomerAddress>;
  channel?: Maybe<Scalars['String']['output']>;
  cost: MobileAddSimUpgradeQuoteCost;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['String']['output']>;
  existingServices?: Maybe<Array<MobileAddSimAvailableUpgrades>>;
  newServices: Array<MobileAddSimUpgradeQuoteNewPlan>;
  quoteId: Scalars['String']['output'];
  quoteStatus?: Maybe<MobileServiceQuoteStatus>;
  requestedChanges: Array<MobileAddSimUpgradeQuotePlanUpgrade>;
  submittedAt?: Maybe<Scalars['String']['output']>;
};

export type MobileAddSimSubmitQuoteRequest = {
  quoteId: Scalars['String']['input'];
};

export type MobileAddSimSubmitQuoteResponse = {
  __typename?: 'MobileAddSimSubmitQuoteResponse';
  success: Scalars['Boolean']['output'];
};

export enum MobileAddSimUpgradeAvailability {
  Available = 'AVAILABLE',
  UnavailableAccountCancelled = 'UNAVAILABLE_ACCOUNT_CANCELLED',
  UnavailableAccountClosed = 'UNAVAILABLE_ACCOUNT_CLOSED',
  UnavailableAtOnlineUpgradeLimit = 'UNAVAILABLE_AT_ONLINE_UPGRADE_LIMIT',
  UnavailableBusinessCustomer = 'UNAVAILABLE_BUSINESS_CUSTOMER',
  UnavailableError = 'UNAVAILABLE_ERROR',
  UnavailableHasInFlightTariffChange = 'UNAVAILABLE_HAS_IN_FLIGHT_TARIFF_CHANGE',
  UnavailableInDebt = 'UNAVAILABLE_IN_DEBT',
  UnavailableMarkedAsFraud = 'UNAVAILABLE_MARKED_AS_FRAUD',
  UnavailableOnlyUpgrade = 'UNAVAILABLE_ONLY_UPGRADE',
  UnavailableOrderRecentlyPlaced = 'UNAVAILABLE_ORDER_RECENTLY_PLACED'
}

export type MobileAddSimUpgradeAvailabilityWithPendingResponse = {
  __typename?: 'MobileAddSimUpgradeAvailabilityWithPendingResponse';
  pendingNewServices?: Maybe<Array<Maybe<MobileAddSimPendingService>>>;
  pendingTariffChanges?: Maybe<Array<Maybe<MobileAddSimPendingService>>>;
  upgradeAvailability: MobileAddSimUpgradeAvailability;
};

export type MobileAddSimUpgradeQuoteCost = {
  __typename?: 'MobileAddSimUpgradeQuoteCost';
  cost: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  previousTotal: Scalars['String']['output'];
  total: Scalars['String']['output'];
};

export type MobileAddSimUpgradeQuoteNewPlan = {
  __typename?: 'MobileAddSimUpgradeQuoteNewPlan';
  budgetControl?: Maybe<Scalars['Boolean']['output']>;
  handset?: Maybe<MobileHandset>;
  id?: Maybe<Scalars['String']['output']>;
  porting?: Maybe<MobileAddSimUpgradingPortingType>;
  simType?: Maybe<SimType>;
  tariff?: Maybe<MobileServiceTariff>;
};

export type MobileAddSimUpgradeQuoteNewPlanRequest = {
  budgetControl?: InputMaybe<Scalars['Boolean']['input']>;
  handsetId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  portingPAC?: InputMaybe<MobileAddSimUpgradeQuotePortingPacInput>;
  portingSTAC?: InputMaybe<MobileAddSimUpgradeQuotePortingStacInput>;
  simType?: InputMaybe<SimType>;
  tariffId: Scalars['String']['input'];
};

export type MobileAddSimUpgradeQuotePlanUpgrade = {
  __typename?: 'MobileAddSimUpgradeQuotePlanUpgrade';
  backdate?: Maybe<Scalars['Boolean']['output']>;
  budgetControl?: Maybe<Scalars['Boolean']['output']>;
  currentService?: Maybe<MobileService>;
  newTariff?: Maybe<MobileServiceTariff>;
  simType?: Maybe<SimType>;
};

export type MobileAddSimUpgradeQuotePlanUpgradeRequest = {
  backdate?: InputMaybe<Scalars['Boolean']['input']>;
  budgetControl?: InputMaybe<Scalars['Boolean']['input']>;
  newTariffId?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
  simType?: InputMaybe<SimType>;
};

export type MobileAddSimUpgradeQuotePortingPac = {
  __typename?: 'MobileAddSimUpgradeQuotePortingPAC';
  cli: Scalars['String']['output'];
  code: Scalars['String']['output'];
};

export type MobileAddSimUpgradeQuotePortingPacInput = {
  cli: Scalars['String']['input'];
  code: Scalars['String']['input'];
};

export type MobileAddSimUpgradeQuotePortingStac = {
  __typename?: 'MobileAddSimUpgradeQuotePortingSTAC';
  cli: Scalars['String']['output'];
  code: Scalars['String']['output'];
  date?: Maybe<Scalars['String']['output']>;
};

export type MobileAddSimUpgradeQuotePortingStacInput = {
  cli?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
};

export type MobileAddSimUpgradeQuoteRequest = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  quoteId?: InputMaybe<Scalars['String']['input']>;
  requestedNewPlans?: InputMaybe<Array<MobileAddSimUpgradeQuoteNewPlanRequest>>;
  requestedUpgrades?: InputMaybe<Array<MobileAddSimUpgradeQuotePlanUpgradeRequest>>;
};

export type MobileAddSimUpgradeQuoteResponse = {
  __typename?: 'MobileAddSimUpgradeQuoteResponse';
  additionalAvailablePlans: Array<MobileServiceTariff>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  availableHandsets?: Maybe<Array<Maybe<MobileHandset>>>;
  billCustomerAddress?: Maybe<MobileBillCustomerAddress>;
  channel?: Maybe<Scalars['String']['output']>;
  cost: MobileAddSimUpgradeQuoteCost;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  estimatedDeliveryDate?: Maybe<Scalars['String']['output']>;
  existingServices?: Maybe<Array<MobileAddSimAvailableUpgrades>>;
  newServices: Array<MobileAddSimUpgradeQuoteNewPlan>;
  quoteId: Scalars['String']['output'];
  quoteStatus?: Maybe<MobileServiceQuoteStatus>;
  requestedChanges: Array<MobileAddSimUpgradeQuotePlanUpgrade>;
  submittedAt?: Maybe<Scalars['String']['output']>;
};

export type MobileAddSimUpgradingPortingType = MobileAddSimUpgradeQuotePortingPac | MobileAddSimUpgradeQuotePortingStac;

export type MobileAvailableHandsetsRequest = {
  includeOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MobileAvailableHandsetsResponse = {
  __typename?: 'MobileAvailableHandsetsResponse';
  brands: Array<MobileHandsetBrand>;
};

export type MobileBillCustomerAddress = {
  __typename?: 'MobileBillCustomerAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2: Scalars['String']['output'];
  addressLine3: Scalars['String']['output'];
  addressLine4: Scalars['String']['output'];
  county: Scalars['String']['output'];
  postCode: Scalars['String']['output'];
};

export type MobileBlacklistHandsetRequest = {
  cli: Scalars['String']['input'];
  imeiNumbers: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MobileBlacklistHandsetResponse = {
  __typename?: 'MobileBlacklistHandsetResponse';
  success: Scalars['Boolean']['output'];
};

export enum MobileBusinessUnit {
  BusinessUnit_1P = 'BUSINESS_UNIT_1P',
  BusinessUnitUnknown = 'BUSINESS_UNIT_UNKNOWN',
  BusinessUnitUw = 'BUSINESS_UNIT_UW'
}

export type MobileCanOrderReplacementEsimResponse = {
  __typename?: 'MobileCanOrderReplacementESIMResponse';
  canOrder: Scalars['Boolean']['output'];
};

export type MobileCanResendESimActivationEmailRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileCanResendESimActivationEmailResponse = {
  __typename?: 'MobileCanResendESimActivationEmailResponse';
  expiresAt?: Maybe<Scalars['String']['output']>;
  nextSend?: Maybe<Scalars['String']['output']>;
  resendable: Scalars['Boolean']['output'];
};

export type MobileCancelActiveContractForServiceRequest = {
  cancellationReason: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type MobileCatalogue = {
  __typename?: 'MobileCatalogue';
  eligibleServices: Array<MobileHandsetEligibleService>;
  handsets: Array<MobileHandsetBrand>;
  resumableOrders: Array<MobileHandsetOrder>;
};


export type MobileCatalogueHandsetsArgs = {
  includeOutOfStock?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MobileChangeServiceNameRequest = {
  newName: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type MobileChangeServiceNameResponse = {
  __typename?: 'MobileChangeServiceNameResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileContractByRequestIdRequest = {
  requestId: Scalars['String']['input'];
};

export type MobileContractByRequestIdResponse = {
  __typename?: 'MobileContractByRequestIDResponse';
  createdAt: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  monthlyPrice: MobileMoney;
  status: MobileHandsetContractStatus;
};

export type MobileContractHandset = {
  __typename?: 'MobileContractHandset';
  battery: Scalars['String']['output'];
  capacity: Scalars['String']['output'];
  colours: Scalars['String']['output'];
  contractTermMonths: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  screenSize: Scalars['String']['output'];
  specificationsLink: Scalars['String']['output'];
};

export type MobileContractRenewalDateResponse = {
  __typename?: 'MobileContractRenewalDateResponse';
  currentSupplier: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
};

export type MobileCreateHandsetOrderError = {
  __typename?: 'MobileCreateHandsetOrderError';
  existingOrder?: Maybe<MobileHandsetOrder>;
  reason: MobileCreateHandsetOrderErrorReason;
};

export enum MobileCreateHandsetOrderErrorReason {
  OpenLoanApplication = 'OPEN_LOAN_APPLICATION',
  OrderAlreadyOpen = 'ORDER_ALREADY_OPEN',
  OutOfStock = 'OUT_OF_STOCK',
  ServiceNotEligible = 'SERVICE_NOT_ELIGIBLE'
}

export type MobileCreateHandsetOrderRequest = {
  serviceId: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};

export type MobileCreateHandsetOrderResponse = {
  __typename?: 'MobileCreateHandsetOrderResponse';
  error?: Maybe<MobileCreateHandsetOrderError>;
  order?: Maybe<MobileHandsetOrder>;
};

export type MobileDataUsage = {
  __typename?: 'MobileDataUsage';
  allowance: Scalars['String']['output'];
  consumed: Scalars['String']['output'];
  consumedUnit: Scalars['String']['output'];
};

export type MobileDownloadEeccContractRequest = {
  id: Scalars['String']['input'];
};

export type MobileDownloadEeccContractResponse = {
  __typename?: 'MobileDownloadEeccContractResponse';
  downloadLink: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
};

export type MobileEligibilityRedirectUrlRequest = {
  requestId: Scalars['String']['input'];
};

export type MobileEligibilityRedirectUrlResponse = {
  __typename?: 'MobileEligibilityRedirectURLResponse';
  iehubRedirectUrl: Scalars['String']['output'];
};

export enum MobileEsimReplacementStatus {
  Cancelled = 'CANCELLED',
  Dispatched = 'DISPATCHED',
  Pending = 'PENDING'
}

export enum MobileFinancingAgreementType {
  Hp = 'HP'
}

export type MobileFinancingTerms = {
  __typename?: 'MobileFinancingTerms';
  agreementType: MobileFinancingAgreementType;
  aprPercent: Scalars['Float']['output'];
  balloonPayment: MobileMoney;
  cashPrice: MobileMoney;
  deposit: MobileMoney;
  monthlyRepayment: MobileMoney;
  termMonths: Scalars['Int']['output'];
  totalAmountPayable: MobileMoney;
};

export type MobileGenerateAndEmailEeccContractRequest = {
  quoteId: Scalars['String']['input'];
};

export type MobileGenerateAndEmailEeccContractResponse = {
  __typename?: 'MobileGenerateAndEmailEeccContractResponse';
  createdAt: Scalars['String']['output'];
  downloadExpiresAt: Scalars['String']['output'];
  downloadLink: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type MobileGetBarredSimStatusRequest = {
  serviceId: Scalars['String']['input'];
  simNumber: Scalars['String']['input'];
};

export type MobileGetBarredSimStatusResponse = {
  __typename?: 'MobileGetBarredSimStatusResponse';
  barredDate?: Maybe<Scalars['DateTimeRFC3339']['output']>;
  cli?: Maybe<Scalars['String']['output']>;
  msoRequestedBarDate?: Maybe<Scalars['DateTimeRFC3339']['output']>;
  requestedBarDate?: Maybe<Scalars['DateTimeRFC3339']['output']>;
  serviceID?: Maybe<Scalars['String']['output']>;
  simNo?: Maybe<Scalars['String']['output']>;
};

export type MobileHandset = {
  __typename?: 'MobileHandset';
  active: Scalars['Boolean']['output'];
  contractTerm: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  monthlyCharge: MobileMoney;
  name: Scalars['String']['output'];
  outOfStock: Scalars['Boolean']['output'];
};

export type MobileHandsetAttribute = {
  __typename?: 'MobileHandsetAttribute';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type MobileHandsetBrand = {
  __typename?: 'MobileHandsetBrand';
  name: Scalars['String']['output'];
  phones: Array<MobileHandsetPhone>;
};

export enum MobileHandsetContractStatus {
  Abandoned = 'ABANDONED',
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  EligibilityApproved = 'ELIGIBILITY_APPROVED',
  EligibilityStarted = 'ELIGIBILITY_STARTED',
  Expired = 'EXPIRED',
  HandsetOrdered = 'HANDSET_ORDERED',
  PendingEligibility = 'PENDING_ELIGIBILITY'
}

export type MobileHandsetDeliveryAddress = {
  __typename?: 'MobileHandsetDeliveryAddress';
  lines: Array<Scalars['String']['output']>;
};

export type MobileHandsetEligibleService = {
  __typename?: 'MobileHandsetEligibleService';
  cli: Scalars['String']['output'];
  name: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
};

export type MobileHandsetEligibleServicesResponse = {
  __typename?: 'MobileHandsetEligibleServicesResponse';
  resumableContracts: Array<MobileResumableContract>;
  services: Array<MobileHandsetEligibleService>;
};

export type MobileHandsetInformationRequest = {
  imeiNumbers: Array<InputMaybe<Scalars['String']['input']>>;
};

export type MobileHandsetInformationResponse = {
  __typename?: 'MobileHandsetInformationResponse';
  imeiNumbers: Array<Maybe<Scalars['String']['output']>>;
  valid: Scalars['Boolean']['output'];
};

export type MobileHandsetOptionType = {
  __typename?: 'MobileHandsetOptionType';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type MobileHandsetOrder = {
  __typename?: 'MobileHandsetOrder';
  closeReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeRFC3339']['output'];
  financing?: Maybe<MobileHandsetOrderFinancing>;
  fulfilment?: Maybe<MobileHandsetOrderFulfilment>;
  handset: MobileHandsetOrderHandset;
  id: Scalars['ID']['output'];
  serviceId: Scalars['String']['output'];
  status: MobileHandsetOrderStatus;
  updatedAt: Scalars['DateTimeRFC3339']['output'];
};

export type MobileHandsetOrderFinancing = {
  __typename?: 'MobileHandsetOrderFinancing';
  loan?: Maybe<MobileHandsetOrderLoan>;
  loanApplication?: Maybe<MobileHandsetOrderLoanApplication>;
  terms: MobileFinancingTerms;
};

export type MobileHandsetOrderFulfilment = {
  __typename?: 'MobileHandsetOrderFulfilment';
  orderedAt: Scalars['DateTimeRFC3339']['output'];
};

export type MobileHandsetOrderHandset = {
  __typename?: 'MobileHandsetOrderHandset';
  capacity: Scalars['String']['output'];
  colour: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  manufacturer: Scalars['String']['output'];
  model: Scalars['String']['output'];
  name: Scalars['String']['output'];
  variantId: Scalars['String']['output'];
};

export type MobileHandsetOrderLoan = {
  __typename?: 'MobileHandsetOrderLoan';
  status: MobileLoanStatus;
};

export type MobileHandsetOrderLoanApplication = {
  __typename?: 'MobileHandsetOrderLoanApplication';
  eligibilityUrl?: Maybe<Scalars['String']['output']>;
  status: MobileLoanApplicationStatus;
};

export type MobileHandsetOrderRequest = {
  orderId: Scalars['ID']['input'];
};

export enum MobileHandsetOrderStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Ordered = 'ORDERED',
  Paid = 'PAID'
}

export type MobileHandsetOrdersRequest = {
  serviceId?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<MobileHandsetOrderStatus>>;
};

export type MobileHandsetPhone = {
  __typename?: 'MobileHandsetPhone';
  battery: Scalars['String']['output'];
  dualSim: Scalars['Boolean']['output'];
  eSim: Scalars['Boolean']['output'];
  fromPrice: MobileMoney;
  inStock: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  optionTypes: Array<MobileHandsetOptionType>;
  primaryImageUrl: Scalars['String']['output'];
  screenSize: Scalars['String']['output'];
  specificationsLink: Scalars['String']['output'];
  variants: Array<MobileHandsetVariant>;
  wifiStandard: Scalars['String']['output'];
};

export type MobileHandsetVariant = {
  __typename?: 'MobileHandsetVariant';
  attributes: Array<MobileHandsetAttribute>;
  id: Scalars['String']['output'];
  imageUrls: Array<Scalars['String']['output']>;
  inStock: Scalars['Boolean']['output'];
  monthlyCharge: MobileMoney;
  primaryImageUrl: Scalars['String']['output'];
  rrp: MobileMoney;
  terms: MobileFinancingTerms;
};

export type MobileIsEsimReplacementCancellableRequest = {
  serviceID: Scalars['String']['input'];
};

export type MobileIsEsimReplacementCancellableResponse = {
  __typename?: 'MobileIsEsimReplacementCancellableResponse';
  cancellable: Scalars['Boolean']['output'];
  reason?: Maybe<MobileEsimReplacementStatus>;
};

export enum MobileLoanApplicationStatus {
  Abandoned = 'ABANDONED',
  Approved = 'APPROVED',
  Created = 'CREATED',
  Declined = 'DECLINED',
  EligibilityStarted = 'ELIGIBILITY_STARTED',
  LoanCreated = 'LOAN_CREATED',
  PendingManualReview = 'PENDING_MANUAL_REVIEW'
}

export enum MobileLoanStatus {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Live = 'LIVE'
}

export type MobileMoney = {
  __typename?: 'MobileMoney';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export type MobileMoneyInput = {
  amount: Scalars['String']['input'];
  currency: Scalars['String']['input'];
};

export type MobilePortingGenerateVerificationCodeRequest = {
  donorCli: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type MobilePortingGenerateVerificationCodeResponse = {
  __typename?: 'MobilePortingGenerateVerificationCodeResponse';
  success: Scalars['Boolean']['output'];
};

export enum MobilePortingInErrors {
  PacNotFound = 'PAC_NOT_FOUND'
}

export type MobilePortingInRequest = {
  code: Scalars['String']['input'];
  donorCli: Scalars['String']['input'];
  serviceID: Scalars['String']['input'];
};

export type MobilePortingInResponse = {
  __typename?: 'MobilePortingInResponse';
  errorMessage?: Maybe<MobilePortingInErrors>;
  success: Scalars['Boolean']['output'];
};

export enum MobilePortingOutAuthCodeStatus {
  AuthCodeStatusGenerated = 'AUTH_CODE_STATUS_GENERATED',
  AuthCodeStatusRetrieved = 'AUTH_CODE_STATUS_RETRIEVED',
  AuthCodeStatusUnknown = 'AUTH_CODE_STATUS_UNKNOWN',
  AuthCodeStatusUw = 'AUTH_CODE_STATUS_UW'
}

export enum MobilePortingOutErrors {
  PacAlreadyExists = 'PAC_ALREADY_EXISTS',
  StacAlreadyExists = 'STAC_ALREADY_EXISTS'
}

export type MobilePortingOutInput = {
  cli: Scalars['String']['input'];
  correlationToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<MobilePortingOutSource>;
  time?: InputMaybe<Scalars['String']['input']>;
  type: MobilePortingType;
};

export enum MobilePortingOutSource {
  Source_1P = 'SOURCE_1P',
  SourceClubhouse = 'SOURCE_CLUBHOUSE',
  SourceCrm = 'SOURCE_CRM',
  SourceSmpp = 'SOURCE_SMPP',
  SourceUnknown = 'SOURCE_UNKNOWN'
}

export type MobilePortingOutState = {
  __typename?: 'MobilePortingOutState';
  authCode?: Maybe<Scalars['String']['output']>;
  authCodeExpiry?: Maybe<Scalars['String']['output']>;
  authCodeStatus?: Maybe<MobilePortingOutAuthCodeStatus>;
  businessUnit?: Maybe<MobileBusinessUnit>;
  cli?: Maybe<Scalars['String']['output']>;
  correlationToken?: Maybe<Scalars['String']['output']>;
  etf?: Maybe<MobileMoney>;
  id?: Maybe<Scalars['String']['output']>;
  prepayBalance?: Maybe<MobileMoney>;
  rawCli?: Maybe<Scalars['String']['output']>;
  requestTime?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  type?: Maybe<MobilePortingType>;
};

export type MobilePortingOutVerifiedPortOutRequest = {
  otpVerificationCode: Scalars['String']['input'];
  portRequest: MobilePortingOutInput;
  serviceId: Scalars['String']['input'];
};

export type MobilePortingOutVerifiedPortOutResponse = {
  __typename?: 'MobilePortingOutVerifiedPortOutResponse';
  errorMessage?: Maybe<MobilePortingOutErrors>;
  response?: Maybe<MobilePortingOutState>;
};

export enum MobilePortingType {
  PortTypeInfo = 'PORT_TYPE_INFO',
  PortTypePac = 'PORT_TYPE_PAC',
  PortTypeStac = 'PORT_TYPE_STAC',
  PortTypeUnknown = 'PORT_TYPE_UNKNOWN'
}

export enum MobileReplacementReason {
  Reason_4GUpgrade = 'REASON_4G_UPGRADE',
  ReasonDamagedSim = 'REASON_DAMAGED_SIM',
  ReasonFaultySim = 'REASON_FAULTY_SIM',
  ReasonHandsetUpgrade = 'REASON_HANDSET_UPGRADE',
  ReasonLostPhoneOrSimCard = 'REASON_LOST_PHONE_OR_SIM_CARD',
  ReasonSimNotDelivered = 'REASON_SIM_NOT_DELIVERED',
  /** @deprecated No longer supported */
  ReasonStolenPhone = 'REASON_STOLEN_PHONE',
  ReasonUnknown = 'REASON_UNKNOWN'
}

export type MobileRequestHandsetRequest = {
  handsetId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type MobileRequestHandsetResponse = {
  __typename?: 'MobileRequestHandsetResponse';
  redirectUrl: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MobileResendESimActivationEmailRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileResendESimActivationEmailResponse = {
  __typename?: 'MobileResendESimActivationEmailResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileResumableContract = {
  __typename?: 'MobileResumableContract';
  createdAt: Scalars['String']['output'];
  handsetName: Scalars['String']['output'];
  requestId: Scalars['String']['output'];
  serviceId: Scalars['String']['output'];
  status: MobileHandsetContractStatus;
};

export type MobileRoamingUsageRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileRoamingUsageResponse = {
  __typename?: 'MobileRoamingUsageResponse';
  data?: Maybe<MobileDataUsage>;
};

export type MobileSmsUsage = {
  __typename?: 'MobileSMSUsage';
  allowance: Scalars['String']['output'];
  consumed: Scalars['String']['output'];
};

export type MobileService = {
  __typename?: 'MobileService';
  activatedAt?: Maybe<Scalars['DateTimeRFC3339']['output']>;
  budgetControl: Scalars['Boolean']['output'];
  cli: Scalars['String']['output'];
  delivery?: Maybe<MobileServiceDelivery>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  portingCli?: Maybe<Scalars['String']['output']>;
  simNumber: Scalars['String']['output'];
  simType?: Maybe<SimType>;
  status: MobileServiceState;
  tags: Array<MobileServiceTags>;
  tariff: MobileServiceTariff;
};

export type MobileServiceAllowance = MobileServiceDataAllowance | MobileServiceMinutesAllowance | MobileServiceRoamingDataAllowance | MobileServiceSmsAllowance;

export type MobileServiceDataAllowance = {
  __typename?: 'MobileServiceDataAllowance';
  stringValue?: Maybe<Scalars['String']['output']>;
  unlimited?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['MobileBigInt']['output']>;
};

export type MobileServiceDelivery = {
  __typename?: 'MobileServiceDelivery';
  estimatedArrivalDate: Scalars['DateTimeRFC3339']['output'];
  estimatedDispatchDate: Scalars['DateTimeRFC3339']['output'];
  orderDate: Scalars['DateTimeRFC3339']['output'];
};

export type MobileServiceMinutesAllowance = {
  __typename?: 'MobileServiceMinutesAllowance';
  stringValue?: Maybe<Scalars['String']['output']>;
  unlimited?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['MobileBigInt']['output']>;
};

export enum MobileServiceQuoteStatus {
  Available = 'AVAILABLE',
  UnavailableAtSimLimit = 'UNAVAILABLE_AT_SIM_LIMIT',
  UnavailableContainsHandset = 'UNAVAILABLE_CONTAINS_HANDSET'
}

export type MobileServiceRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileServiceResponse = {
  __typename?: 'MobileServiceResponse';
  service?: Maybe<MobileService>;
};

export type MobileServiceRoamingDataAllowance = {
  __typename?: 'MobileServiceRoamingDataAllowance';
  stringValue?: Maybe<Scalars['String']['output']>;
  unlimited?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['MobileBigInt']['output']>;
};

export type MobileServiceSmsAllowance = {
  __typename?: 'MobileServiceSMSAllowance';
  stringValue?: Maybe<Scalars['String']['output']>;
  unlimited?: Maybe<Scalars['Boolean']['output']>;
  value?: Maybe<Scalars['MobileBigInt']['output']>;
};

export enum MobileServiceState {
  Ended = 'ENDED',
  Live = 'LIVE',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export enum MobileServiceTags {
  ESimReplacementPending = 'E_SIM_REPLACEMENT_PENDING',
  SimBarred = 'SIM_BARRED',
  TariffChangePending = 'TARIFF_CHANGE_PENDING'
}

export type MobileServiceTariff = {
  __typename?: 'MobileServiceTariff';
  allowances?: Maybe<Array<MobileServiceAllowance>>;
  canBackdate?: Maybe<Scalars['Boolean']['output']>;
  canBackdateAtDate?: Maybe<Scalars['String']['output']>;
  canToggleBudgetControl?: Maybe<Scalars['Boolean']['output']>;
  cost: MobileMoney;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<MobileServiceTariffDiscount>;
  features?: Maybe<Array<MobileServiceTariffFeature>>;
  id: Scalars['String']['output'];
  mustBackdate?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
};

export type MobileServiceTariffDiscount = {
  __typename?: 'MobileServiceTariffDiscount';
  amount: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export enum MobileServiceTariffFeature {
  Feat_5G = 'FEAT_5G',
  FeatEuRoaming = 'FEAT_EU_ROAMING',
  FeatUnknown = 'FEAT_UNKNOWN',
  FeatWifiAnd_4GCalling = 'FEAT_WIFI_AND_4G_CALLING'
}

export type MobileServiceUsageHistoryRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileServiceUsageHistoryResponse = {
  __typename?: 'MobileServiceUsageHistoryResponse';
  cycle: Scalars['String']['output'];
  usage?: Maybe<MobileServiceUsageResponse>;
};

export type MobileServiceUsageRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileServiceUsageResponse = {
  __typename?: 'MobileServiceUsageResponse';
  data?: Maybe<MobileDataUsage>;
  sms?: Maybe<MobileSmsUsage>;
  voice?: Maybe<MobileVoiceUsage>;
};

export type MobileServicesResponse = {
  __typename?: 'MobileServicesResponse';
  services: Array<MobileService>;
};

export type MobileSimBalanceRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileSimBalanceResponse = {
  __typename?: 'MobileSimBalanceResponse';
  balance: Scalars['String']['output'];
  currency: Scalars['String']['output'];
};

export enum MobileSimReplacementErrorReason {
  ContactDetailsChangedRecently = 'CONTACT_DETAILS_CHANGED_RECENTLY'
}

export type MobileSimReplacementRequest = {
  cli: Scalars['String']['input'];
  overrideAddressLine1?: InputMaybe<Scalars['String']['input']>;
  overrideAddressLine2?: InputMaybe<Scalars['String']['input']>;
  overrideAddressLine3?: InputMaybe<Scalars['String']['input']>;
  overrideAddressLine4?: InputMaybe<Scalars['String']['input']>;
  overrideCounty?: InputMaybe<Scalars['String']['input']>;
  overridePostCode?: InputMaybe<Scalars['String']['input']>;
  reason: MobileReplacementReason;
  simType?: InputMaybe<SimType>;
};

export type MobileSimReplacementResponse = {
  __typename?: 'MobileSimReplacementResponse';
  errorMessage?: Maybe<MobileSimReplacementErrorReason>;
  simBarred: Scalars['Boolean']['output'];
  simReplacementOnHold: Scalars['Boolean']['output'];
  simReplacementOrdered: Scalars['Boolean']['output'];
};

export type MobileSimRequestESimReplacementCancellationRequest = {
  serviceID: Scalars['String']['input'];
};

export type MobileSimRequestESimReplacementCancellationResponse = {
  __typename?: 'MobileSimRequestESimReplacementCancellationResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileSimSetting = {
  enabled: Scalars['Boolean']['input'];
  setting: MobileSimSettingType;
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type MobileSimSettingResponse = {
  __typename?: 'MobileSimSettingResponse';
  appliesAt?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  editable: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  setting: MobileSimSettingType;
  value: Scalars['Int']['output'];
};

export enum MobileSimSettingType {
  SettingAdultContent = 'SETTING_ADULT_CONTENT',
  SettingCallCap = 'SETTING_CALL_CAP',
  SettingInternationalCalling = 'SETTING_INTERNATIONAL_CALLING',
  SettingPremiumTextCall = 'SETTING_PREMIUM_TEXT_CALL',
  SettingRoaming = 'SETTING_ROAMING',
  SettingRoamingInternational = 'SETTING_ROAMING_INTERNATIONAL',
  SettingUnknown = 'SETTING_UNKNOWN'
}

export type MobileSimSettingsRequest = {
  serviceId: Scalars['String']['input'];
};

export type MobileSubmitContractRenewalDateRequest = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  currentSupplier: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
};

export type MobileSubmitContractRenewalDateResponse = {
  __typename?: 'MobileSubmitContractRenewalDateResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileTopupCompleteDeviceFingerprintRequest = {
  externalTransactionToken: Scalars['String']['input'];
};

export type MobileTopupCompleteDeviceFingerprintResponse = {
  __typename?: 'MobileTopupCompleteDeviceFingerprintResponse';
  requiredAction?: Maybe<MobileTopupRequiredAction>;
  transactionToken: Scalars['String']['output'];
};

export type MobileTopupCompleteRequest = {
  continueThreeDSToken: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  transactionToken: Scalars['String']['input'];
};

export type MobileTopupCompleteResponse = {
  __typename?: 'MobileTopupCompleteResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileTopupRequest = {
  amount: MobileMoneyInput;
  clientAppName: Scalars['String']['input'];
  clientAppVersion: Scalars['String']['input'];
  clientFingerPrint: Scalars['String']['input'];
  isStoredCard: Scalars['Boolean']['input'];
  paymentMethodToken: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  storeCard: Scalars['Boolean']['input'];
};

export type MobileTopupRequestResponse = {
  __typename?: 'MobileTopupRequestResponse';
  requiredAction?: Maybe<MobileTopupRequiredAction>;
  transactionToken: Scalars['String']['output'];
};

export type MobileTopupRequiredAction = {
  __typename?: 'MobileTopupRequiredAction';
  externalTransactionToken: Scalars['String']['output'];
  transactionData?: Maybe<Scalars['String']['output']>;
};

export type MobileUpdateSimSettingsRequest = {
  serviceId: Scalars['String']['input'];
  simSettings: Array<InputMaybe<MobileSimSetting>>;
};

export type MobileUpdateSimSettingsResponse = {
  __typename?: 'MobileUpdateSimSettingsResponse';
  success: Scalars['Boolean']['output'];
};

export type MobileValidateOtpVerificationCodeRequest = {
  cli: Scalars['String']['input'];
  otpCode: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type MobileValidateOtpVerificationCodeResponse = {
  __typename?: 'MobileValidateOTPVerificationCodeResponse';
  portingInfo?: Maybe<PortingInfo>;
  success: Scalars['Boolean']['output'];
};

export type MobileVoiceUsage = {
  __typename?: 'MobileVoiceUsage';
  allowance: Scalars['String']['output'];
  consumed: Scalars['String']['output'];
  consumedUnit: Scalars['String']['output'];
};

export type MoveInCustomerDetails = {
  dateOfBirth: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MoveInDetails = {
  code: Scalars['String']['input'];
  date: Scalars['String']['input'];
};

export enum MultiChoice {
  False = 'FALSE',
  True = 'TRUE',
  Unknown = 'UNKNOWN'
}

export type Mutation = {
  __typename?: 'Mutation';
  accountPlatform: AccountPlatformMutation;
  amendBudgetPlan: AmendBudgetPlanResponse;
  cbcActivateCard: Scalars['Boolean']['output'];
  cbcApproveChallenge: CbcApproveChallengeResponse;
  cbcBlockCard: Scalars['Boolean']['output'];
  cbcCancelLowBalanceTopup: Scalars['Boolean']['output'];
  cbcCancelScheduledTopup: Scalars['Boolean']['output'];
  cbcCancelWallet: Scalars['Boolean']['output'];
  cbcCompleteFingerprint: Scalars['String']['output'];
  cbcContinue3DSTransaction: CbcContinue3DsTransactionResponse;
  cbcConvertToPhysical: Scalars['Boolean']['output'];
  cbcCreateDocumentCheck: Scalars['Boolean']['output'];
  cbcCreateLowBalanceTopup: Scalars['Boolean']['output'];
  cbcCreateScheduledTopup: Scalars['Boolean']['output'];
  cbcCreateServiceOrder: Scalars['Boolean']['output'];
  cbcDisableATMWithdrawals: Scalars['Boolean']['output'];
  cbcDisableAccountPushNotifications: Scalars['Boolean']['output'];
  cbcDisableContactless: Scalars['Boolean']['output'];
  cbcDisableLowBalanceTopup: Scalars['Boolean']['output'];
  cbcDisableMagstripe: Scalars['Boolean']['output'];
  cbcDisableScheduledTopup: Scalars['Boolean']['output'];
  cbcEnableATMWithdrawals: Scalars['Boolean']['output'];
  cbcEnableAccountPushNotifications: Scalars['Boolean']['output'];
  cbcEnableContactless: Scalars['Boolean']['output'];
  cbcEnableLowBalanceTopup: Scalars['Boolean']['output'];
  cbcEnableMagstripe: Scalars['Boolean']['output'];
  cbcEnableScheduledTopup: Scalars['Boolean']['output'];
  cbcEnrollForInAppChallenges: Scalars['Boolean']['output'];
  cbcExecuteRefund: CbcExecuteRefundResponse;
  cbcGenerateTimeBasedSecret: Scalars['String']['output'];
  cbcInitiatePayment: CbcInitiatePaymentResponse;
  cbcOrderAdditionalCard: Scalars['Boolean']['output'];
  cbcRegisterPushNotificationsToken: Scalars['Boolean']['output'];
  cbcRejectTransaction: Scalars['Boolean']['output'];
  cbcReplaceCard: Scalars['Boolean']['output'];
  cbcSetCardHolderEmail: Scalars['Boolean']['output'];
  cbcSetCardHolderIsOptedInToMarketingComms: Scalars['Boolean']['output'];
  cbcSetCardHolderMobile: Scalars['Boolean']['output'];
  cbcSetRetailerFavourite: Scalars['Boolean']['output'];
  cbcTopUpWallet: CbcTopUpResponse;
  cbcTopUpWalletWithNewPaymentMethod: CbcTopUpResponse;
  cbcUnblockCard: Scalars['Boolean']['output'];
  cbcVerifyCardHolderMobile: Scalars['Boolean']['output'];
  cbcVerifyNewPaymentMethod: CbcTopUpResponse;
  cbcVerifyPaymentMethod: CbcTopUpResponse;
  changeAccountSmartConsentLevel?: Maybe<ChangeAccountSmartConsentLevelResponse>;
  /** @deprecated Use `Account Platform` mutation instead */
  changeEmail?: Maybe<ChangeEmailResult>;
  changePassword?: Maybe<ChangePasswordResult>;
  clearChatState: Scalars['Boolean']['output'];
  closeAccount: CloseAccountResponse;
  completePasswordReset?: Maybe<CompletePasswordResetResult>;
  contactChannels?: Maybe<ContactChannelsMutation>;
  continue3DS: Continue3DsResponse;
  continueChallengedPayment: ContinueChallengedPaymentResult;
  createBasket: Basket;
  createPaymentPlan?: Maybe<CreatePaymentPlanResponse>;
  customerBilling: CustomerBillingMutation;
  customerSupport: CustomerSupportMutations;
  /** @deprecated No longer supported */
  digitalSupport?: Maybe<DigitalSupportMutation>;
  editDirectDebitMandate: EditDirectDebitMandateOutcome;
  energyEvSwitchToEvTariff: EnergyEvSwitchToEvTariffResponse;
  energySBBookAppointment: EnergySbBookingAppointmentResponse;
  energySBBookAppointmentPointOfSale: EnergySbBookingAppointmentResponse;
  energySBRegisterInterest: EnergySbRegisterInterestResponse;
  energySBRescheduleAppointment: EnergySbRescheduleAppointmentResponse;
  fixed_line_rebook_appointment: RebookBroadbandAppointmentResponse;
  fixed_line_request_line_test: RequestLineTestResponse;
  fixed_line_reserve_appointment: ReserveBroadbandAppointmentResponse;
  fixed_line_resolve_external_fault: Scalars['Boolean']['output'];
  get_fixed_line_equipment_quote: FixedLineEquipmentQuote;
  initiateCardPayment: CardPaymentCheckout;
  initiateOpenBankingPayment: OpenBankingPaymentCheckout;
  insuranceCancelHomeMTAQuoteV2: Scalars['Boolean']['output'];
  insuranceCancelMotorMTAQuote: Scalars['Boolean']['output'];
  insuranceCancelPolicy: Scalars['Boolean']['output'];
  insuranceCancelPolicyV2: Scalars['Boolean']['output'];
  insuranceConvertHomeMTAQuoteV2: Scalars['Boolean']['output'];
  insuranceConvertMotorMTAQuote: Scalars['Boolean']['output'];
  insuranceConvertQuote: Scalars['Boolean']['output'];
  insuranceCreateBoilerQuote: InsuranceQuote;
  insuranceCreateHomeMTAQuoteV2?: Maybe<InsuranceHomeQuoteV2>;
  insuranceCreateHomeQuote: InsuranceHomeQuote;
  insuranceCreateHomeQuoteV2?: Maybe<InsuranceHomeQuoteV2>;
  insuranceCreateMotorMTAQuote?: Maybe<InsuranceMotorQuote>;
  insuranceCreateMotorQuote?: Maybe<InsuranceMotorQuote>;
  insuranceCreateProtectorQuote: InsuranceQuote;
  insuranceDevToolsApplyAction: Scalars['Boolean']['output'];
  insuranceGenerateQuoteDocuments: Scalars['Boolean']['output'];
  insuranceMoveProtectorPolicy: InsuranceMoveProtectorPolicyResult;
  insuranceQuoteIncludedInPromotion: Scalars['Boolean']['output'];
  insuranceReinstatePolicy: Scalars['Boolean']['output'];
  insuranceReloadHomeQuote?: Maybe<InsuranceHomeQuote>;
  insuranceSendHomeQuote: Scalars['Boolean']['output'];
  insuranceSendPolicyDocuments: Scalars['Boolean']['output'];
  insuranceSendQuote: Scalars['Boolean']['output'];
  /** @deprecated Use `insuranceSubmitExternalRenewalDate` instead */
  insuranceSubmitExternalHomeRenewalDate: Scalars['Boolean']['output'];
  insuranceSubmitExternalRenewalDate: Scalars['Boolean']['output'];
  insuranceSubmitHomeMTAQuoteV2?: Maybe<InsuranceHomeQuoteV2>;
  insuranceSubmitHomeQuote?: Maybe<InsuranceHomeQuote>;
  insuranceSubmitHomeQuoteV2?: Maybe<InsuranceHomeQuoteV2>;
  insuranceSubmitMotorMTAQuote?: Maybe<InsuranceMotorQuote>;
  insuranceSubmitMotorQuote?: Maybe<InsuranceMotorQuote>;
  insuranceUpdateAndSendPolicyDocuments: Scalars['Boolean']['output'];
  insuranceUpdateCommsPreference: Scalars['Boolean']['output'];
  insuranceUpdateHomeQuote?: Maybe<InsuranceHomeQuote>;
  insuranceUpdateHomeQuoteAddons?: Maybe<InsuranceHomeQuote>;
  insuranceUpdateHomeQuoteV2?: Maybe<InsuranceHomeQuoteV2>;
  insuranceUpdateMotorQuote?: Maybe<InsuranceMotorQuote>;
  insuranceUpdatePolicyAddress: Scalars['Boolean']['output'];
  insuranceUpdatePolicyAutoRenewal: InsurancePolicy;
  insuranceUpdatePolicyDocuments: Scalars['Boolean']['output'];
  insuranceWithdrawPolicyCancellationV2: Scalars['Boolean']['output'];
  legacyPlaceholder?: Maybe<Scalars['Boolean']['output']>;
  makePayment: MakePaymentResult;
  mobileAbandonHandsetOrder: MobileAbandonHandsetOrderResponse;
  mobileActivateSim: MobileActivateSimResponse;
  mobileAddSimSubmitQuote: MobileAddSimSubmitQuoteResponse;
  mobileBlacklistHandset: MobileBlacklistHandsetResponse;
  /** @deprecated Use mobileAbandonHandsetOrder. */
  mobileCancelActiveContractForService: Scalars['Boolean']['output'];
  mobileChangeServiceName: MobileChangeServiceNameResponse;
  mobileCreateHandsetOrder: MobileCreateHandsetOrderResponse;
  mobileGenerateAndEmailEeccContract: MobileGenerateAndEmailEeccContractResponse;
  mobilePortingGenerateVerificationCode: MobilePortingGenerateVerificationCodeResponse;
  mobilePortingIn: MobilePortingInResponse;
  mobilePortingVerifiedPortOut: MobilePortingOutVerifiedPortOutResponse;
  /** @deprecated Use mobileCreateHandsetOrder. */
  mobileRequestHandset: MobileRequestHandsetResponse;
  mobileRequestSimReplacement: MobileSimReplacementResponse;
  mobileResendESimActivationEmail?: Maybe<MobileResendESimActivationEmailResponse>;
  mobileSimRequestESimReplacementCancellation: MobileSimRequestESimReplacementCancellationResponse;
  mobileSubmitContractRenewalDate: MobileSubmitContractRenewalDateResponse;
  mobileTopupComplete: MobileTopupCompleteResponse;
  mobileTopupCompleteDeviceFingerprint: MobileTopupCompleteDeviceFingerprintResponse;
  mobileTopupRequest: MobileTopupRequestResponse;
  mobileUpdateSimSettings: MobileUpdateSimSettingsResponse;
  /** Processes a payment against the customer's balance. If `isDue` is true, the payment is applied toward the upcoming month's billing cycle. */
  payCustomerBalance: PayCustomerBalanceResult;
  payOverdueDebt?: Maybe<PayOverdueDebtResponse>;
  pingCbc: Scalars['Boolean']['output'];
  redactPaymentMethod: RedactPaymentMethodOutcome;
  /**
   * Links the given email address to the given account, and sends a password reset email.
   * Uses the postcode and account number matching to verify the account.
   * Requires a castle token.
   */
  registerAccountEmail: RegisterAccountEmailResult;
  registerSmartBookingInterest: EnergySmartBookingRegisterInterestResponse;
  revokeCbcConsent?: Maybe<Scalars['Boolean']['output']>;
  sendHelpArticleFeedback: Scalars['Boolean']['output'];
  sendSupportRequestEmail: Scalars['Boolean']['output'];
  /** @deprecated Use `Account Platform` mutation instead */
  sendVerificationEmail?: Maybe<Scalars['Boolean']['output']>;
  setUpMoveInCustomer: SetUpMoveInCustomerResult;
  setupBudgetPlan: SetupBudgetPlanResponse;
  setupDirectDebitMandate: SetupDirectDebitMandateOutcome;
  smartBookingAppointment: EnergySmartBookingAppointmentResponse;
  smartBookingAppointmentReschedule: EnergySmartBookingAppointmentResponse;
  startPasswordReset?: Maybe<StartPasswordResetResult>;
  storeContactSession: StoreContactSessionOutput;
  submitCbcConsent?: Maybe<Scalars['Boolean']['output']>;
  submitMeterReading: MeterReadingResponse;
  submitSelfServeForm: SubmitSelfServeFormResponse;
  submit_fixed_line_contract_renewal_date: Scalars['Boolean']['output'];
  submit_fixed_line_equipment_quote: FixedLineEquipmentQuote;
  submit_fixed_line_quote: Scalars['Boolean']['output'];
  submit_fixed_line_sub_product: FixedLineSubProductResponse;
  /**
   * Switch the energy tariff for one of the calling customer's own services. Changes may not
   * take effect immediately.
   * @deprecated Use switchEnergyTariffs(services: ...) to support single or multiple service tariff changes.
   */
  switchEnergyTariff: EnergyTariffSwitchResponse;
  /**
   * Switch the energy tariffs for one or more of the calling customer's own services. Changes
   * may not take effect immediately.
   */
  switchEnergyTariffs: EnergyTariffSwitchResponse;
  trackCustomer?: Maybe<TrackCustomerResult>;
  uploadSelfServeFormAttachments: SelfServeFormAttachmentResponse;
  upsertCitizenConsent: UpsertCitizenConsentPayload;
  upsertCitizenPreference: UpsertCitizenPreferencePayload;
  /** @deprecated Use Query.validateMeterReading instead */
  validateMeterReading: MeterReadingResponse;
  validateMoveIn: ValidateMoveInResult;
  validatePasswordResetLink?: Maybe<Scalars['Boolean']['output']>;
  verifyCardPaymentMethod: CardPaymentCheckout;
};


export type MutationAmendBudgetPlanArgs = {
  input: AmendBudgetPlanInput;
};


export type MutationCbcActivateCardArgs = {
  activationCode: Scalars['String']['input'];
  cardID: Scalars['String']['input'];
};


export type MutationCbcApproveChallengeArgs = {
  transactionToken: Scalars['String']['input'];
};


export type MutationCbcBlockCardArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcCancelLowBalanceTopupArgs = {
  autoTopupId: Scalars['String']['input'];
};


export type MutationCbcCancelScheduledTopupArgs = {
  autoTopupId: Scalars['String']['input'];
};


export type MutationCbcCancelWalletArgs = {
  reason: CbcCancelWalletReason;
};


export type MutationCbcCompleteFingerprintArgs = {
  externalTransactionToken: Scalars['String']['input'];
};


export type MutationCbcContinue3DsTransactionArgs = {
  externalTransactionToken: Scalars['String']['input'];
};


export type MutationCbcConvertToPhysicalArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcCreateLowBalanceTopupArgs = {
  input?: InputMaybe<CbcCreateLowBalanceTopupRequest>;
};


export type MutationCbcCreateScheduledTopupArgs = {
  input?: InputMaybe<CbcCreateScheduledTopupRequest>;
};


export type MutationCbcCreateServiceOrderArgs = {
  cardHolders: Array<CbcCardHolderInput>;
  source: CbcOrderSourceInput;
};


export type MutationCbcDisableAtmWithdrawalsArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcDisableContactlessArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcDisableLowBalanceTopupArgs = {
  autoTopupId: Scalars['String']['input'];
};


export type MutationCbcDisableMagstripeArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcDisableScheduledTopupArgs = {
  autoTopupId: Scalars['String']['input'];
};


export type MutationCbcEnableAtmWithdrawalsArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcEnableContactlessArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcEnableLowBalanceTopupArgs = {
  autoTopupId: Scalars['String']['input'];
};


export type MutationCbcEnableMagstripeArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcEnableScheduledTopupArgs = {
  autoTopupId: Scalars['String']['input'];
};


export type MutationCbcExecuteRefundArgs = {
  input?: InputMaybe<CbcExecuteRefundRequest>;
};


export type MutationCbcGenerateTimeBasedSecretArgs = {
  cardId: Scalars['String']['input'];
};


export type MutationCbcInitiatePaymentArgs = {
  amountInPence: Scalars['Int']['input'];
};


export type MutationCbcOrderAdditionalCardArgs = {
  dateOfBirth: Scalars['DateTime']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCbcRegisterPushNotificationsTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationCbcRejectTransactionArgs = {
  transactionToken: Scalars['String']['input'];
};


export type MutationCbcReplaceCardArgs = {
  cardId: Scalars['String']['input'];
  reason: CbcCardReplacementReason;
};


export type MutationCbcSetCardHolderEmailArgs = {
  cardHolderId: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationCbcSetCardHolderIsOptedInToMarketingCommsArgs = {
  cardHolderId: Scalars['String']['input'];
  optedIn: Scalars['Boolean']['input'];
};


export type MutationCbcSetCardHolderMobileArgs = {
  cardHolderId: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};


export type MutationCbcSetRetailerFavouriteArgs = {
  favourite: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
};


export type MutationCbcTopUpWalletArgs = {
  amount: Scalars['Int']['input'];
  cardFingerprint?: InputMaybe<Scalars['String']['input']>;
  meta: CbcClientMetaData;
  paymentMethodToken: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
};


export type MutationCbcTopUpWalletWithNewPaymentMethodArgs = {
  amount: Scalars['Int']['input'];
  cardFingerprint?: InputMaybe<Scalars['String']['input']>;
  externalPaymentMethodToken: Scalars['String']['input'];
  meta: CbcClientMetaData;
  redirectURL: Scalars['String']['input'];
  savePaymentMethod: Scalars['Boolean']['input'];
};


export type MutationCbcUnblockCardArgs = {
  cardID: Scalars['String']['input'];
};


export type MutationCbcVerifyCardHolderMobileArgs = {
  cardHolderId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
};


export type MutationCbcVerifyNewPaymentMethodArgs = {
  cardFingerprint?: InputMaybe<Scalars['String']['input']>;
  externalPaymentMethodToken: Scalars['String']['input'];
  meta: CbcClientMetaData;
  redirectURL: Scalars['String']['input'];
};


export type MutationCbcVerifyPaymentMethodArgs = {
  cardFingerprint?: InputMaybe<Scalars['String']['input']>;
  meta: CbcClientMetaData;
  paymentMethodToken: Scalars['String']['input'];
  redirectURL: Scalars['String']['input'];
};


export type MutationChangeAccountSmartConsentLevelArgs = {
  input: ChangeAccountSmartConsentLevelInput;
};


export type MutationChangeEmailArgs = {
  email: Scalars['String']['input'];
  personID: Scalars['String']['input'];
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationClearChatStateArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationCloseAccountArgs = {
  closeAccountRequest: CloseAccountRequest;
};


export type MutationCompletePasswordResetArgs = {
  clientID: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};


export type MutationContinue3DsArgs = {
  input: Continue3DsInput;
};


export type MutationContinueChallengedPaymentArgs = {
  customerAccountID: Scalars['String']['input'];
  externalTransactionToken: Scalars['String']['input'];
};


export type MutationCreateBasketArgs = {
  accountId: Scalars['ID']['input'];
  isHomeOwner: Scalars['Boolean']['input'];
};


export type MutationCreatePaymentPlanArgs = {
  input: CreatePaymentPlanInput;
};


export type MutationEditDirectDebitMandateArgs = {
  input: EditDirectDebitMandateInput;
};


export type MutationEnergyEvSwitchToEvTariffArgs = {
  input: EnergyEvSwitchToEvTariffInput;
};


export type MutationEnergySbBookAppointmentArgs = {
  input: EnergySbBookAppointmentInput;
};


export type MutationEnergySbBookAppointmentPointOfSaleArgs = {
  input: EnergySbBookAppointmentPointOfSaleInput;
};


export type MutationEnergySbRegisterInterestArgs = {
  input: EnergySbRegisterInterestInput;
};


export type MutationEnergySbRescheduleAppointmentArgs = {
  input: EnergySbRescheduleAppointmentInput;
};


export type MutationFixed_Line_Rebook_AppointmentArgs = {
  appointment: BroadbandAppointmentInput;
  service_id: Scalars['String']['input'];
};


export type MutationFixed_Line_Request_Line_TestArgs = {
  request?: InputMaybe<RequestLineTestRequest>;
};


export type MutationFixed_Line_Reserve_AppointmentArgs = {
  appointment: BroadbandAppointmentInput;
  quote_id: Scalars['String']['input'];
};


export type MutationFixed_Line_Resolve_External_FaultArgs = {
  request?: InputMaybe<ResolveExternalFaultRequest>;
};


export type MutationGet_Fixed_Line_Equipment_QuoteArgs = {
  request?: InputMaybe<GetFixedLineEquipmentQuoteRequest>;
};


export type MutationInitiateCardPaymentArgs = {
  input: InitCardPaymentInput;
};


export type MutationInitiateOpenBankingPaymentArgs = {
  input: NewOpenBankingPaymentInput;
};


export type MutationInsuranceCancelHomeMtaQuoteV2Args = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceCancelMotorMtaQuoteArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceCancelPolicyArgs = {
  customerReason?: InputMaybe<InsurancePolicyCustomerRequestCancellationReason>;
  date: Scalars['DateTime']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
  policyId: Scalars['String']['input'];
  reason: InsurancePolicyCancellationReason;
  waivedFees?: InputMaybe<InsuranceWaivedFeesInput>;
};


export type MutationInsuranceCancelPolicyV2Args = {
  customerReason?: InputMaybe<InsurancePolicyCustomerRequestCancellationReason>;
  date: Scalars['Date']['input'];
  policyId: Scalars['String']['input'];
  reason: InsurancePolicyCancellationReason;
  waiveAdminFee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceConvertHomeMtaQuoteV2Args = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceConvertMotorMtaQuoteArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceConvertQuoteArgs = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  quoteId: Scalars['String']['input'];
  skipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceCreateBoilerQuoteArgs = {
  input: InsuranceCreateBoilerQuoteInput;
  skipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceCreateHomeMtaQuoteV2Args = {
  actionDate: Scalars['Date']['input'];
  actionTime?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceCreateHomeQuoteArgs = {
  accountId: Scalars['String']['input'];
  skipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceCreateHomeQuoteV2Args = {
  accountId: Scalars['String']['input'];
  skipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceCreateMotorMtaQuoteArgs = {
  actionDate: Scalars['Date']['input'];
  actionTime?: InputMaybe<Scalars['Time']['input']>;
  description: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceCreateMotorQuoteArgs = {
  accountId: Scalars['String']['input'];
  skipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceCreateProtectorQuoteArgs = {
  accountId: Scalars['String']['input'];
  product: InsuranceProduct;
  skipEligibility?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceDevToolsApplyActionArgs = {
  accountId: Scalars['String']['input'];
  action: Scalars['String']['input'];
  fields?: InputMaybe<Array<InputMaybe<InsuranceDevToolsFieldInput>>>;
};


export type MutationInsuranceGenerateQuoteDocumentsArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceMoveProtectorPolicyArgs = {
  newAccountId: Scalars['String']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceQuoteIncludedInPromotionArgs = {
  promotionName: Scalars['String']['input'];
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceReinstatePolicyArgs = {
  policyId: Scalars['String']['input'];
  reinstateDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationInsuranceReloadHomeQuoteArgs = {
  generateDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceSendHomeQuoteArgs = {
  quoteId: Scalars['String']['input'];
  regenerateDocuments?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInsuranceSendPolicyDocumentsArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceSendQuoteArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceSubmitExternalHomeRenewalDateArgs = {
  accountId: Scalars['String']['input'];
  date: Scalars['String']['input'];
};


export type MutationInsuranceSubmitExternalRenewalDateArgs = {
  accountId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  productClass: InsuranceProductClass;
};


export type MutationInsuranceSubmitHomeMtaQuoteV2Args = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceSubmitHomeQuoteArgs = {
  generateDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceSubmitHomeQuoteV2Args = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceSubmitMotorMtaQuoteArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceSubmitMotorQuoteArgs = {
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceUpdateAndSendPolicyDocumentsArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceUpdateCommsPreferenceArgs = {
  accountId: Scalars['String']['input'];
  commsPreference: InsuranceCommsPreference;
};


export type MutationInsuranceUpdateHomeQuoteArgs = {
  input?: InputMaybe<InsuranceUpdateHomeQuoteInput>;
};


export type MutationInsuranceUpdateHomeQuoteAddonsArgs = {
  addons?: InputMaybe<Array<InputMaybe<InsuranceHomeAddonInput>>>;
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceUpdateHomeQuoteV2Args = {
  input?: InputMaybe<InsuranceHomeRiskInput>;
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceUpdateMotorQuoteArgs = {
  input?: InputMaybe<InsuranceMotorRiskInput>;
  quoteId: Scalars['String']['input'];
};


export type MutationInsuranceUpdatePolicyAddressArgs = {
  input: InsuranceUpdatePolicyAddressInput;
};


export type MutationInsuranceUpdatePolicyAutoRenewalArgs = {
  autoRenewal: Scalars['Boolean']['input'];
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceUpdatePolicyDocumentsArgs = {
  policyId: Scalars['String']['input'];
};


export type MutationInsuranceWithdrawPolicyCancellationV2Args = {
  policyId: Scalars['String']['input'];
};


export type MutationMakePaymentArgs = {
  amount: AmountInput;
  clientFingerprint: Scalars['String']['input'];
  customerAccountID: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  paymentMethod: PaymentMethodInput;
  reason: PaymentReason;
  redirectURL: Scalars['String']['input'];
};


export type MutationMobileAbandonHandsetOrderArgs = {
  request: MobileAbandonHandsetOrderRequest;
};


export type MutationMobileActivateSimArgs = {
  request: MobileActivateSimRequest;
};


export type MutationMobileAddSimSubmitQuoteArgs = {
  request: MobileAddSimSubmitQuoteRequest;
};


export type MutationMobileBlacklistHandsetArgs = {
  request: MobileBlacklistHandsetRequest;
};


export type MutationMobileCancelActiveContractForServiceArgs = {
  request: MobileCancelActiveContractForServiceRequest;
};


export type MutationMobileChangeServiceNameArgs = {
  request: MobileChangeServiceNameRequest;
};


export type MutationMobileCreateHandsetOrderArgs = {
  request: MobileCreateHandsetOrderRequest;
};


export type MutationMobileGenerateAndEmailEeccContractArgs = {
  request: MobileGenerateAndEmailEeccContractRequest;
};


export type MutationMobilePortingGenerateVerificationCodeArgs = {
  request: MobilePortingGenerateVerificationCodeRequest;
};


export type MutationMobilePortingInArgs = {
  request: MobilePortingInRequest;
};


export type MutationMobilePortingVerifiedPortOutArgs = {
  req: MobilePortingOutVerifiedPortOutRequest;
};


export type MutationMobileRequestHandsetArgs = {
  request: MobileRequestHandsetRequest;
};


export type MutationMobileRequestSimReplacementArgs = {
  request: MobileSimReplacementRequest;
};


export type MutationMobileResendESimActivationEmailArgs = {
  request?: InputMaybe<MobileResendESimActivationEmailRequest>;
};


export type MutationMobileSimRequestESimReplacementCancellationArgs = {
  request: MobileSimRequestESimReplacementCancellationRequest;
};


export type MutationMobileSubmitContractRenewalDateArgs = {
  request: MobileSubmitContractRenewalDateRequest;
};


export type MutationMobileTopupCompleteArgs = {
  request: MobileTopupCompleteRequest;
};


export type MutationMobileTopupCompleteDeviceFingerprintArgs = {
  request: MobileTopupCompleteDeviceFingerprintRequest;
};


export type MutationMobileTopupRequestArgs = {
  request: MobileTopupRequest;
};


export type MutationMobileUpdateSimSettingsArgs = {
  request: MobileUpdateSimSettingsRequest;
};


export type MutationPayCustomerBalanceArgs = {
  amount: AmountInput;
  customerAccountID: Scalars['String']['input'];
  isDue: Scalars['Boolean']['input'];
};


export type MutationPayOverdueDebtArgs = {
  accountId: Scalars['String']['input'];
  amount: Scalars['String']['input'];
};


export type MutationRedactPaymentMethodArgs = {
  input: RedactPaymentMethodInput;
};


export type MutationRegisterAccountEmailArgs = {
  accountNumber: Scalars['String']['input'];
  newEmail: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
};


export type MutationRegisterSmartBookingInterestArgs = {
  input: EnergySmartBookingRegisterInterestInput;
};


export type MutationRevokeCbcConsentArgs = {
  id: Scalars['String']['input'];
};


export type MutationSendHelpArticleFeedbackArgs = {
  feedback: HelpArticleFeedbackInput;
};


export type MutationSendSupportRequestEmailArgs = {
  attachments: Array<SupportRequestEmailAttachmentReferenceInput>;
  customer?: InputMaybe<SupportRequestCustomerInput>;
  message: Scalars['String']['input'];
  subject: SupportRequestEmailSubjectInput;
  topic: SupportRequestEmailTopicInput;
};


export type MutationSendVerificationEmailArgs = {
  personID: Scalars['String']['input'];
};


export type MutationSetUpMoveInCustomerArgs = {
  accountNumber: Scalars['String']['input'];
  customerDetails: MoveInCustomerDetails;
  moveInDetails: MoveInDetails;
};


export type MutationSetupBudgetPlanArgs = {
  input: SetupBudgetPlanInput;
};


export type MutationSetupDirectDebitMandateArgs = {
  input: SetupDirectDebitMandateInput;
};


export type MutationSmartBookingAppointmentArgs = {
  input: EnergySmartBookingAppointmentInput;
};


export type MutationSmartBookingAppointmentRescheduleArgs = {
  input: EnergySmartBookingAppointmentRescheduleInput;
};


export type MutationStartPasswordResetArgs = {
  accountNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationStoreContactSessionArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  intent: Scalars['String']['input'];
  type: SessionType;
};


export type MutationSubmitCbcConsentArgs = {
  sessionID: Scalars['String']['input'];
  status: CbcConsentStatus;
};


export type MutationSubmitMeterReadingArgs = {
  input: MeterReadingInputCustomer;
};


export type MutationSubmitSelfServeFormArgs = {
  fields: Array<SelfServeFormFieldAnswerInput>;
  formID: Scalars['String']['input'];
};


export type MutationSubmit_Fixed_Line_Contract_Renewal_DateArgs = {
  request: FixedLineContractRenewalDate;
};


export type MutationSubmit_Fixed_Line_Equipment_QuoteArgs = {
  request?: InputMaybe<SubmitFixedLineEquipmentQuoteRequest>;
};


export type MutationSubmit_Fixed_Line_QuoteArgs = {
  quote_id: Scalars['String']['input'];
};


export type MutationSubmit_Fixed_Line_Sub_ProductArgs = {
  request?: InputMaybe<FixedLineSubProductRequest>;
};


export type MutationSwitchEnergyTariffArgs = {
  serviceId: Scalars['String']['input'];
  tariffId: Scalars['String']['input'];
};


export type MutationSwitchEnergyTariffsArgs = {
  services: Array<EnergyServiceTariffInput>;
};


export type MutationTrackCustomerArgs = {
  accountNumber: Scalars['String']['input'];
  event: TrackingEvent;
};


export type MutationUploadSelfServeFormAttachmentsArgs = {
  attachments: Array<SelfServeFormAttachmentInput>;
  formID: Scalars['String']['input'];
};


export type MutationUpsertCitizenConsentArgs = {
  input: UpsertCitizenConsentInput;
};


export type MutationUpsertCitizenPreferenceArgs = {
  input: UpsertCitizenPreferenceInput;
};


export type MutationValidateMeterReadingArgs = {
  input: MeterReadingInputCustomer;
};


export type MutationValidateMoveInArgs = {
  accountNumber: Scalars['String']['input'];
  moveInDetails: MoveInDetails;
};


export type MutationValidatePasswordResetLinkArgs = {
  tokenID: Scalars['String']['input'];
};


export type MutationVerifyCardPaymentMethodArgs = {
  input: VerifyCardPaymentMethodInput;
};

export enum MutationStatus {
  Done = 'DONE',
  Pending = 'PENDING'
}

export type NewOpenBankingPaymentInput = {
  accountReference?: InputMaybe<Scalars['String']['input']>;
  failUrl: Scalars['String']['input'];
  paymentMethodToken?: InputMaybe<Scalars['String']['input']>;
  paymentToken: Scalars['String']['input'];
  returnToAppUrl?: InputMaybe<Scalars['String']['input']>;
  successUrl: Scalars['String']['input'];
};

export type OAuthToken = {
  __typename?: 'OAuthToken';
  accessToken: Scalars['String']['output'];
  expiresIn: Scalars['Int']['output'];
  refreshToken: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  tokenType: Scalars['String']['output'];
};

export type Occupancy = {
  __typename?: 'Occupancy';
  /** Supply address of the occupancy: the site the customer occupies. Null if not found. */
  address?: Maybe<SiteAddress>;
  id: Scalars['String']['output'];
};

/** Offset-based pagination. Use 'offset' to skip a number of results (e.g. offset=20, size=10 returns results 21-30). Preferred for traditional paginated UIs. */
export type OffsetPaginationInput = {
  offset?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

export type OpenBankingPaymentCheckout = {
  __typename?: 'OpenBankingPaymentCheckout';
  checkoutUrl: Scalars['String']['output'];
};

export type OpenBankingPaymentMethod = {
  __typename?: 'OpenBankingPaymentMethod';
  bankName: Scalars['String']['output'];
  externalToken: Scalars['String']['output'];
  lastDigits: Scalars['String']['output'];
};

export type OtherIntegrationIssues = IntegrationIssues & {
  __typename?: 'OtherIntegrationIssues';
  subProductStatusUpdates?: Maybe<Scalars['Boolean']['output']>;
};

export type OtherService = DexOrderService & {
  __typename?: 'OtherService';
  estimatedDate?: Maybe<Scalars['Date']['output']>;
  hasIntegrationIssues?: Maybe<IntegrationIssues>;
  lineItemId: Scalars['ID']['output'];
  product?: Maybe<Scalars['String']['output']>;
  serviceId: Scalars['ID']['output'];
  serviceStatus: DexOrderServiceStatus;
  serviceType: DexOrderServiceType;
  statusReason?: Maybe<Scalars['String']['output']>;
  subproducts?: Maybe<Array<Maybe<DexOrderSubproduct>>>;
};

export type OverdueDebt = {
  __typename?: 'OverdueDebt';
  overdueBalance?: Maybe<Amount>;
};

export type PdpAuthorizeBatchEffect = {
  __typename?: 'PDPAuthorizeBatchEffect';
  action: Scalars['String']['output'];
  /** Is the principal for this combination of resource & action authorized? */
  allowed: Scalars['Boolean']['output'];
  /** Resource identifier. */
  resource: PdpResourceIdentity;
};

/** Resource to check authorization against multiple actions. */
export type PdpAuthorizeBatchInput = {
  actions: Array<Scalars['String']['input']>;
  resource: PdpResourceInput;
};

export type PdpAuthorizeBatchMetadata = {
  __typename?: 'PDPAuthorizeBatchMetadata';
  /**
   * Principal is the authenticated actor.
   * The principal is extracted from the HTTP header `Authorization: Bearer {token}`.
   */
  principal: Principal;
  /**
   * Unique ddentifier recorded for this request by the policy engine.
   * Useful for correlating against the audit log of decisions.
   */
  requestID: Scalars['String']['output'];
  /** Details about the token supplied in the request. */
  token: TokenDetails;
};

/** Result after performing a PDP authorize batch request. */
export type PdpAuthorizeBatchResult = {
  __typename?: 'PDPAuthorizeBatchResult';
  /** Extra information not directly related to the authorization decision. */
  metadata: PdpAuthorizeBatchMetadata;
  /** Result for each combination of resource & action. */
  results: Array<PdpAuthorizeBatchEffect>;
};

export type PdpAuthorizeMetadata = {
  __typename?: 'PDPAuthorizeMetadata';
  /**
   * Principal is the authenticated actor.
   * The principal is extracted from the HTTP header `Authorization: Bearer {token}`.
   */
  principal: Principal;
  /**
   * Unique ddentifier recorded for this request by the policy engine.
   * Useful for correlating against the audit log of decisions.
   */
  requestID: Scalars['String']['output'];
  /** Details about the token supplied in the request. */
  token: TokenDetails;
};

/** Result after performing a PDP authorize request. */
export type PdpAuthorizeResult = {
  __typename?: 'PDPAuthorizeResult';
  /** Can the principal perform the action on the resource? */
  allowed: Scalars['Boolean']['output'];
  /** Extra information not directly related to the authorization decision. */
  metadata: PdpAuthorizeMetadata;
};

export type PdpResourceAttributeInput = {
  /**
   * Attribute name.
   * This is the name used in your policy files.
   */
  name: Scalars['String']['input'];
  value: Scalars['Any']['input'];
};

export type PdpResourceIdentity = {
  __typename?: 'PDPResourceIdentity';
  /** ID of the resource. */
  id: Scalars['String']['output'];
  /** Resource type. */
  kind: Scalars['String']['output'];
};

/** Resource input for the PDP. */
export type PdpResourceInput = {
  /** Additional data for the resource. */
  attributes?: InputMaybe<Array<PdpResourceAttributeInput>>;
  /**
   * ID of the resource.
   * In some cases an ID does not make sense, for example a collection or
   * when looking to create a new resource. In those cases, anything can be passed,
   * we typically use "nil" or "dummy".
   */
  id: Scalars['String']['input'];
  /** Resource type. */
  kind: Scalars['String']['input'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

/** Partner details. */
export type PartnerPrincipal = {
  __typename?: 'PartnerPrincipal';
  /** UUID identifies the individial partner. */
  id: Scalars['ID']['output'];
  /** Position (account) partner is associated with in a friendly format. */
  positionID: Scalars['String']['output'];
};

export type PayCustomerBalanceError = {
  message?: Maybe<Scalars['String']['output']>;
};

export type PayCustomerBalanceInternalError = PayCustomerBalanceError & {
  __typename?: 'PayCustomerBalanceInternalError';
  message?: Maybe<Scalars['String']['output']>;
};

export type PayCustomerBalanceInvalidInputError = PayCustomerBalanceError & {
  __typename?: 'PayCustomerBalanceInvalidInputError';
  message?: Maybe<Scalars['String']['output']>;
};

export type PayCustomerBalanceResult = PayCustomerBalanceInternalError | PayCustomerBalanceInvalidInputError | PayCustomerBalanceSuccess;

export type PayCustomerBalanceSuccess = {
  __typename?: 'PayCustomerBalanceSuccess';
  paymentToken: Scalars['UUID']['output'];
};

export type PayOverdueDebtResponse = {
  __typename?: 'PayOverdueDebtResponse';
  paymentToken?: Maybe<Scalars['String']['output']>;
};

export type Payment = {
  __typename?: 'Payment';
  amount: Amount;
  flowType: FlowType;
  status: PaymentStatus;
  token: Scalars['String']['output'];
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  expiry?: Maybe<PaymentCardExpiry>;
  id: Scalars['String']['output'];
  lastFourDigits?: Maybe<Scalars['String']['output']>;
  scheme?: Maybe<PaymentCardScheme>;
  token: Scalars['String']['output'];
};

export type PaymentCardDetails = {
  __typename?: 'PaymentCardDetails';
  lastFourDigits: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
};

export type PaymentCardDetailsV2 = {
  __typename?: 'PaymentCardDetailsV2';
  expiry?: Maybe<Expiry>;
  lastFourDigits: Scalars['String']['output'];
  scheme: Scalars['String']['output'];
};

export type PaymentCardExpiry = {
  __typename?: 'PaymentCardExpiry';
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export enum PaymentCardScheme {
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  collectionDate?: Maybe<CollectionDate>;
  paymentMethod: PaymentMethod;
};

export enum PaymentDueChoice {
  PaymentDueChoice_3RdOfEachMonth = 'PAYMENT_DUE_CHOICE_3RD_OF_EACH_MONTH',
  PaymentDueChoice_17ThOfEachMonth = 'PAYMENT_DUE_CHOICE_17TH_OF_EACH_MONTH',
  PaymentDueChoiceUnspecified = 'PAYMENT_DUE_CHOICE_UNSPECIFIED'
}

export enum PaymentFailureReason {
  PaymentFailureAddressCheckFailed = 'PAYMENT_FAILURE_ADDRESS_CHECK_FAILED',
  PaymentFailureInvalidPaymentMethod = 'PAYMENT_FAILURE_INVALID_PAYMENT_METHOD',
  PaymentFailureNone = 'PAYMENT_FAILURE_NONE',
  PaymentFailurePaymentMethodNotAllowed = 'PAYMENT_FAILURE_PAYMENT_METHOD_NOT_ALLOWED',
  PaymentFailurePaymentRefused = 'PAYMENT_FAILURE_PAYMENT_REFUSED'
}

export enum PaymentMethod {
  PaymentMethodCash = 'PAYMENT_METHOD_CASH',
  PaymentMethodDirectDebit = 'PAYMENT_METHOD_DIRECT_DEBIT'
}

export type PaymentMethodDetails = {
  __typename?: 'PaymentMethodDetails';
  cardDetails?: Maybe<PaymentCardDetails>;
  token: Scalars['String']['output'];
  type: PaymentMethodType;
};

export type PaymentMethodDetailsV2 = {
  __typename?: 'PaymentMethodDetailsV2';
  cardDetails?: Maybe<PaymentCardDetailsV2>;
  token: Scalars['String']['output'];
  type: PaymentMethodType;
};

export type PaymentMethodInput = {
  keep?: InputMaybe<Scalars['Boolean']['input']>;
  new: Scalars['Boolean']['input'];
  /** 3rd party payment method reference (e.g. Spreedly's payment method token) */
  token: Scalars['String']['input'];
};

export enum PaymentMethodType {
  PaymentMethodTypeCard = 'PAYMENT_METHOD_TYPE_CARD',
  PaymentMethodTypeUnspecified = 'PAYMENT_METHOD_TYPE_UNSPECIFIED'
}

export type PaymentPlatformBankAccount = {
  __typename?: 'PaymentPlatformBankAccount';
  number: Scalars['String']['output'];
  ownerName: Scalars['String']['output'];
  sortCode: Scalars['String']['output'];
};

export type PaymentPlatformBankAccountInput = {
  isBusiness: Scalars['Boolean']['input'];
  number: Scalars['String']['input'];
  ownerName: Scalars['String']['input'];
  sortCode: Scalars['String']['input'];
};

export enum PaymentReason {
  PaymentReasonBill = 'PAYMENT_REASON_BILL',
  PaymentReasonDebt = 'PAYMENT_REASON_DEBT'
}

export enum PaymentStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  Finalised = 'FINALISED',
  Initialised = 'INITIALISED',
  NotSpecified = 'NOT_SPECIFIED',
  Pending = 'PENDING',
  Requested = 'REQUESTED',
  Settled = 'SETTLED',
  SettlementFailed = 'SETTLEMENT_FAILED'
}

export type PdfUrlRequest = {
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type PenceInput = {
  value?: InputMaybe<Scalars['Int']['input']>;
};

export type Person = {
  __typename?: 'Person';
  email?: Maybe<Scalars['String']['output']>;
  emailPendingVerification?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  landline?: Maybe<Scalars['String']['output']>;
};

export type PhoneCallContactChannel = {
  __typename?: 'PhoneCallContactChannel';
  calloutBanner?: Maybe<CalloutBanner>;
  estimatedWaitTime?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  queueId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelStatus>;
};

export type PortingInfo = {
  __typename?: 'PortingInfo';
  code: Scalars['String']['output'];
  expiresAt: Scalars['String']['output'];
  type: MobilePortingType;
};

export type PostalAddress = {
  __typename?: 'PostalAddress';
  county?: Maybe<Scalars['String']['output']>;
  linesList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  postcode?: Maybe<Scalars['String']['output']>;
};

export enum Preference {
  All = 'ALL',
  Unknown = 'UNKNOWN'
}

export type PreferenceSubmission = {
  __typename?: 'PreferenceSubmission';
  /** choices is the list of selected choice references for this preference. */
  choices: Array<Scalars['String']['output']>;
  /** reference is the DataGuard preference ID that uniquely identifies the preference being submitted. */
  reference: Scalars['String']['output'];
};

export type PreferenceSubmissionInput = {
  /** choices is the list of selected choice references for this preference. */
  choices: Array<Scalars['String']['input']>;
  /** reference is the DataGuard preference ID that uniquely identifies the preference being submitted. */
  reference: Scalars['String']['input'];
};

/** Principal holds the authenticated actor. */
export type Principal = UserPrincipal;

/** GraphQL entry point for making queries which are only reading data */
export type Query = {
  __typename?: 'Query';
  IsAccountClosureSubmitted?: Maybe<Scalars['Boolean']['output']>;
  account?: Maybe<Account>;
  accountPlatform: AccountPlatformQuery;
  authorize: PdpAuthorizeResult;
  authorizeBatch: PdpAuthorizeBatchResult;
  availableContactChannels?: Maybe<AvailableContactChannels>;
  bills?: Maybe<BillsQueries>;
  broadbandGetCustomerLastName: Scalars['String']['output'];
  broadbandOtsMatch: BroadbandSwitchingRequestReference;
  broadbandOtsRetrieveMatch: BroadbandSwitchingMatchRequestResponse;
  cbcAccount: CbcAccount;
  cbcAccountInformation: CbcAccountInformation;
  cbcCanOrderWallet: CbcCanOrderWalletResponse;
  cbcCard: CbcCard;
  cbcCardByIssuerTokenID: CbcCard;
  cbcComputeRefund: CbcComputeRefundResponse;
  cbcCvv2: CbcSecureCvv2;
  cbcGetCardReplacementsUntilCharge: Scalars['Int']['output'];
  cbcGetChallenge: CbcTransactionChallenge;
  cbcGetDebitCardTopupFee: Scalars['Int']['output'];
  cbcGetLowBalanceTopupById: CbcLowBalanceTopup;
  cbcGetOnfidoSDKToken: Scalars['String']['output'];
  cbcGetRetailer: Retailer;
  cbcGetRetailerCountNearestFive: Scalars['Int']['output'];
  cbcGetScheduledTopupById: CbcScheduledTopup;
  cbcGetWallet?: Maybe<CbcWallet>;
  cbcInsightsAverageMonthlyCashbackInPence: Scalars['Int']['output'];
  cbcInsightsAverageMonthlyTopupInPence: Scalars['Int']['output'];
  cbcInsightsHighestEarningMonth?: Maybe<CbcInsightsMonthlyCashback>;
  cbcInsightsJoinDate: Scalars['DateTime']['output'];
  cbcInsightsMagicWinners: CbcInsightsMagicWinners;
  cbcInsightsMonthlyCashback: Array<CbcInsightsMonthlyCashback>;
  cbcInsightsMonthlySpend: Array<CbcInsightsMonthlySpend>;
  cbcInsightsMonthlyTopup: Array<CbcInsightsMonthlyTopup>;
  cbcInsightsTopMagicWinnersBetweenDates: Array<CbcInsightsMagicWinner>;
  cbcInsightsTopRetailPartners: Array<CbcInsightsTopRetailPartner>;
  cbcInsightsTotalEarnedCashbackInPence: CbcInsightsTotalEarnedCashback;
  cbcInsightsTotalMagicCashbackBetweenDates: CbcTotalMagicEarned;
  cbcLimits: CbcLimits;
  cbcListGroupedTransactions: Array<CbcGroupedTransactions>;
  cbcListRetailPartners: ListRetailPartnersResponse;
  cbcListRetailers: Array<Retailer>;
  cbcListTransactions: Array<CbcTransaction>;
  cbcLowBalanceTopup: Array<CbcLowBalanceTopup>;
  cbcPan: CbcSecurePan;
  cbcPaymentsMethods: CbcPaymentsMethods;
  cbcPin: CbcSecurePin;
  cbcRecentMagicWin?: Maybe<CbcTransaction>;
  cbcScheduledTopup: Array<CbcScheduledTopup>;
  cbcSecureCardDataPublicKey: Scalars['String']['output'];
  cbcShouldVerifyPaymentMethod: Scalars['Boolean']['output'];
  cbcTransactionDetails: CbcTransactionDetailsResponse;
  contactChannels?: Maybe<ContactChannelsQuery>;
  customerBilling: CustomerBillingQuery;
  customerProposition?: Maybe<CustomerProposition>;
  demoEnergy?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer supported */
  digitalSupport?: Maybe<DigitalSupportQuery>;
  energyEvEligibilityCheck: EnergyEvTariffEligibility;
  energyEvSwitchComparison: EnergyEvSwitchComparison;
  energyEvVehicleCheck: EnergyEvVehicleCheck;
  energyMeterpoint: EnergyMeterpoint;
  energySBAvailableSlots: Array<EnergySbAvailableSlot>;
  energySBAvailableSlotsPointOfSale: Array<EnergySbAvailableSlot>;
  energySBCustomer: EnergySbCustomer;
  energySBCustomerPointOfSale: EnergySbCustomerPointOfSale;
  energyTariffs: Array<EnergyTariff>;
  energyUW4BAccount: EnergyUw4BAccount;
  energyUW4BCompany: EnergyUw4BCompany;
  finance: FinanceQuery;
  fixed_line_appointment?: Maybe<BroadbandAppointment>;
  fixed_line_available_appointments?: Maybe<Array<BroadbandAppointment>>;
  fixed_line_generate_email_eecc_docs: FixedLineEeccContractResponse;
  fixed_line_get_all_line_test_results: FixedLineGetAllLineTestResultsResponse;
  fixed_line_get_broadband_credentials: FixedLineBroadbandCredentials;
  fixed_line_get_broadband_details: FixedLineBroadbandDetailsResponse;
  fixed_line_get_call_bundle_availability: FixedLineCallBundleAvailabilityResponse;
  fixed_line_get_contract_renewal_date: FixedLineContractRenewalDateResponse;
  fixed_line_get_customer_addresses: Array<Maybe<FixedLineAddress>>;
  fixed_line_get_homephone_details: FixedLineHomephoneDetailsResponse;
  fixed_line_get_line_test_result: FixedLineGetLineTestResultResponse;
  fixed_line_get_line_test_timeline: FixedLineGetLineTestTimelineResponse;
  fixed_line_get_list_of_suppliers?: Maybe<Array<Scalars['String']['output']>>;
  fixed_line_get_my_services: FixedLineMyServicesResponse;
  fixed_line_get_quote: FixedLineQuoteResponse;
  fixed_line_ots_directory?: Maybe<BroadbandOtsEntitiesDirectory>;
  getAccountId?: Maybe<Scalars['String']['output']>;
  getCbcConsentSession?: Maybe<CbcConsentSession>;
  getDashboardServices: DashboardServices;
  getFirstCustomerTracking?: Maybe<GetFirstCustomerTrackingResult>;
  getOverdueDebt?: Maybe<OverdueDebt>;
  getPayment: GetPaymentResponse;
  getReferralCode?: Maybe<Scalars['String']['output']>;
  getServiceGroupOverview?: Maybe<ServiceGroup>;
  getServiceGroupOverviews?: Maybe<Array<Maybe<ServiceGroup>>>;
  getServiceOverviews?: Maybe<Array<Maybe<ServiceOverview>>>;
  /** @deprecated Use `supportRequestTopics` instead. */
  helpAndSupportTopics?: Maybe<Array<HelpAndSupportTopic>>;
  /** @deprecated Use `helpArticleByID` instead. */
  helpArticle?: Maybe<HelpArticle>;
  helpArticleByID?: Maybe<HelpArticle>;
  helpArticleBySlug?: Maybe<HelpArticle>;
  helpArticleCategories: Array<HelpArticleCategory>;
  helpArticleV2?: Maybe<HelpArticle>;
  helpArticles: Array<HelpArticleSearchResult>;
  helpDecisionTree?: Maybe<HelpDecisionTree>;
  insuranceAccount: InsuranceAccount;
  insuranceAddresses: Array<Maybe<InsuranceAddress>>;
  insuranceAddressesV2: Array<Maybe<InsuranceAddressV2>>;
  insuranceBoilerPolicies: Array<InsurancePolicy>;
  insuranceExternalRenewalDates: Array<InsuranceExternalRenewalDate>;
  /** @deprecated Use `insuranceExternalRenewalDates` instead */
  insuranceExternalRenewalHomeDate: InsuranceExternalRenewalDate;
  insuranceFindPolicies: Array<InsurancePolicySummary>;
  insuranceGetLists: Array<InsuranceList>;
  insuranceGetPolicyCancellationFees: InsurancePolicyCancellationFees;
  insuranceGetPolicyCancellationFeesV2: InsurancePolicyCancellationFeesV2;
  insuranceHomeMTAQuotesV2: Array<InsuranceHomeQuoteV2>;
  insuranceHomeQuote: InsuranceHomeQuote;
  insuranceHomeQuoteV2: InsuranceHomeQuoteV2;
  insuranceMotorMTAQuotes: Array<InsuranceMotorQuote>;
  insuranceMotorMakeModelSearch: Array<InsuranceMotorMakeModelResult>;
  insuranceMotorQuote: InsuranceMotorQuote;
  insuranceMotorRegSearch?: Maybe<InsuranceMotorVehicle>;
  insurancePolicy: InsurancePolicy;
  insurancePortalPolicies: Array<InsurancePolicy>;
  insuranceProductCatalog?: Maybe<InsuranceCatalog>;
  insuranceQuote: InsuranceQuote;
  insuranceUserExtraActions?: Maybe<InsuranceUserExtraActions>;
  isHomeMoveAccount?: Maybe<Scalars['Boolean']['output']>;
  is_fixed_line_equipment_upgrade_available: FixedLineEquipmentUpgradeAvailabilityResponse;
  legacyPlaceholder?: Maybe<Scalars['Boolean']['output']>;
  listCbcActiveConsent: Array<CbcConsent>;
  listDirectDebitMandates: Array<DirectDebitMandate>;
  listFinancePaymentMethods: Array<FinancePaymentMethod>;
  listPaymentMethods: ListPaymentMethodsResult;
  /** @deprecated Use `WhoAmI` query, this has been maintained while App is migrated to use `WhoAmI` query */
  me?: Maybe<Person>;
  mobileActivatableSims: Array<MobileActivatableSimResponse>;
  /** @deprecated Use mobileHandsetOrders. */
  mobileActiveContractForServiceV2?: Maybe<MobileActiveContractForServiceV2Response>;
  mobileAddSimIsUpgradeAvailableWithPendingChanges: MobileAddSimUpgradeAvailabilityWithPendingResponse;
  mobileAddSimQuote: MobileAddSimQuoteResponse;
  mobileAddSimUpgradeQuote: MobileAddSimUpgradeQuoteResponse;
  /** @deprecated Use mobileCatalogue.handsets. */
  mobileAvailableHandsets: MobileAvailableHandsetsResponse;
  mobileCanOrderReplacementESIM?: Maybe<MobileCanOrderReplacementEsimResponse>;
  mobileCanResendESimActivationEmail?: Maybe<MobileCanResendESimActivationEmailResponse>;
  mobileCatalogue: MobileCatalogue;
  /** @deprecated Use mobileHandsetOrder. */
  mobileContractByRequestID?: Maybe<MobileContractByRequestIdResponse>;
  mobileContractRenewalDate: MobileContractRenewalDateResponse;
  mobileDownloadEeccContract: MobileDownloadEeccContractResponse;
  /** @deprecated Use mobileHandsetOrder.financing.loanApplication.eligibilityUrl. */
  mobileEligibilityRedirectUrl?: Maybe<MobileEligibilityRedirectUrlResponse>;
  mobileGetBarredSimStatus: MobileGetBarredSimStatusResponse;
  mobileHandsetDeliveryAddress: MobileHandsetDeliveryAddress;
  /** @deprecated Use mobileCatalogue.eligibleServices. */
  mobileHandsetEligibleServices: MobileHandsetEligibleServicesResponse;
  mobileHandsetInformation: MobileHandsetInformationResponse;
  mobileHandsetOrder?: Maybe<MobileHandsetOrder>;
  mobileHandsetOrders: Array<MobileHandsetOrder>;
  mobileIsEsimReplacementCancellable?: Maybe<MobileIsEsimReplacementCancellableResponse>;
  mobileRoamingUsage: MobileRoamingUsageResponse;
  mobileService: MobileServiceResponse;
  mobileServiceUsage: MobileServiceUsageResponse;
  mobileServiceUsageHistory: Array<MobileServiceUsageHistoryResponse>;
  mobileServices: MobileServicesResponse;
  mobileSimBalance: MobileSimBalanceResponse;
  mobileSimSettings: Array<MobileSimSettingResponse>;
  mobileValidateOTPVerificationCode: MobileValidateOtpVerificationCodeResponse;
  order?: Maybe<DexOrder>;
  pingCbc: Scalars['Boolean']['output'];
  referral?: Maybe<Referral>;
  selfServeForm?: Maybe<SelfServeForm>;
  /** @deprecated Use `suggestedHelpArticleTopics` instead. */
  suggestedHelpArticleCategories?: Maybe<Array<SuggestedHelpArticleCategory>>;
  suggestedHelpArticleTopics?: Maybe<Array<SuggestedHelpArticleTopic>>;
  /** @deprecated Use `suggestedHelpArticlesV2` instead. */
  suggestedHelpArticles?: Maybe<Array<SuggestedHelpArticle>>;
  suggestedHelpArticlesV2?: Maybe<Array<SuggestedHelpArticle>>;
  support?: Maybe<SupportQueries>;
  supportLiveChatAvailability: SupportLiveChatAvailability;
  supportRequestTopics?: Maybe<Array<SupportRequestTopic>>;
  validateMeterReading: MeterReadingResponse;
  /**
   * Verifies the account number and postcode match an account.
   * This is intended to be used as part of the account setup process, so will only work for
   * accounts without an email address. This is to prevent account enumeration.
   * Requires a castle token.
   */
  verifyAccountPostcode: VerifyAccountPostcodeResult;
  whoAmI: WhoAmI;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryIsAccountClosureSubmittedArgs = {
  accountNumber: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryAccountArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryAuthorizeArgs = {
  action: Scalars['String']['input'];
  resource: PdpResourceInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryAuthorizeBatchArgs = {
  batch: Array<PdpAuthorizeBatchInput>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryAvailableContactChannelsArgs = {
  intent?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryBroadbandGetCustomerLastNameArgs = {
  accountId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryBroadbandOtsMatchArgs = {
  request?: InputMaybe<BroadbandSwitchingMatchRequestInput>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryBroadbandOtsRetrieveMatchArgs = {
  request?: InputMaybe<BroadbandSwitchingRequestReferenceInput>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcCardArgs = {
  cardId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcCardByIssuerTokenIdArgs = {
  issuerTokenId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcComputeRefundArgs = {
  amountInPence: Scalars['Int']['input'];
  useOpenBanking?: InputMaybe<Scalars['Boolean']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcCvv2Args = {
  cardId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcGetChallengeArgs = {
  token: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcGetLowBalanceTopupByIdArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcGetOnfidoSdkTokenArgs = {
  caller: CbcGetOnfidoSdkTokenCaller;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcGetRetailerArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcGetScheduledTopupByIdArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsAverageMonthlyCashbackInPenceArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsAverageMonthlyTopupInPenceArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsMonthlyCashbackArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsMonthlySpendArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsMonthlyTopupArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsTopMagicWinnersBetweenDatesArgs = {
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsTopRetailPartnersArgs = {
  from: Scalars['DateTime']['input'];
  to: Scalars['DateTime']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsTotalEarnedCashbackInPenceArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcInsightsTotalMagicCashbackBetweenDatesArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
  toDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcListGroupedTransactionsArgs = {
  options: ListTransactionsOptions;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcListRetailPartnersArgs = {
  opts?: InputMaybe<ListRetailPartnerOptions>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcListTransactionsArgs = {
  options: ListTransactionsOptions;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcPanArgs = {
  cardId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcPinArgs = {
  cardId: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcShouldVerifyPaymentMethodArgs = {
  cardFingerprint: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryCbcTransactionDetailsArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyEvEligibilityCheckArgs = {
  input: EnergyEvEligibilityCheckInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyEvSwitchComparisonArgs = {
  applicationId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyEvVehicleCheckArgs = {
  input: EnergyEvVehicleCheckInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyMeterpointArgs = {
  input: EnergyMeterpointInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergySbAvailableSlotsArgs = {
  input: EnergySbAvailableSlotsInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergySbAvailableSlotsPointOfSaleArgs = {
  input: EnergySbAvailableSlotsPointOfSaleInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergySbCustomerArgs = {
  accountId?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergySbCustomerPointOfSaleArgs = {
  input: EnergySbCustomerPointOfSaleInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyTariffsArgs = {
  input: EnergyTariffsInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyUw4BAccountArgs = {
  input: EnergyUw4BAccountInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryEnergyUw4BCompanyArgs = {
  input: EnergyUw4BCompanyInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_AppointmentArgs = {
  service_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Available_AppointmentsArgs = {
  after?: InputMaybe<Scalars['FixedLineDateTimeRFC3339']['input']>;
  by: BroadbandGetAppointmentsBy;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Generate_Email_Eecc_DocsArgs = {
  quote_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_All_Line_Test_ResultsArgs = {
  request?: InputMaybe<FixedLineGetAllLineTestResultsInput>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_Broadband_CredentialsArgs = {
  service_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_Broadband_DetailsArgs = {
  service_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_Call_Bundle_AvailabilityArgs = {
  service_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_Homephone_DetailsArgs = {
  service_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_Line_Test_ResultArgs = {
  test_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_Line_Test_TimelineArgs = {
  request?: InputMaybe<FixedLineGetLineTestTimelineInput>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryFixed_Line_Get_QuoteArgs = {
  request?: InputMaybe<FixedLineQuoteRequest>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetAccountIdArgs = {
  referral_code: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetCbcConsentSessionArgs = {
  sessionID: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetDashboardServicesArgs = {
  accountID: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetFirstCustomerTrackingArgs = {
  accountNumber: Scalars['String']['input'];
  event: TrackingEvent;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetOverdueDebtArgs = {
  accountId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetPaymentArgs = {
  input: GetPayment;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetReferralCodeArgs = {
  account_id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetServiceGroupOverviewArgs = {
  accountID: Scalars['String']['input'];
  serviceType: ServiceType;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetServiceGroupOverviewsArgs = {
  accountID: Scalars['String']['input'];
  serviceTypes?: InputMaybe<Array<ServiceType>>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryGetServiceOverviewsArgs = {
  accountID: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryHelpArticleArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryHelpArticleByIdArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryHelpArticleBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryHelpArticleV2Args = {
  idOrSlug: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryHelpArticlesArgs = {
  searchCriteria: HelpArticleSearchInput;
  searchEngine?: InputMaybe<HelpArticleSearchEngine>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryHelpDecisionTreeArgs = {
  category: HelpDecisionTreeCategoryFilter;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceAccountArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceAddressesArgs = {
  postcode: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceAddressesV2Args = {
  postcode: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceBoilerPoliciesArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceExternalRenewalDatesArgs = {
  accountId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceExternalRenewalHomeDateArgs = {
  accountId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceFindPoliciesArgs = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  postCode?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceGetListsArgs = {
  journey: InsuranceJourney;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceGetPolicyCancellationFeesArgs = {
  cancellationDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  productClass: InsuranceProductClass;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceGetPolicyCancellationFeesV2Args = {
  cancellationDate: Scalars['Date']['input'];
  id: Scalars['String']['input'];
  waiveAdminFee?: InputMaybe<Scalars['Boolean']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceHomeMtaQuotesV2Args = {
  policyId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceHomeQuoteArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceHomeQuoteV2Args = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceMotorMtaQuotesArgs = {
  policyId: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceMotorMakeModelSearchArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceMotorQuoteArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceMotorRegSearchArgs = {
  reg: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsurancePolicyArgs = {
  id: Scalars['String']['input'];
  includeDocumentHistory?: InputMaybe<Scalars['Boolean']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsurancePortalPoliciesArgs = {
  accountNumber: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryInsuranceQuoteArgs = {
  id: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryIsHomeMoveAccountArgs = {
  accountNumber: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryListDirectDebitMandatesArgs = {
  input: ListDirectDebitMandatesInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryListFinancePaymentMethodsArgs = {
  input: ListFinancePaymentMethodsInput;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryListPaymentMethodsArgs = {
  customerAccountID: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileActiveContractForServiceV2Args = {
  request: MobileActiveContractForServiceV2Request;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileAddSimQuoteArgs = {
  request: MobileAddSimQuoteRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileAddSimUpgradeQuoteArgs = {
  request: MobileAddSimUpgradeQuoteRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileAvailableHandsetsArgs = {
  request: MobileAvailableHandsetsRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileCanResendESimActivationEmailArgs = {
  request?: InputMaybe<MobileCanResendESimActivationEmailRequest>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileContractByRequestIdArgs = {
  request: MobileContractByRequestIdRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileDownloadEeccContractArgs = {
  request: MobileDownloadEeccContractRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileEligibilityRedirectUrlArgs = {
  request: MobileEligibilityRedirectUrlRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileGetBarredSimStatusArgs = {
  request: MobileGetBarredSimStatusRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileHandsetInformationArgs = {
  request: MobileHandsetInformationRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileHandsetOrderArgs = {
  request: MobileHandsetOrderRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileHandsetOrdersArgs = {
  request?: InputMaybe<MobileHandsetOrdersRequest>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileIsEsimReplacementCancellableArgs = {
  request: MobileIsEsimReplacementCancellableRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileRoamingUsageArgs = {
  request: MobileRoamingUsageRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileServiceArgs = {
  request: MobileServiceRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileServiceUsageArgs = {
  request: MobileServiceUsageRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileServiceUsageHistoryArgs = {
  request: MobileServiceUsageHistoryRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileSimBalanceArgs = {
  request: MobileSimBalanceRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileSimSettingsArgs = {
  request: MobileSimSettingsRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryMobileValidateOtpVerificationCodeArgs = {
  request: MobileValidateOtpVerificationCodeRequest;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryOrderArgs = {
  accountID?: InputMaybe<Scalars['String']['input']>;
};


/** GraphQL entry point for making queries which are only reading data */
export type QuerySelfServeFormArgs = {
  formID: Scalars['String']['input'];
};


/** GraphQL entry point for making queries which are only reading data */
export type QuerySuggestedHelpArticlesArgs = {
  category: SuggestedHelpArticleCategory;
};


/** GraphQL entry point for making queries which are only reading data */
export type QuerySuggestedHelpArticlesV2Args = {
  topic: SuggestedHelpArticleTopic;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryValidateMeterReadingArgs = {
  input: MeterReadingInputCustomer;
};


/** GraphQL entry point for making queries which are only reading data */
export type QueryVerifyAccountPostcodeArgs = {
  accountNumber: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
};

export enum ReadingState {
  Accepted = 'ACCEPTED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  Unknown = 'UNKNOWN'
}

export type RebookBroadbandAppointmentResponse = {
  __typename?: 'RebookBroadbandAppointmentResponse';
  appointment: BroadbandAppointment;
};

export type RecommendedBudgetPlan = {
  __typename?: 'RecommendedBudgetPlan';
  amount: Amount;
  maximumAmount?: Maybe<Amount>;
  minimumAmount: Amount;
};

export type RedactPaymentMethodInput = {
  accountReference: Scalars['String']['input'];
  paymentMethodToken: Scalars['String']['input'];
};

export type RedactPaymentMethodOutcome = {
  __typename?: 'RedactPaymentMethodOutcome';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

export type Referral = {
  __typename?: 'Referral';
  baseUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  promo?: Maybe<ReferralPromo>;
};

export type ReferralPromo = {
  __typename?: 'ReferralPromo';
  bannerText?: Maybe<Scalars['String']['output']>;
  bannerTitle?: Maybe<Scalars['String']['output']>;
  pageText?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
};

export type RegisterAccountEmailResult = {
  __typename?: 'RegisterAccountEmailResult';
  status: RegisterAccountEmailStatus;
};

export enum RegisterAccountEmailStatus {
  /** The account number and postcode do not match. Or the account already has an email address. */
  InvalidDetails = 'INVALID_DETAILS',
  /** The request to register the email was successful, the email was sent. */
  Success = 'SUCCESS'
}

export type RegisterReading = {
  __typename?: 'RegisterReading';
  label?: Maybe<Scalars['String']['output']>;
  registerId: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type RegisterReadingInput = {
  registerId: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export type RelatedHelpArticle = {
  __typename?: 'RelatedHelpArticle';
  meta: RelatedHelpArticleMeta;
  score: RelatedHelpArticleScore;
  title: Scalars['String']['output'];
};

export type RelatedHelpArticleMeta = {
  __typename?: 'RelatedHelpArticleMeta';
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type RelatedHelpArticleScore = {
  __typename?: 'RelatedHelpArticleScore';
  value: Scalars['Int']['output'];
};

export type RequestLineTestRequest = {
  service_id: Scalars['ID']['input'];
};

export type RequestLineTestResponse = {
  __typename?: 'RequestLineTestResponse';
  test_id: Scalars['String']['output'];
};

export type RequesterInput = {
  ip: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

/**
 * The required action for a non-successful payment. Contains the information required by a pending transaction to complete
 * the 3DS (v1 or v2) flow.
 */
export type RequiredAction = {
  __typename?: 'RequiredAction';
  /** Holds the token which should be passed to continue/complete 3DS challenge. */
  externalTransactionToken: Scalars['String']['output'];
  /** Holds the raw transaction fields required by 3DS. Base64 encoded JSON */
  transactionData?: Maybe<Scalars['String']['output']>;
};

export type ReserveBroadbandAppointmentResponse = {
  __typename?: 'ReserveBroadbandAppointmentResponse';
  appointment: BroadbandAppointment;
  id: Scalars['String']['output'];
};

export type ResidentialDetails = {
  __typename?: 'ResidentialDetails';
  changes?: Maybe<Array<AccountPlatformChange>>;
  isMarkedAsDeceased: Scalars['Boolean']['output'];
  isMarkedAsFraud: Scalars['Boolean']['output'];
  isStaff: Scalars['Boolean']['output'];
  legacyDateOfBirth1?: Maybe<Scalars['String']['output']>;
  legacyDateOfBirth2?: Maybe<Scalars['String']['output']>;
  supplyDetails?: Maybe<AccountPlatformContactDetails>;
};

export type ResolveExternalFaultRequest = {
  resolved: Scalars['Boolean']['input'];
  service_id: Scalars['ID']['input'];
};

export type Retailer = {
  __typename?: 'Retailer';
  categories: Array<Scalars['String']['output']>;
  category: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  exclusions?: Maybe<Scalars['String']['output']>;
  favourite: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  marketingTier?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  percentage: Scalars['String']['output'];
  startDate: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type Sic = {
  __typename?: 'SIC';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
};

export type ScheduledPayment = {
  __typename?: 'ScheduledPayment';
  amount: Amount;
  date: Scalars['String']['output'];
};

export enum SearchEngine {
  ElasticSearch = 'ELASTIC_SEARCH',
  Google = 'GOOGLE',
  Unknown = 'UNKNOWN'
}

export type SelfServeForm = {
  __typename?: 'SelfServeForm';
  id: Scalars['String']['output'];
  schema?: Maybe<SelfServeFormSchema>;
};

export type SelfServeFormAttachmentInput = {
  file: Scalars['Upload']['input'];
};

export type SelfServeFormAttachmentResponse = {
  __typename?: 'SelfServeFormAttachmentResponse';
  attachmentIds: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SelfServeFormCaseManagement = {
  __typename?: 'SelfServeFormCaseManagement';
  teamId: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  ticketDescription: Scalars['String']['output'];
  ticketTitle: Scalars['String']['output'];
};

export type SelfServeFormField = SelfServeFormFieldAttachment | SelfServeFormFieldCheckbox | SelfServeFormFieldInput | SelfServeFormFieldRadio | SelfServeFormFieldSelect | SelfServeFormFieldTextarea;

export type SelfServeFormFieldAnswerInput = {
  answer: SelfServeFormFieldAnswerValueInput;
  fieldID: Scalars['String']['input'];
};

export type SelfServeFormFieldAnswerValueInput = {
  attachment?: InputMaybe<Array<Scalars['String']['input']>>;
  checkbox?: InputMaybe<Array<Scalars['String']['input']>>;
  input?: InputMaybe<Scalars['String']['input']>;
  radio?: InputMaybe<Scalars['String']['input']>;
  select?: InputMaybe<Scalars['String']['input']>;
  textarea?: InputMaybe<Scalars['String']['input']>;
};

export type SelfServeFormFieldAttachment = {
  __typename?: 'SelfServeFormFieldAttachment';
  allowedMimeTypes: Array<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  maxCount: Scalars['Int']['output'];
  maxSize: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredMessage?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormFieldCheckbox = {
  __typename?: 'SelfServeFormFieldCheckbox';
  checkboxOptions: SelfServeFormFieldCheckboxOptions;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredMessage?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormFieldCheckboxOption = {
  __typename?: 'SelfServeFormFieldCheckboxOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelfServeFormFieldCheckboxOptions = {
  __typename?: 'SelfServeFormFieldCheckboxOptions';
  /** @deprecated No longer supported */
  fixed?: Maybe<Array<SelfServeFormFieldCheckboxOption>>;
  /** @deprecated No longer supported */
  injected: Scalars['String']['output'];
  values?: Maybe<Array<SelfServeFormFieldCheckboxOption>>;
};

export type SelfServeFormFieldInput = {
  __typename?: 'SelfServeFormFieldInput';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredMessage?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
  validationMessage?: Maybe<Scalars['String']['output']>;
  validationRegex?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormFieldRadio = {
  __typename?: 'SelfServeFormFieldRadio';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  radioOptions: SelfServeFormFieldRadioOptions;
  required: Scalars['Boolean']['output'];
  requiredMessage?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormFieldRadioOption = {
  __typename?: 'SelfServeFormFieldRadioOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SelfServeFormFieldRadioOptions = {
  __typename?: 'SelfServeFormFieldRadioOptions';
  /** @deprecated No longer supported */
  fixed?: Maybe<Array<SelfServeFormFieldRadioOption>>;
  /** @deprecated No longer supported */
  injected: Scalars['String']['output'];
  values?: Maybe<Array<SelfServeFormFieldRadioOption>>;
};

export type SelfServeFormFieldSelect = {
  __typename?: 'SelfServeFormFieldSelect';
  buttonLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredMessage?: Maybe<Scalars['String']['output']>;
  selectConfirmLabel: Scalars['String']['output'];
  selectOptions: SelfServeFormFieldSelectOptions;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormFieldSelectOptions = {
  __typename?: 'SelfServeFormFieldSelectOptions';
  /** @deprecated No longer supported */
  fixed?: Maybe<Array<Scalars['String']['output']>>;
  /** @deprecated No longer supported */
  injected: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type SelfServeFormFieldTextarea = {
  __typename?: 'SelfServeFormFieldTextarea';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  requiredMessage?: Maybe<Scalars['String']['output']>;
  subLabel?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormFulfilment = {
  __typename?: 'SelfServeFormFulfilment';
  caseManagement: SelfServeFormCaseManagement;
  emailSLA: Scalars['Int']['output'];
};

export type SelfServeFormSchema = {
  __typename?: 'SelfServeFormSchema';
  bodyText: Scalars['String']['output'];
  eligibility: Scalars['String']['output'];
  fields: Array<Maybe<SelfServeFormField>>;
  fulfilment: SelfServeFormFulfilment;
  screens?: Maybe<SelfServeFormScreens>;
  submitButtonText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SelfServeFormScreens = {
  __typename?: 'SelfServeFormScreens';
  submission: SelfServeFormSubmissionScreen;
};

export type SelfServeFormSubmissionScreen = {
  __typename?: 'SelfServeFormSubmissionScreen';
  bodyText?: Maybe<Scalars['String']['output']>;
  button?: Maybe<SelfServeFormSubmissionScreenButton>;
  heading?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['String']['output']>;
};

export type SelfServeFormSubmissionScreenButton = {
  __typename?: 'SelfServeFormSubmissionScreenButton';
  redirectLocation?: Maybe<SelfServeFormSubmissionScreenRedirectLocation>;
  text: Scalars['String']['output'];
};

export type SelfServeFormSubmissionScreenRedirectLocation = {
  __typename?: 'SelfServeFormSubmissionScreenRedirectLocation';
  mobile: Scalars['String']['output'];
  web: Scalars['String']['output'];
};

export type SelfServeFormV2 = {
  __typename?: 'SelfServeFormV2';
  id: Scalars['String']['output'];
  schemaV2?: Maybe<SelfServeFormSchema>;
};

export type SendEmailContactChannelsMutationInput = {
  attachments: Array<EmailAttachmentReference>;
  message: Scalars['String']['input'];
  subject: ContactChannelsEmailSubject;
  topic: ContactChannelsEmailTopic;
};

export type ServiceGroup = {
  __typename?: 'ServiceGroup';
  hasNonEndedServices: Scalars['Boolean']['output'];
  services?: Maybe<Array<Maybe<ServiceOverview>>>;
  status: ServiceStatus;
  type: ServiceType;
};

export enum ServiceName {
  BillProtector = 'BILL_PROTECTOR',
  BoilerInsurance = 'BOILER_INSURANCE',
  CashbackCard = 'CASHBACK_CARD',
  Electricity = 'ELECTRICITY',
  Fit = 'FIT',
  FixedLineBroadband = 'FIXED_LINE_BROADBAND',
  FixedLineNgn = 'FIXED_LINE_NGN',
  FixedLineVoice = 'FIXED_LINE_VOICE',
  Gas = 'GAS',
  HomeInsurance = 'HOME_INSURANCE',
  IncomeProtector = 'INCOME_PROTECTOR',
  Mobile = 'MOBILE'
}

export type ServiceOverview = {
  __typename?: 'ServiceOverview';
  endedOn?: Maybe<DateAndUtcTime>;
  id: Scalars['String']['output'];
  inProgressSince?: Maybe<DateAndUtcTime>;
  liveSince?: Maybe<DateAndUtcTime>;
  name: ServiceName;
  status: ServiceStatus;
};

export enum ServiceStatus {
  Ended = 'ENDED',
  InProgress = 'IN_PROGRESS',
  Live = 'LIVE',
  None = 'NONE'
}

export enum ServiceType {
  Broadband = 'BROADBAND',
  Cashback = 'CASHBACK',
  Energy = 'ENERGY',
  Homephone = 'HOMEPHONE',
  Insurance = 'INSURANCE',
  Mobile = 'MOBILE'
}

export enum SessionType {
  Call = 'CALL',
  Whatsapp = 'WHATSAPP'
}

export type SetUpMoveInCustomerResult = {
  __typename?: 'SetUpMoveInCustomerResult';
  success: Scalars['Boolean']['output'];
};

export type SetupBudgetPlanInput = {
  accountId: Scalars['String']['input'];
  serviceIds: Array<Scalars['String']['input']>;
  totalAmount: AmountInput;
};

export type SetupBudgetPlanResponse = {
  __typename?: 'SetupBudgetPlanResponse';
  budgetPlan?: Maybe<EnergyBudgetPlan>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum SetupDirectDebitMandateFailureReason {
  BankAccountNotSupported = 'BANK_ACCOUNT_NOT_SUPPORTED',
  BankAccountNotValid = 'BANK_ACCOUNT_NOT_VALID',
  DdmWithThisPurposeAlreadyExists = 'DDM_WITH_THIS_PURPOSE_ALREADY_EXISTS',
  NotSpecified = 'NOT_SPECIFIED'
}

export type SetupDirectDebitMandateInput = {
  accountReference: Scalars['String']['input'];
  bankAccount: PaymentPlatformBankAccountInput;
  clientApplication: ClientApplicationInput;
  purpose: DirectDebitMandatePurpose;
  requester: RequesterInput;
};

export type SetupDirectDebitMandateOutcome = SetupDirectDebitMandateOutcomeFailure | SetupDirectDebitMandateOutcomeSuccess;

export type SetupDirectDebitMandateOutcomeFailure = {
  __typename?: 'SetupDirectDebitMandateOutcomeFailure';
  failureReason?: Maybe<SetupDirectDebitMandateFailureReason>;
};

export type SetupDirectDebitMandateOutcomeSuccess = {
  __typename?: 'SetupDirectDebitMandateOutcomeSuccess';
  _empty?: Maybe<Scalars['Boolean']['output']>;
};

export enum ShippingCarrier {
  Dpd = 'DPD',
  RoyalMail = 'ROYAL_MAIL'
}

export enum SimType {
  Esim = 'ESIM',
  Psim = 'PSIM'
}

export type SiteAddress = {
  __typename?: 'SiteAddress';
  buildingNameNumber: Scalars['String']['output'];
  county: Scalars['String']['output'];
  deliveryPointSuffix: Scalars['String']['output'];
  department: Scalars['String']['output'];
  dependentLocality: Scalars['String']['output'];
  dependentThoroughfare: Scalars['String']['output'];
  doubleDependentLocality: Scalars['String']['output'];
  locality: Scalars['String']['output'];
  organisation: Scalars['String']['output'];
  poBox: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  subBuildingNameNumber: Scalars['String']['output'];
  thoroughfare: Scalars['String']['output'];
  town: Scalars['String']['output'];
  uprn: Scalars['String']['output'];
};

export type SmartBookingAppointmentFailure = {
  __typename?: 'SmartBookingAppointmentFailure';
  code: SmartBookingAppointmentFailureReason;
  message: Scalars['String']['output'];
};

export enum SmartBookingAppointmentFailureReason {
  BookingExists = 'BOOKING_EXISTS',
  DataLoad = 'DATA_LOAD',
  SlotTaken = 'SLOT_TAKEN',
  Unauthenticated = 'UNAUTHENTICATED'
}

export type SmartBookingAppointmentResponseData = {
  __typename?: 'SmartBookingAppointmentResponseData';
  bookingId: Scalars['String']['output'];
};

export enum SmartConsentLevel {
  Daily = 'DAILY',
  HalfHourly = 'HALF_HOURLY',
  Monthly = 'MONTHLY',
  Unknown = 'UNKNOWN'
}

export type SmartTip = {
  __typename?: 'SmartTip';
  /** Call to action text for this smart tip */
  callToAction: Scalars['String']['output'];
  /**
   * Description providing more details about the smart tip (nullable)
   * @deprecated Use callToAction instead
   */
  description?: Maybe<Scalars['String']['output']>;
  /** Title of the smart tip */
  title: Scalars['String']['output'];
  /** Type of smart tip - unique identifier */
  type: SmartTipType;
};

export enum SmartTipType {
  /** @deprecated Use ANNIVERSARY_SURVEY_1 through ANNIVERSARY_SURVEY_10 instead */
  AnniversarySurvey = 'ANNIVERSARY_SURVEY',
  AnniversarySurvey_1 = 'ANNIVERSARY_SURVEY_1',
  AnniversarySurvey_2 = 'ANNIVERSARY_SURVEY_2',
  AnniversarySurvey_3 = 'ANNIVERSARY_SURVEY_3',
  AnniversarySurvey_4 = 'ANNIVERSARY_SURVEY_4',
  AnniversarySurvey_5 = 'ANNIVERSARY_SURVEY_5',
  AnniversarySurvey_6 = 'ANNIVERSARY_SURVEY_6',
  AnniversarySurvey_7 = 'ANNIVERSARY_SURVEY_7',
  AnniversarySurvey_8 = 'ANNIVERSARY_SURVEY_8',
  AnniversarySurvey_9 = 'ANNIVERSARY_SURVEY_9',
  AnniversarySurvey_10 = 'ANNIVERSARY_SURVEY_10',
  BouncedEmail = 'BOUNCED_EMAIL',
  EmailAddressMissing = 'EMAIL_ADDRESS_MISSING',
  InvalidMeterReading = 'INVALID_METER_READING',
  MissingMobile = 'MISSING_MOBILE',
  NoDirectDebit = 'NO_DIRECT_DEBIT',
  NoRecentMeterReading = 'NO_RECENT_METER_READING',
  OnboardingSurvey = 'ONBOARDING_SURVEY'
}

export type SoleTrader = {
  __typename?: 'SoleTrader';
  _placeholder?: Maybe<Scalars['Int']['output']>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartPasswordResetResult = {
  __typename?: 'StartPasswordResetResult';
  status?: Maybe<MutationStatus>;
};

export type StoreContactSessionOutput = {
  __typename?: 'StoreContactSessionOutput';
  digits?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type StoreSessionMutationInput = {
  category: Scalars['String']['input'];
  intent: Scalars['String']['input'];
};

export type SubmitFixedLineEquipmentQuoteRequest = {
  quote_id: Scalars['String']['input'];
  service_id: Scalars['String']['input'];
};

export type SubmitSelfServeFormResponse = {
  __typename?: 'SubmitSelfServeFormResponse';
  success: Scalars['Boolean']['output'];
  ticketID?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cbcNotifications: CbcNotification;
  chatState: ChatState;
};


export type SubscriptionChatStateArgs = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestedHelpArticle = {
  __typename?: 'SuggestedHelpArticle';
  meta: SuggestedHelpArticleMeta;
  score: SuggestedHelpArticleScore;
  title: Scalars['String']['output'];
};

export enum SuggestedHelpArticleCategory {
  Account = 'ACCOUNT',
  Billing = 'BILLING',
  Broadband = 'BROADBAND',
  Cashback = 'CASHBACK',
  Energy = 'ENERGY',
  Insurance = 'INSURANCE',
  Mobile = 'MOBILE',
  Unknown = 'UNKNOWN'
}

export type SuggestedHelpArticleMeta = {
  __typename?: 'SuggestedHelpArticleMeta';
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type SuggestedHelpArticleScore = {
  __typename?: 'SuggestedHelpArticleScore';
  value: Scalars['Int']['output'];
};

export enum SuggestedHelpArticleTopic {
  Account = 'ACCOUNT',
  Billing = 'BILLING',
  Broadband = 'BROADBAND',
  Cashback = 'CASHBACK',
  Energy = 'ENERGY',
  Insurance = 'INSURANCE',
  Mobile = 'MOBILE',
  Unknown = 'UNKNOWN'
}

export enum SupportArticleContentTheme {
  Dark = 'DARK',
  Light = 'LIGHT'
}

export type SupportArticleContentWithMetaData = {
  __typename?: 'SupportArticleContentWithMetaData';
  faqCategory: SupportArticleFaqCategory;
  html: Scalars['String']['output'];
};

export type SupportArticleFaqCategory = {
  __typename?: 'SupportArticleFAQCategory';
  faqCategories?: Maybe<Array<Maybe<SupportArticleFaqCategory>>>;
  faqCategory?: Maybe<SupportArticleFaqCategory>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export enum SupportArticleFeedbackPlatform {
  Mobile = 'MOBILE',
  Unknown = 'UNKNOWN',
  Web = 'WEB'
}

export type SupportArticleFeedbackRequest = {
  accountNumber: Scalars['String']['input'];
  channel: SupportArticleFeedbackPlatform;
  feedback: Feedback;
  freetext?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  submittedTime: Scalars['String']['input'];
};

export type SupportArticleFilterInput = {
  faqCategoryID?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  suggested?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SupportArticleInfo = {
  __typename?: 'SupportArticleInfo';
  faqCategory: SupportArticleFaqCategory;
  id: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type SupportArticleWithMetaData = {
  __typename?: 'SupportArticleWithMetaData';
  content?: Maybe<SupportArticleContentWithMetaData>;
  hideFeedback?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  intent?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SupportArticleWithMetaDataContentArgs = {
  platform: SupportArticlesPlatform;
  theme: SupportArticleContentTheme;
};

export enum SupportArticlesPlatform {
  Mobile = 'MOBILE',
  Web = 'WEB'
}

export type SupportLiveChatAvailability = {
  __typename?: 'SupportLiveChatAvailability';
  mobile: Scalars['Boolean']['output'];
  web: Scalars['Boolean']['output'];
};

export type SupportPhoneNumbers = {
  __typename?: 'SupportPhoneNumbers';
  memberServices: Scalars['String']['output'];
  noIDV: Scalars['String']['output'];
};

export type SupportQueries = {
  __typename?: 'SupportQueries';
  phoneNumbers?: Maybe<SupportPhoneNumbers>;
};

export type SupportRequestCustomerInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SupportRequestEmailAttachmentReferenceInput = {
  fileName: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
  reference: Scalars['String']['input'];
};

export type SupportRequestEmailSubjectInput = {
  label: Scalars['String']['input'];
};

export type SupportRequestEmailTopicInput = {
  allowAttachments: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type SupportRequestLink = {
  __typename?: 'SupportRequestLink';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SupportRequestSubject = {
  __typename?: 'SupportRequestSubject';
  backofficeEmailAddress?: Maybe<Scalars['String']['output']>;
  /** @deprecated Added temporarily for the sake of migration within the mobile app. */
  id?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  links: Array<SupportRequestLink>;
  prioritiseCalling: Scalars['Boolean']['output'];
};

export type SupportRequestTopic = {
  __typename?: 'SupportRequestTopic';
  allowEmailAttachments: Scalars['Boolean']['output'];
  backofficeEmailAddress?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  subjects: Array<SupportRequestSubject>;
};

export type TargetedFiles = {
  __typename?: 'TargetedFiles';
  audienceSize: Scalars['Int']['output'];
  imageFile: ImageFile;
  textFile: TextFile;
};

export type TariffEffectiveDates = {
  __typename?: 'TariffEffectiveDates';
  effectiveFromDate?: Maybe<Scalars['DateTime']['output']>;
  effectiveToDate?: Maybe<Scalars['DateTime']['output']>;
};

export type TextFile = {
  __typename?: 'TextFile';
  fileContents: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  uploadedAt: Scalars['Int']['output'];
};

export type Ticket = {
  __typename?: 'Ticket';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notes: Array<TicketNote>;
  status: TicketStatus;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TicketConnection = {
  __typename?: 'TicketConnection';
  edges: Array<TicketEdge>;
  pageInfo: PageInfo;
  totalClosed: Scalars['Int']['output'];
  totalOpen: Scalars['Int']['output'];
};

export type TicketEdge = {
  __typename?: 'TicketEdge';
  node: Ticket;
};

export type TicketNote = {
  __typename?: 'TicketNote';
  createdAt: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
};

export enum TicketStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

/**
 * A calendar-day window with hour-precision start and end. Used for things
 * like appointment slots. Hours are 24h format (0-23).
 */
export type TimeSlot = {
  __typename?: 'TimeSlot';
  date: Scalars['DateTime']['output'];
  endHour: Scalars['Int']['output'];
  startHour: Scalars['Int']['output'];
};

export type TimeSlotInput = {
  date: Scalars['DateTime']['input'];
  endHour: Scalars['Int']['input'];
  startHour: Scalars['Int']['input'];
};

/** Issuers can add custom claims to a token, such as customer SCA. */
export type TokenCustomClaim = {
  __typename?: 'TokenCustomClaim';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Details about the provided token.
 * Not all details are guareenteed to be available due to how legacy authentication
 * providers currently work.
 * This is provided to aid backwards compatibility as well as use-cases
 * such as token renewal.
 */
export type TokenDetails = {
  __typename?: 'TokenDetails';
  audience: Array<Scalars['String']['output']>;
  customClaims: Array<TokenCustomClaim>;
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  issuedAt?: Maybe<Scalars['Time']['output']>;
  issuer?: Maybe<Scalars['String']['output']>;
  issuingDomain?: Maybe<IssuingDomain>;
  scopes: Array<Scalars['String']['output']>;
};

export type TrackCustomerResult = {
  __typename?: 'TrackCustomerResult';
  success: Scalars['Boolean']['output'];
};

export type TrackingEvent = {
  name: TrackingEventName;
  origin: TrackingEventOrigin;
};

export enum TrackingEventName {
  FeedbackModalViewed = 'FEEDBACK_MODAL_VIEWED',
  HomeMoveWelcomeSeen = 'HOME_MOVE_WELCOME_SEEN'
}

export enum TrackingEventOrigin {
  MyAccount = 'MY_ACCOUNT'
}

export type Url = {
  __typename?: 'URL';
  caption?: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
};

export type UpsertCitizenConsentInput = {
  /** The UW account Id. */
  accountId: Scalars['ID']['input'];
  /** A list of consent decisions being recorded. The DataGuard preference ID (e.g., 'preference.all'). */
  consentSubmissions: Array<Preference>;
  /** Identifies who or what system triggered this consent submission. */
  submittedBy: Scalars['String']['input'];
};

export type UpsertCitizenConsentPayload = {
  __typename?: 'UpsertCitizenConsentPayload';
  /** Providing the updated account/consent object allows for immediate UI updates. */
  account: Account;
  /** A description of what actions were taken (e.g. 'CREATED', 'UPDATED'). */
  changes: Scalars['String']['output'];
};

export type UpsertCitizenPreferenceInput = {
  /** The UW account Id. */
  accountId: Scalars['ID']['input'];
  /** A list of preference choices by a citizen. */
  preferenceSubmissions: Array<PreferenceSubmissionInput>;
};

export type UpsertCitizenPreferencePayload = {
  __typename?: 'UpsertCitizenPreferencePayload';
  /** Providing the updated account/consent object allows for immediate UI updates. */
  account: Account;
};

/** UserPrincipal is an end user usig one of our applications. */
export type UserPrincipal = {
  __typename?: 'UserPrincipal';
  /**
   * Information extracted from the authenticating token related to the customer.
   * Even when we have a unified authentication process for users, this field
   * may always be null when the user is not a customer.
   */
  customer?: Maybe<CustomerPrincipal>;
  /** Is the authenticated user a customer. */
  isCustomer: Scalars['Boolean']['output'];
  /** Is the authenticated user a partner. */
  isPartner: Scalars['Boolean']['output'];
  /**
   * Information extracted from the authenticating token related to the partner.
   * Even when we have a unified authentication process for users, this field
   * may always be null when the user is not a partner.
   */
  partner?: Maybe<PartnerPrincipal>;
};

export type ValidateDirectDebitResult = {
  __typename?: 'ValidateDirectDebitResult';
  reason?: Maybe<DirectDebitValidationReason>;
  valid: Scalars['Boolean']['output'];
};

export type ValidateMoveInResult = {
  __typename?: 'ValidateMoveInResult';
  expectedMoveInDate?: Maybe<Scalars['String']['output']>;
  status: ValidateMoveInStatus;
  success: Scalars['Boolean']['output'];
};

export enum ValidateMoveInStatus {
  ValidateMoveInStatusAttemptFailed = 'VALIDATE_MOVE_IN_STATUS_ATTEMPT_FAILED',
  ValidateMoveInStatusDateAcceptable = 'VALIDATE_MOVE_IN_STATUS_DATE_ACCEPTABLE',
  ValidateMoveInStatusDateExpected = 'VALIDATE_MOVE_IN_STATUS_DATE_EXPECTED',
  ValidateMoveInStatusDateUnacceptable = 'VALIDATE_MOVE_IN_STATUS_DATE_UNACCEPTABLE',
  ValidateMoveInStatusExpired = 'VALIDATE_MOVE_IN_STATUS_EXPIRED',
  ValidateMoveInStatusUndefined = 'VALIDATE_MOVE_IN_STATUS_UNDEFINED'
}

export enum ValidationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Succeeded = 'SUCCEEDED',
  Unknown = 'UNKNOWN'
}

export type VerifyAccountPostcodeResult = {
  __typename?: 'VerifyAccountPostcodeResult';
  status: VerifyAccountPostcodeStatus;
};

export enum VerifyAccountPostcodeStatus {
  /** The account number and postcode do not match. Or the account already has an email address. */
  InvalidDetails = 'INVALID_DETAILS',
  /** The account number and postcode match an account. */
  Success = 'SUCCESS'
}

export type VerifyCardPaymentMethodInput = {
  accountReference: Scalars['String']['input'];
  browserInfo: Scalars['String']['input'];
  externalPaymentMethodToken: Scalars['String']['input'];
  ip: Scalars['String']['input'];
  paymentToken: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};

export type WebChatContactChannel = {
  __typename?: 'WebChatContactChannel';
  calloutBanner?: Maybe<CalloutBanner>;
  estimatedWaitTime?: Maybe<Scalars['Int']['output']>;
  queueId?: Maybe<Scalars['String']['output']>;
  queue_name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ChannelStatus>;
};

/** WhoAmI gives details about the current authenticated token. */
export type WhoAmI = {
  __typename?: 'WhoAmI';
  /**
   * Principal is the authenticated actor.
   * The principal is extracted from the HTTP header `Authorization: Bearer {token}`.
   */
  principal: Principal;
  /** Details about the token supplied in the request. */
  token: TokenDetails;
};

export type Continue3DsInput = {
  accountReference?: InputMaybe<Scalars['String']['input']>;
  paymentToken: Scalars['String']['input'];
};

export type Continue3DsResponse = {
  __typename?: 'continue3DSResponse';
  success: Scalars['Boolean']['output'];
};

export type GetPayment = {
  paymentToken: Scalars['String']['input'];
};

export type GetPaymentResponse = {
  __typename?: 'getPaymentResponse';
  integrationProfile: IntegrationProfile;
  payment: Payment;
};

export type EnergyServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type EnergyServicesQuery = { __typename?: 'Query', account?: { __typename?: 'Account', energy?: { __typename?: 'AccountEnergy', services: Array<{ __typename?: 'EnergyService', serviceState: EnergyServiceState }> } | null } | null };

export type GetServiceGroupOverviewQueryVariables = Exact<{
  accountId: Scalars['String']['input'];
  serviceType: ServiceType;
}>;


export type GetServiceGroupOverviewQuery = { __typename?: 'Query', getServiceGroupOverview?: { __typename?: 'ServiceGroup', status: ServiceStatus, hasNonEndedServices: boolean, services?: Array<{ __typename?: 'ServiceOverview', name: ServiceName, status: ServiceStatus } | null> | null } | null };

export type SubmitAssessmentMutationVariables = Exact<{
  request: CustomerSupportSubmitAssessmentRequest;
}>;


export type SubmitAssessmentMutation = { __typename?: 'Mutation', customerSupport: { __typename?: 'CustomerSupportMutations', submitAssessment?: any | null } };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', whoAmI: { __typename?: 'WhoAmI', principal: { __typename: 'UserPrincipal', customer?: { __typename?: 'CustomerPrincipal', accountID: string, accountNumber: string } | null } } };


export const EnergyServicesDocument = gql`
    query energyServices {
  account {
    energy {
      services {
        serviceState
      }
    }
  }
}
    `;

/**
 * __useEnergyServicesQuery__
 *
 * To run a query within a React component, call `useEnergyServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnergyServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEnergyServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useEnergyServicesQuery(baseOptions?: Apollo.QueryHookOptions<EnergyServicesQuery, EnergyServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EnergyServicesQuery, EnergyServicesQueryVariables>(EnergyServicesDocument, options);
      }
export function useEnergyServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EnergyServicesQuery, EnergyServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EnergyServicesQuery, EnergyServicesQueryVariables>(EnergyServicesDocument, options);
        }
export function useEnergyServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EnergyServicesQuery, EnergyServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EnergyServicesQuery, EnergyServicesQueryVariables>(EnergyServicesDocument, options);
        }
export type EnergyServicesQueryHookResult = ReturnType<typeof useEnergyServicesQuery>;
export type EnergyServicesLazyQueryHookResult = ReturnType<typeof useEnergyServicesLazyQuery>;
export type EnergyServicesSuspenseQueryHookResult = ReturnType<typeof useEnergyServicesSuspenseQuery>;
export type EnergyServicesQueryResult = Apollo.QueryResult<EnergyServicesQuery, EnergyServicesQueryVariables>;
export const GetServiceGroupOverviewDocument = gql`
    query getServiceGroupOverview($accountId: String!, $serviceType: ServiceType!) {
  getServiceGroupOverview(accountID: $accountId, serviceType: $serviceType) {
    status
    hasNonEndedServices
    services {
      name
      status
    }
  }
}
    `;

/**
 * __useGetServiceGroupOverviewQuery__
 *
 * To run a query within a React component, call `useGetServiceGroupOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceGroupOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceGroupOverviewQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      serviceType: // value for 'serviceType'
 *   },
 * });
 */
export function useGetServiceGroupOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables> & ({ variables: GetServiceGroupOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables>(GetServiceGroupOverviewDocument, options);
      }
export function useGetServiceGroupOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables>(GetServiceGroupOverviewDocument, options);
        }
export function useGetServiceGroupOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables>(GetServiceGroupOverviewDocument, options);
        }
export type GetServiceGroupOverviewQueryHookResult = ReturnType<typeof useGetServiceGroupOverviewQuery>;
export type GetServiceGroupOverviewLazyQueryHookResult = ReturnType<typeof useGetServiceGroupOverviewLazyQuery>;
export type GetServiceGroupOverviewSuspenseQueryHookResult = ReturnType<typeof useGetServiceGroupOverviewSuspenseQuery>;
export type GetServiceGroupOverviewQueryResult = Apollo.QueryResult<GetServiceGroupOverviewQuery, GetServiceGroupOverviewQueryVariables>;
export const SubmitAssessmentDocument = gql`
    mutation submitAssessment($request: CustomerSupportSubmitAssessmentRequest!) {
  customerSupport {
    submitAssessment(request: $request)
  }
}
    `;
export type SubmitAssessmentMutationFn = Apollo.MutationFunction<SubmitAssessmentMutation, SubmitAssessmentMutationVariables>;

/**
 * __useSubmitAssessmentMutation__
 *
 * To run a mutation, you first call `useSubmitAssessmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAssessmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAssessmentMutation, { data, loading, error }] = useSubmitAssessmentMutation({
 *   variables: {
 *      request: // value for 'request'
 *   },
 * });
 */
export function useSubmitAssessmentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAssessmentMutation, SubmitAssessmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAssessmentMutation, SubmitAssessmentMutationVariables>(SubmitAssessmentDocument, options);
      }
export type SubmitAssessmentMutationHookResult = ReturnType<typeof useSubmitAssessmentMutation>;
export type SubmitAssessmentMutationResult = Apollo.MutationResult<SubmitAssessmentMutation>;
export type SubmitAssessmentMutationOptions = Apollo.BaseMutationOptions<SubmitAssessmentMutation, SubmitAssessmentMutationVariables>;
export const WhoAmIDocument = gql`
    query whoAmI {
  whoAmI {
    principal {
      ... on UserPrincipal {
        __typename
        customer {
          accountID
          accountNumber
        }
      }
    }
  }
}
    `;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export function useWhoAmISuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmISuspenseQueryHookResult = ReturnType<typeof useWhoAmISuspenseQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;